export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTimeISO: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type ActivePartnerGroupCountData = {
  __typename?: 'ActivePartnerGroupCountData';
  group_id?: Maybe<Scalars['Float']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  total_active_partner?: Maybe<Scalars['Float']['output']>;
};

export type AddBannerInput = {
  bannerHeadingDe?: InputMaybe<Scalars['String']['input']>;
  bannerHeadingEn?: InputMaybe<Scalars['String']['input']>;
  bannerMessageDe?: InputMaybe<Scalars['String']['input']>;
  bannerMessageEn?: InputMaybe<Scalars['String']['input']>;
  bannerShowEnd?: InputMaybe<Scalars['String']['input']>;
  bannerShowStart?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type AddBannerResponse = {
  __typename?: 'AddBannerResponse';
  response?: Maybe<Scalars['String']['output']>;
};

export type AddNotificationInput = {
  activeFromDate?: InputMaybe<Scalars['String']['input']>;
  activeToDate?: InputMaybe<Scalars['String']['input']>;
  entitlements?: InputMaybe<Array<Scalars['String']['input']>>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  notificationTemplateId?: InputMaybe<Scalars['String']['input']>;
  notificationTypeId?: InputMaybe<Scalars['String']['input']>;
  templateData?: InputMaybe<Scalars['String']['input']>;
};

export type AddNotificationResponse = {
  __typename?: 'AddNotificationResponse';
  response?: Maybe<Scalars['String']['output']>;
};

export type AgingBucket = {
  __typename?: 'AgingBucket';
  ageRange: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
};

export type AgreementHistory = {
  __typename?: 'AgreementHistory';
  agreementAcceptedDate?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type AgreementHistoryInputType = {
  agreementAcceptedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  agreementId?: InputMaybe<Scalars['Float']['input']>;
  companyPartnerId?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
};

export type AssignPartner = {
  partnerId?: InputMaybe<Scalars['Float']['input']>;
  roleId?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type AssignedCompany = {
  __typename?: 'AssignedCompany';
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Float']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  systemId?: Maybe<Scalars['Float']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
};

export type AssignedPartner = {
  __typename?: 'AssignedPartner';
  category?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['Float']['output']>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  systemId?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
};

export type B2xRoles = {
  __typename?: 'B2xRoles';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  updateAction?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  userB2xrole?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type B2xRolesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  phraseId?: InputMaybe<Scalars['String']['input']>;
  updateAction?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
  userB2xrole?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export type BannerAllResponse = {
  __typename?: 'BannerAllResponse';
  bannerHeadingDe?: Maybe<Scalars['String']['output']>;
  bannerHeadingEn?: Maybe<Scalars['String']['output']>;
  bannerId?: Maybe<Scalars['Float']['output']>;
  bannerMessageDe?: Maybe<Scalars['String']['output']>;
  bannerMessageEn?: Maybe<Scalars['String']['output']>;
  bannerShowEnd?: Maybe<Scalars['String']['output']>;
  bannerShowStart?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type BannerDetailsResponse = {
  __typename?: 'BannerDetailsResponse';
  bannerHeadingDe?: Maybe<Scalars['String']['output']>;
  bannerHeadingEn?: Maybe<Scalars['String']['output']>;
  bannerMessageDe?: Maybe<Scalars['String']['output']>;
  bannerMessageEn?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  messageType?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
};

export type BannerEditRequest = {
  bannerHeadingDe?: InputMaybe<Scalars['String']['input']>;
  bannerHeadingEn?: InputMaybe<Scalars['String']['input']>;
  bannerId?: InputMaybe<Scalars['Float']['input']>;
  bannerMessageDe?: InputMaybe<Scalars['String']['input']>;
  bannerMessageEn?: InputMaybe<Scalars['String']['input']>;
  bannerShowEnd?: InputMaybe<Scalars['String']['input']>;
  bannerShowStart?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type BlobDeleteResult = {
  __typename?: 'BlobDeleteResult';
  blobId: Scalars['Float']['output'];
  status: Scalars['Float']['output'];
};

export type BlobFileInput = {
  base64FileData?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  requiresAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  rolesAllowed?: InputMaybe<Scalars['String']['input']>;
};

export type BlobInfo = {
  blobId: Scalars['Float']['input'];
  documentId: Scalars['Float']['input'];
  insertUser?: InputMaybe<Scalars['String']['input']>;
};

export type BorderoEdpData = {
  __typename?: 'BorderoEdpData';
  borderoDate?: Maybe<Scalars['String']['output']>;
  borderoIdentifier?: Maybe<Scalars['String']['output']>;
  borderoNumber?: Maybe<Scalars['String']['output']>;
  borderoPosition?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  carrierNumber?: Maybe<Scalars['String']['output']>;
  consignee?: Maybe<Scalars['String']['output']>;
  consignor?: Maybe<Scalars['String']['output']>;
  countPosition?: Maybe<Scalars['Float']['output']>;
  fsdNumber?: Maybe<Scalars['String']['output']>;
  goodsCategory?: Maybe<Scalars['String']['output']>;
  loadNumber?: Maybe<Scalars['String']['output']>;
  orderArea?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type BorderoEdpFilter = {
  borderoNumber?: InputMaybe<Scalars['String']['input']>;
  carrierNumber?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateUntil?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<BorderoEdpStatus>>;
};

export enum BorderoEdpStatus {
  Billed = 'BILLED',
  DocumentReceived = 'DOCUMENT_RECEIVED',
  DocumentRequested = 'DOCUMENT_REQUESTED',
  InCorrection = 'IN_CORRECTION',
  InProgress = 'IN_PROGRESS',
  InSettlement = 'IN_SETTLEMENT',
  Ok = 'OK'
}

export type BorderoUploadDocument = {
  __typename?: 'BorderoUploadDocument';
  borderoDate?: Maybe<Scalars['String']['output']>;
  borderoIdentifier?: Maybe<Scalars['String']['output']>;
  borderoNumber?: Maybe<Scalars['String']['output']>;
  borderoPosition?: Maybe<Scalars['String']['output']>;
  carrierNumber?: Maybe<Scalars['String']['output']>;
  consignee?: Maybe<Scalars['String']['output']>;
  consignor?: Maybe<Scalars['String']['output']>;
  goodsCategory?: Maybe<Scalars['String']['output']>;
  loadNumber?: Maybe<Scalars['String']['output']>;
  orderArea?: Maybe<Scalars['String']['output']>;
  relation?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type BorderoUploadDocumentsQueryInput = {
  borderoNumber?: InputMaybe<Scalars['String']['input']>;
  carrierNumber?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateUntil?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<BorderoEdpStatus>>;
};

export type BusinessArea = {
  __typename?: 'BusinessArea';
  businessAreaCode?: Maybe<Scalars['String']['output']>;
  businessAreaName?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  id?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type BusinessUnit = {
  __typename?: 'BusinessUnit';
  businessArea?: Maybe<BusinessArea>;
  businessUnitCode?: Maybe<Scalars['String']['output']>;
  businessUnitName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type CfoCountryBreakdown = {
  __typename?: 'CFOCountryBreakdown';
  country?: Maybe<Scalars['String']['output']>;
  invoiceCount?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type CfoCurrencyBreakdown = {
  __typename?: 'CFOCurrencyBreakdown';
  currency?: Maybe<Scalars['String']['output']>;
  currentAmount?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  percentageChange?: Maybe<Scalars['Float']['output']>;
  previousAmount?: Maybe<Scalars['Float']['output']>;
};

export type CfoErrorReason = {
  __typename?: 'CFOErrorReason';
  count?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type CfokpiMetric = {
  __typename?: 'CFOKPIMetric';
  delta?: Maybe<Scalars['Float']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  percentageChange?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type CfoReportingResponse = {
  __typename?: 'CFOReportingResponse';
  countryBreakdown?: Maybe<Array<CfoCountryBreakdown>>;
  currencyBreakdown?: Maybe<Array<CfoCurrencyBreakdown>>;
  errorRate?: Maybe<CfokpiMetric>;
  rejectedByRecipientEstimate?: Maybe<Scalars['Float']['output']>;
  statusBreakdown?: Maybe<Array<CfoStatusBreakdown>>;
  successRate?: Maybe<CfokpiMetric>;
  timeTrend?: Maybe<Array<CfoTimeTrendData>>;
  topErrorReasons?: Maybe<Array<CfoErrorReason>>;
  totalAmount?: Maybe<CfokpiMetric>;
  totalInvoices?: Maybe<CfokpiMetric>;
};

export type CfoStatusBreakdown = {
  __typename?: 'CFOStatusBreakdown';
  count?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CfoTimeTrendData = {
  __typename?: 'CFOTimeTrendData';
  date?: Maybe<Scalars['String']['output']>;
  invoiceCount?: Maybe<Scalars['Float']['output']>;
  previousInvoiceCount?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type Cr1Filter = {
  compcode: Array<Scalars['String']['input']>;
  grscdate: Scalars['String']['input'];
  language: Scalars['String']['input'];
  partnerno: Array<Scalars['String']['input']>;
};

export type Cr1PdfRequest = {
  blobId?: InputMaybe<Scalars['Float']['input']>;
  boardMemberName?: InputMaybe<Scalars['String']['input']>;
  companyCode?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  deliveryNoteDate?: InputMaybe<Scalars['String']['input']>;
  deliveryNoteNumber?: InputMaybe<Scalars['String']['input']>;
  documentCreated?: InputMaybe<Scalars['Boolean']['input']>;
  documentCreationDate?: InputMaybe<Scalars['String']['input']>;
  gjahr?: InputMaybe<Scalars['String']['input']>;
  grQuantity?: InputMaybe<Scalars['String']['input']>;
  grScDate?: InputMaybe<Scalars['String']['input']>;
  grScItem?: InputMaybe<Scalars['String']['input']>;
  grUnit?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  lfCity?: InputMaybe<Scalars['String']['input']>;
  lfCountry?: InputMaybe<Scalars['String']['input']>;
  lfPostalCode?: InputMaybe<Scalars['String']['input']>;
  lfStreet?: InputMaybe<Scalars['String']['input']>;
  llCity?: InputMaybe<Scalars['String']['input']>;
  llCountry?: InputMaybe<Scalars['String']['input']>;
  llPostalCode?: InputMaybe<Scalars['String']['input']>;
  llStreet?: InputMaybe<Scalars['String']['input']>;
  logsys?: InputMaybe<Scalars['String']['input']>;
  materialDescription?: InputMaybe<Scalars['String']['input']>;
  materialDocNumber?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  maxrows?: InputMaybe<Scalars['Float']['input']>;
  partnerLl?: InputMaybe<Scalars['String']['input']>;
  partnerLlName?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  partnerNumber?: InputMaybe<Scalars['String']['input']>;
  plantAddress?: InputMaybe<Scalars['String']['input']>;
  plantCode?: InputMaybe<Scalars['String']['input']>;
  plantName?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Array<Cr1PositionInput>>;
  vatNr?: InputMaybe<Scalars['String']['input']>;
  yearMonth?: InputMaybe<Scalars['String']['input']>;
};

export type Cr1Position = {
  __typename?: 'CR1Position';
  boardMemberName?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  deliveryNote?: Maybe<Scalars['String']['output']>;
  deliveryNoteDate?: Maybe<Scalars['String']['output']>;
  gjahr?: Maybe<Scalars['String']['output']>;
  grQty?: Maybe<Scalars['Float']['output']>;
  grScDate?: Maybe<Scalars['String']['output']>;
  grScItem?: Maybe<Scalars['String']['output']>;
  grUnit?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  materialDoc?: Maybe<Scalars['String']['output']>;
  materialText?: Maybe<Scalars['String']['output']>;
  plant?: Maybe<Scalars['String']['output']>;
  plantAddress?: Maybe<Scalars['String']['output']>;
  plantName?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  pos?: Maybe<Scalars['Float']['output']>;
};

export type Cr1PositionInput = {
  boardMemberName?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  deliveryNote?: InputMaybe<Scalars['String']['input']>;
  deliveryNoteDate?: InputMaybe<Scalars['String']['input']>;
  gjahr?: InputMaybe<Scalars['String']['input']>;
  grQty?: InputMaybe<Scalars['Float']['input']>;
  grScDate?: InputMaybe<Scalars['String']['input']>;
  grScItem?: InputMaybe<Scalars['String']['input']>;
  grUnit?: InputMaybe<Scalars['String']['input']>;
  logsys?: InputMaybe<Scalars['String']['input']>;
  material?: InputMaybe<Scalars['String']['input']>;
  materialDoc?: InputMaybe<Scalars['String']['input']>;
  materialText?: InputMaybe<Scalars['String']['input']>;
  plant?: InputMaybe<Scalars['String']['input']>;
  plantAddress?: InputMaybe<Scalars['String']['input']>;
  plantName?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  pos?: InputMaybe<Scalars['Float']['input']>;
};

export type Cr1Response = {
  __typename?: 'CR1Response';
  blobId?: Maybe<Scalars['Float']['output']>;
  boardMemberName?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  deliveryNoteDate?: Maybe<Scalars['String']['output']>;
  deliveryNoteNumber?: Maybe<Scalars['String']['output']>;
  documentCreated?: Maybe<Scalars['Boolean']['output']>;
  documentCreationDate?: Maybe<Scalars['String']['output']>;
  gjahr?: Maybe<Scalars['String']['output']>;
  grQuantity?: Maybe<Scalars['String']['output']>;
  grScDate?: Maybe<Scalars['String']['output']>;
  grScItem?: Maybe<Scalars['String']['output']>;
  grUnit?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lfCity?: Maybe<Scalars['String']['output']>;
  lfCountry?: Maybe<Scalars['String']['output']>;
  lfPostalCode?: Maybe<Scalars['String']['output']>;
  lfStreet?: Maybe<Scalars['String']['output']>;
  llCity?: Maybe<Scalars['String']['output']>;
  llCountry?: Maybe<Scalars['String']['output']>;
  llPostalCode?: Maybe<Scalars['String']['output']>;
  llStreet?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  materialDescription?: Maybe<Scalars['String']['output']>;
  materialDocNumber?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  maxrows?: Maybe<Scalars['Float']['output']>;
  partnerLl?: Maybe<Scalars['String']['output']>;
  partnerLlName?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  plantAddress?: Maybe<Scalars['String']['output']>;
  plantCode?: Maybe<Scalars['String']['output']>;
  plantName?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Cr1Position>>;
  vatNr?: Maybe<Scalars['String']['output']>;
  yearMonth?: Maybe<Scalars['String']['output']>;
};

export type CzGenericFilter = {
  bmwdocno?: InputMaybe<OpValue>;
  compcode?: InputMaybe<Array<Scalars['String']['input']>>;
  czinvoicestatus?: InputMaybe<Array<Scalars['String']['input']>>;
  deliverynote?: InputMaybe<OpValue>;
  documentdateFrom?: InputMaybe<Scalars['String']['input']>;
  documentdateUntil?: InputMaybe<Scalars['String']['input']>;
  documenttype?: InputMaybe<Array<Scalars['String']['input']>>;
  fapiaono?: InputMaybe<OpValue>;
  grdateFrom?: InputMaybe<Scalars['String']['input']>;
  grdateUntil?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  logic?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Array<Scalars['String']['input']>>;
  plantcode?: InputMaybe<Array<Scalars['String']['input']>>;
  ponumber?: InputMaybe<OpValue>;
  supplierclaimno?: InputMaybe<OpValue>;
};

export type CzLineItem = {
  __typename?: 'CZLineItem';
  amount?: Maybe<Scalars['Float']['output']>;
  bmwdocno?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliverynoteno?: Maybe<Scalars['String']['output']>;
  grdate?: Maybe<Scalars['String']['output']>;
  headId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  materialtext?: Maybe<Scalars['String']['output']>;
  materialtextzh?: Maybe<Scalars['String']['output']>;
  plantname?: Maybe<Scalars['String']['output']>;
  poitem?: Maybe<Scalars['String']['output']>;
  ponumber?: Maybe<Scalars['String']['output']>;
  pounit?: Maybe<Scalars['String']['output']>;
  pounitprice?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  reitem?: Maybe<Scalars['String']['output']>;
  supplierclaim?: Maybe<Scalars['String']['output']>;
};

export type CzResponse = {
  __typename?: 'CZResponse';
  bmwdocno?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  czcompcode?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  documentdate?: Maybe<Scalars['String']['output']>;
  fapiaono?: Maybe<Scalars['String']['output']>;
  fiscalyear?: Maybe<Scalars['String']['output']>;
  grossamount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoicestatus?: Maybe<Scalars['String']['output']>;
  invpostdate?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  maxrows?: Maybe<Scalars['Float']['output']>;
  origfapiaono?: Maybe<Scalars['String']['output']>;
  originvoiceno?: Maybe<Scalars['String']['output']>;
  originvoiceyear?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<CzLineItem>>;
  revdocno?: Maybe<Scalars['String']['output']>;
  revstattxt?: Maybe<Scalars['String']['output']>;
};

export type ChannelFormat = {
  __typename?: 'ChannelFormat';
  channelName?: Maybe<Scalars['String']['output']>;
  defaultAlternative?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
};

export type ChannelMetricsSummary = {
  __typename?: 'ChannelMetricsSummary';
  channel: Scalars['String']['output'];
  coverage: CoverageMetricsSummary;
  exceptions: ExceptionMetricsSummary;
  intake: IntakeMetricsSummary;
  processing: ProcessingMetricsSummary;
};

export type ChannelType = {
  __typename?: 'ChannelType';
  channelDescription?: Maybe<Scalars['String']['output']>;
  channelType?: Maybe<Scalars['String']['output']>;
  channelTypeId?: Maybe<Scalars['Float']['output']>;
  incomingChannel?: Maybe<Scalars['Boolean']['output']>;
  incomingId?: Maybe<Scalars['Float']['output']>;
  outgoingChannel?: Maybe<Scalars['Boolean']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  processCodeId?: Maybe<Scalars['Float']['output']>;
};

export type CommissionFilterInput = {
  alphabetFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  compCode?: InputMaybe<Array<Scalars['String']['input']>>;
  documentDateFrom?: InputMaybe<Scalars['String']['input']>;
  documentDateUntil?: InputMaybe<Scalars['String']['input']>;
  documentNumber?: InputMaybe<OpValue>;
  language?: InputMaybe<Scalars['String']['input']>;
  partnerNo?: InputMaybe<Array<Scalars['String']['input']>>;
  vinNumber?: InputMaybe<OpValue>;
};

export type CommissionHeader = {
  __typename?: 'CommissionHeader';
  alphabet?: Maybe<Scalars['String']['output']>;
  baseValue?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  commissionType?: Maybe<Scalars['String']['output']>;
  compCode?: Maybe<Scalars['String']['output']>;
  compName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dealerNR?: Maybe<Scalars['String']['output']>;
  dealerName?: Maybe<Scalars['String']['output']>;
  documentDate?: Maybe<Scalars['String']['output']>;
  documentNR?: Maybe<Scalars['String']['output']>;
  grossValuePaid?: Maybe<Scalars['String']['output']>;
  handOverDate?: Maybe<Scalars['String']['output']>;
  itemNr?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  modelCode?: Maybe<Scalars['String']['output']>;
  netValuePaid?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  salesCategory?: Maybe<Scalars['String']['output']>;
  salesPartner?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
  vinNumber?: Maybe<Scalars['String']['output']>;
};

export type Company = {
  __typename?: 'Company';
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
};

export type CompanyAddress = {
  __typename?: 'CompanyAddress';
  AddressTypeCode?: Maybe<Scalars['String']['output']>;
  addressType?: Maybe<Scalars['String']['output']>;
  addressTypePhraseId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyAddressId?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  poBox?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export type CompanyDefaultTaxId = {
  __typename?: 'CompanyDefaultTaxId';
  companyCode?: Maybe<Company>;
  companyTaxDefaultId?: Maybe<Scalars['Float']['output']>;
  countryCode?: Maybe<CountryCode>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  ceo?: Maybe<Scalars['String']['output']>;
  chairman?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyInfoId?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyNameAddon?: Maybe<Scalars['String']['output']>;
  companyNameShort?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['Float']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  management?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  registerCourt?: Maybe<Scalars['String']['output']>;
  registerCourtShort?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  systemId?: Maybe<Scalars['Float']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyPartner = {
  __typename?: 'CompanyPartner';
  category?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['Float']['output']>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  systemCompanyId?: Maybe<Scalars['Float']['output']>;
  systemId?: Maybe<Scalars['Float']['output']>;
};

export type CompanyProcessingCodeRecordsInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  companyProcessId?: InputMaybe<Scalars['Float']['input']>;
  processCode?: InputMaybe<Scalars['String']['input']>;
  processCodeId?: InputMaybe<Scalars['Float']['input']>;
  sysId?: InputMaybe<Scalars['String']['input']>;
  systemCompanyId?: InputMaybe<Scalars['Float']['input']>;
};

export type CopySurveyRequest = {
  listSurveyCreateRequest: Array<SurveyCreateRequest>;
  masterSurveyId: Scalars['Float']['input'];
};

export type CountryCode = {
  __typename?: 'CountryCode';
  country?: Maybe<Scalars['String']['output']>;
  defaultCurrencyCode?: Maybe<CurrencyCode>;
  id: Scalars['ID']['output'];
  isEuMemberState?: Maybe<Scalars['Boolean']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
};

export type CountryMetricsSummary = {
  __typename?: 'CountryMetricsSummary';
  companyCode: Scalars['String']['output'];
  country: Scalars['String']['output'];
  coverage: CoverageMetricsSummary;
  exceptions: ExceptionMetricsSummary;
  intake: IntakeMetricsSummary;
  processing: ProcessingMetricsSummary;
};

export type CoverageMetricsSummary = {
  __typename?: 'CoverageMetricsSummary';
  activePartners: Scalars['Int']['output'];
  coverageRate: Scalars['Float']['output'];
  totalPartners: Scalars['Int']['output'];
};

export type CoverageSectionMetrics = {
  __typename?: 'CoverageSectionMetrics';
  activePartners: Scalars['Int']['output'];
  coverageDelta: Scalars['Float']['output'];
  coverageRate: Scalars['Float']['output'];
  coverageTarget: Scalars['Float']['output'];
  coverageThreshold: Scalars['Float']['output'];
  coverageTrendByMonth: Array<CoverageTrendPoint>;
  monthlyNewPartners: Scalars['Int']['output'];
  previousCoverageRate: Scalars['Float']['output'];
  topImpactedGroups: Array<TopImpactedGroup>;
  totalPartners: Scalars['Int']['output'];
};

export type CoverageTrendPoint = {
  __typename?: 'CoverageTrendPoint';
  activePartnerCount: Scalars['Int']['output'];
  coverageRate: Scalars['Float']['output'];
  month: Scalars['String']['output'];
};

export type CurrencyCode = {
  __typename?: 'CurrencyCode';
  currencyName?: Maybe<Scalars['String']['output']>;
  currencySymbol?: Maybe<Scalars['String']['output']>;
  decimalPlaces?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  phraseId?: Maybe<Scalars['String']['output']>;
};

export type CurrentInvoiceStatus = {
  objectId: Scalars['Float']['input'];
  status: Scalars['String']['input'];
  step_number: Scalars['Float']['input'];
};

export type DashboardAppliedFilters = {
  __typename?: 'DashboardAppliedFilters';
  partnerGroup?: Maybe<Scalars['String']['output']>;
  periodEnd: Scalars['DateTimeISO']['output'];
  periodStart: Scalars['DateTimeISO']['output'];
  processType?: Maybe<Scalars['String']['output']>;
};

export type DashboardMetadata = {
  __typename?: 'DashboardMetadata';
  appliedFilters: DashboardAppliedFilters;
  compositeHealthScore?: Maybe<Scalars['Float']['output']>;
  dataAsOf: Scalars['DateTimeISO']['output'];
  healthScoreLabel?: Maybe<Scalars['String']['output']>;
  lastRefresh: Scalars['DateTimeISO']['output'];
};

export type DataModel = {
  filterModel?: InputMaybe<Scalars['String']['input']>;
  sortModel?: InputMaybe<Array<SortModel>>;
};

export type DeleteBannerResponse = {
  __typename?: 'DeleteBannerResponse';
  response?: Maybe<Scalars['String']['output']>;
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  statusCode: Scalars['Float']['output'];
};

export type DisplayPreference = {
  __typename?: 'DisplayPreference';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

export type DocList = {
  __typename?: 'DocList';
  attachment?: Maybe<Scalars['String']['output']>;
  blobId?: Maybe<Scalars['Float']['output']>;
  bmwCompany?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  documentDate?: Maybe<Scalars['String']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  downloaded?: Maybe<Scalars['String']['output']>;
  duplicate?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  externalDocumentNumber?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  receptionDate?: Maybe<Scalars['String']['output']>;
  sdiNumber?: Maybe<Scalars['String']['output']>;
  shipPartnerNo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusPhraseId?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  vinNumber?: Maybe<Scalars['String']['output']>;
};

export type DocListInput = {
  attachment?: InputMaybe<Scalars['Float']['input']>;
  bmwCompanyId?: InputMaybe<Scalars['Float']['input']>;
  bmwCompanyIdList?: InputMaybe<Array<Scalars['Float']['input']>>;
  documentDateFrom?: InputMaybe<Scalars['String']['input']>;
  documentDateTo?: InputMaybe<Scalars['String']['input']>;
  documentNumbers?: InputMaybe<Scalars['String']['input']>;
  documentTypeId?: InputMaybe<Scalars['Float']['input']>;
  downloaded?: InputMaybe<Scalars['Float']['input']>;
  externalDocumentNumbers?: InputMaybe<Scalars['String']['input']>;
  formatId?: InputMaybe<Scalars['Float']['input']>;
  partnerId?: InputMaybe<Scalars['Float']['input']>;
  partnerNo?: InputMaybe<Scalars['String']['input']>;
  partnerNoList?: InputMaybe<Array<Scalars['String']['input']>>;
  processCodeId?: InputMaybe<Scalars['Float']['input']>;
  receptionDateFrom?: InputMaybe<Scalars['String']['input']>;
  receptionDateTo?: InputMaybe<Scalars['String']['input']>;
  shipPartnerNo?: InputMaybe<Scalars['String']['input']>;
  showDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  statusId?: InputMaybe<Scalars['Float']['input']>;
  vinNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Document = {
  __typename?: 'Document';
  amount?: Maybe<Scalars['Float']['output']>;
  area?: Maybe<Scalars['String']['output']>;
  azContainerName?: Maybe<Scalars['String']['output']>;
  azDownloadFileName?: Maybe<Scalars['String']['output']>;
  azItemPathName?: Maybe<Scalars['String']['output']>;
  azStorageType?: Maybe<Scalars['String']['output']>;
  blobId?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dateReceived?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['Float']['output']>;
  downloadLink?: Maybe<Scalars['String']['output']>;
  downloaded?: Maybe<Scalars['Float']['output']>;
  insertTs?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  updatetime?: Maybe<Scalars['String']['output']>;
};

export type DocumentCount = {
  __typename?: 'DocumentCount';
  count: Scalars['Float']['output'];
};

export type DocumentDownload = {
  __typename?: 'DocumentDownload';
  documentId?: Maybe<Scalars['Float']['output']>;
  documentLink?: Maybe<Scalars['String']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  documentPath?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type DocumentDownloadInput = {
  blobId?: InputMaybe<Scalars['Float']['input']>;
  documentLink?: InputMaybe<Scalars['String']['input']>;
  documentName?: InputMaybe<Scalars['String']['input']>;
  documentPath?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDownloadInputs = {
  blobId?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentDownloadResponse = {
  __typename?: 'DocumentDownloadResponse';
  encodedZipFileData?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  failureDocuments?: Maybe<Array<DocumentDownload>>;
  successDocuments?: Maybe<Array<DocumentDownload>>;
  zipFileData?: Maybe<Array<Scalars['String']['output']>>;
};

export type DocumentDownloadResponses = {
  __typename?: 'DocumentDownloadResponses';
  encodedZipFileData?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  failureDocuments?: Maybe<Array<DocumentDownloads>>;
  successDocuments?: Maybe<Array<DocumentDownloads>>;
  zipFileData?: Maybe<Array<Scalars['String']['output']>>;
};

export type DocumentDownloads = {
  __typename?: 'DocumentDownloads';
  blobId?: Maybe<Scalars['Float']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
};

export type DocumentFormat = {
  __typename?: 'DocumentFormat';
  channel?: Maybe<Array<ChannelFormat>>;
  formatName?: Maybe<Scalars['String']['output']>;
};

export type DocumentFormatChannelData = {
  __typename?: 'DocumentFormatChannelData';
  companyCode?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Array<DocumentFormat>>;
  partnerType?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
};

export type DocumentInput = {
  companyCode?: InputMaybe<Scalars['String']['input']>;
  downloaded?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  orderArea?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentProcessCode = {
  __typename?: 'DocumentProcessCode';
  channel?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  defaultAlternative?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  formatOptions?: Maybe<Array<Scalars['String']['output']>>;
  partnerType?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  processCodeId?: Maybe<Scalars['String']['output']>;
  processCodeName?: Maybe<Scalars['String']['output']>;
  updatedChannel?: Maybe<Scalars['String']['output']>;
  updatedFormat?: Maybe<Scalars['String']['output']>;
};

export type DocumentRecord = {
  __typename?: 'DocumentRecord';
  agreementHistory?: Maybe<AgreementHistory>;
  changedFields?: Maybe<Array<Scalars['String']['output']>>;
  document?: Maybe<EcapDocument>;
  documentTemplate?: Maybe<DocumentTemplate>;
  lineItems?: Maybe<Array<LineItems>>;
  masterDataRefreshed?: Maybe<Scalars['Boolean']['output']>;
  shippingInformation?: Maybe<ShippingInformation>;
  supplierDetails?: Maybe<SupplierDetails>;
};

export type DocumentRecordInput = {
  agreementHistory?: InputMaybe<AgreementHistoryInputType>;
  changedFields?: InputMaybe<Array<Scalars['String']['input']>>;
  document?: InputMaybe<EcapDocumentInput>;
  documentTemplate?: InputMaybe<DocumentTemplateInput>;
  lineItems?: InputMaybe<Array<LineItemsInput>>;
  masterDataRefreshed?: InputMaybe<Scalars['Boolean']['input']>;
  shippingInformation?: InputMaybe<ShippingInformationInput>;
  supplierDetails?: InputMaybe<SupplierDetailsInput>;
};

export type DocumentTemplate = {
  __typename?: 'DocumentTemplate';
  id?: Maybe<Scalars['Float']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type DocumentTemplateDropdownResult = {
  __typename?: 'DocumentTemplateDropdownResult';
  companyCode?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['Float']['output']>;
  documentTemplateID?: Maybe<Scalars['Float']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type DocumentTemplateInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};

export type DownloadSurveyPartnerChannelInput = {
  categories: Array<Scalars['String']['input']>;
  companyCodes: Array<Scalars['String']['input']>;
  partnerNumbers: Array<Scalars['String']['input']>;
  systemCodes: Array<Scalars['String']['input']>;
};

export type DownloadSurveyPartnerContactInput = {
  categories: Array<Scalars['String']['input']>;
  companyCodes: Array<Scalars['String']['input']>;
  partnerNumbers: Array<Scalars['String']['input']>;
  systemCodes: Array<Scalars['String']['input']>;
};

export type DownloadedRejectionLetter = {
  __typename?: 'DownloadedRejectionLetter';
  companyCodeName?: Maybe<Scalars['String']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  downloadDate?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  insertDate?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  partnerInvoice?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type DraftList = {
  __typename?: 'DraftList';
  bmwCompany?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  documentDate?: Maybe<Scalars['String']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lastUpdate?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  tpUser?: Maybe<Scalars['String']['output']>;
};

export type DraftListInput = {
  bmwCompanyId?: InputMaybe<Scalars['Float']['input']>;
  documentDateFrom?: InputMaybe<Scalars['String']['input']>;
  documentDateTo?: InputMaybe<Scalars['String']['input']>;
  documentNumbers?: InputMaybe<Scalars['String']['input']>;
  documentTypeId?: InputMaybe<Scalars['Float']['input']>;
  downloaded?: InputMaybe<Scalars['Float']['input']>;
  formatId?: InputMaybe<Scalars['Float']['input']>;
  myDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Float']['input']>;
  partnerNoList?: InputMaybe<Array<Scalars['String']['input']>>;
  processCodeId?: InputMaybe<Scalars['Float']['input']>;
  receptionDateFrom?: InputMaybe<Scalars['String']['input']>;
  receptionDateTo?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Float']['input']>;
  vinNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DropDown = {
  __typename?: 'DropDown';
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type DropDownQuery = {
  dataType?: InputMaybe<Scalars['String']['input']>;
  entitlements?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type DuplicateDocNoWarningFlag = {
  __typename?: 'DuplicateDocNoWarningFlag';
  duplicateDocumentNumberInCurrentYearWarning?: Maybe<Scalars['Boolean']['output']>;
};

export type EcapAgreementHistory = {
  __typename?: 'ECAPAgreementHistory';
  agreementAcceptedByUserId?: Maybe<Scalars['Float']['output']>;
  agreementAcceptedDate?: Maybe<Scalars['String']['output']>;
  agreementAcceptedUser?: Maybe<Scalars['String']['output']>;
  agreementDescription?: Maybe<Scalars['String']['output']>;
  agreementHistoryId?: Maybe<Scalars['Float']['output']>;
  agreementId?: Maybe<Scalars['Float']['output']>;
  agreementName?: Maybe<Scalars['String']['output']>;
  blobId?: Maybe<Scalars['String']['output']>;
};

export type EcapAgreementInfo = {
  __typename?: 'ECAPAgreementInfo';
  agreementDescription?: Maybe<Scalars['String']['output']>;
  agreementId?: Maybe<Scalars['Float']['output']>;
  agreementName?: Maybe<Scalars['String']['output']>;
  blobId?: Maybe<Scalars['Float']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
};

export type EcapCreatedDocument = {
  __typename?: 'ECAPCreatedDocument';
  agreementReference?: Maybe<Scalars['String']['output']>;
  bmwBusinessAreaId?: Maybe<Scalars['Float']['output']>;
  bmwBusinessUnitId?: Maybe<Scalars['Float']['output']>;
  bmwCompanyCity?: Maybe<Scalars['String']['output']>;
  bmwCompanyCountryCode?: Maybe<Scalars['String']['output']>;
  bmwCompanyPostalCode?: Maybe<Scalars['String']['output']>;
  bmwCompanyStreet1?: Maybe<Scalars['String']['output']>;
  bmwCompanyStreet2?: Maybe<Scalars['String']['output']>;
  bmwCompanyTaxId?: Maybe<Scalars['String']['output']>;
  bmwContactDepartment?: Maybe<Scalars['String']['output']>;
  bmwContactEmail?: Maybe<Scalars['String']['output']>;
  bmwContactName?: Maybe<Scalars['String']['output']>;
  bmwContactTelephone?: Maybe<Scalars['String']['output']>;
  bmwGroupPaymentRequest?: Maybe<Scalars['Boolean']['output']>;
  bmwIsRetailOutlet?: Maybe<Scalars['Boolean']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['Float']['output']>;
  companyVatCode?: Maybe<Scalars['String']['output']>;
  companyVatCodeId?: Maybe<Scalars['Float']['output']>;
  currencyCodeId?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryNumber?: Maybe<Scalars['String']['output']>;
  documentDate?: Maybe<Scalars['String']['output']>;
  documentFormatId?: Maybe<Scalars['Float']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  documentStatus?: Maybe<Scalars['String']['output']>;
  documentStatusId?: Maybe<Scalars['Float']['output']>;
  documentStatusPhraseId?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  documentTypeDescription?: Maybe<Scalars['String']['output']>;
  documentTypeDescriptionPhraseId?: Maybe<Scalars['String']['output']>;
  documentTypeId?: Maybe<Scalars['Float']['output']>;
  documentTypePhraseId?: Maybe<Scalars['String']['output']>;
  earlyPaymentDescription?: Maybe<Scalars['String']['output']>;
  earlyPaymentDiscountDate?: Maybe<Scalars['String']['output']>;
  earlyPaymentDiscountDueDate?: Maybe<Scalars['String']['output']>;
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  exchangeRateDate?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  headerText?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  isOrderNumberNotRequired?: Maybe<Scalars['Boolean']['output']>;
  isTemplateDocument?: Maybe<Scalars['Boolean']['output']>;
  lastUploadedFileName?: Maybe<Scalars['String']['output']>;
  lastUploadedFileTime?: Maybe<Scalars['String']['output']>;
  localCurrencyCodeId?: Maybe<Scalars['String']['output']>;
  localCurrencyGrossAmount?: Maybe<Scalars['Float']['output']>;
  localCurrencyNetAmount?: Maybe<Scalars['Float']['output']>;
  localCurrencyTaxAmount?: Maybe<Scalars['Float']['output']>;
  localCurrencyTaxableAmount?: Maybe<Scalars['Float']['output']>;
  messageCountryCode?: Maybe<Scalars['String']['output']>;
  messageFileName?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['Float']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  originalInvoiceNumber?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerVatCode?: Maybe<Scalars['String']['output']>;
  partnerVatCodeId?: Maybe<Scalars['Float']['output']>;
  partnerVatCountry?: Maybe<Scalars['String']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  processCodeId?: Maybe<Scalars['Float']['output']>;
  processingStatusFlag?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  taxableAmount?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type EcapDocument = {
  __typename?: 'ECAPDocument';
  agreementReference?: Maybe<Scalars['String']['output']>;
  bmwBusinessAreaId?: Maybe<Scalars['Float']['output']>;
  bmwBusinessUnitId?: Maybe<Scalars['Float']['output']>;
  bmwCompanyCity?: Maybe<Scalars['String']['output']>;
  bmwCompanyCountryCode?: Maybe<Scalars['String']['output']>;
  bmwCompanyPostalCode?: Maybe<Scalars['String']['output']>;
  bmwCompanyStreet1?: Maybe<Scalars['String']['output']>;
  bmwCompanyStreet2?: Maybe<Scalars['String']['output']>;
  bmwCompanyTaxId?: Maybe<Scalars['String']['output']>;
  bmwContactDepartment?: Maybe<Scalars['String']['output']>;
  bmwContactEmail?: Maybe<Scalars['String']['output']>;
  bmwContactName?: Maybe<Scalars['String']['output']>;
  bmwContactTelephone?: Maybe<Scalars['String']['output']>;
  bmwGroupPaymentRequest?: Maybe<Scalars['Boolean']['output']>;
  bmwIsRetailOutlet?: Maybe<Scalars['Boolean']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['Float']['output']>;
  companyVatCode?: Maybe<Scalars['String']['output']>;
  companyVatCodeId?: Maybe<Scalars['Float']['output']>;
  currencyCodeId?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryNumber?: Maybe<Scalars['String']['output']>;
  documentDate?: Maybe<Scalars['String']['output']>;
  documentFormatId?: Maybe<Scalars['Float']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  documentStatus?: Maybe<Scalars['String']['output']>;
  documentStatusId?: Maybe<Scalars['Float']['output']>;
  documentStatusPhraseId?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  documentTypeDescription?: Maybe<Scalars['String']['output']>;
  documentTypeDescriptionPhraseId?: Maybe<Scalars['String']['output']>;
  documentTypeId?: Maybe<Scalars['Float']['output']>;
  documentTypePhraseId?: Maybe<Scalars['String']['output']>;
  earlyPaymentDescription?: Maybe<Scalars['String']['output']>;
  earlyPaymentDiscountDate?: Maybe<Scalars['String']['output']>;
  earlyPaymentDiscountDueDate?: Maybe<Scalars['String']['output']>;
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  exchangeRateDate?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  headerText?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  isOrderNumberNotRequired?: Maybe<Scalars['Boolean']['output']>;
  isTemplateDocument?: Maybe<Scalars['Boolean']['output']>;
  localCurrencyCodeId?: Maybe<Scalars['String']['output']>;
  localCurrencyGrossAmount?: Maybe<Scalars['Float']['output']>;
  localCurrencyNetAmount?: Maybe<Scalars['Float']['output']>;
  localCurrencyTaxAmount?: Maybe<Scalars['Float']['output']>;
  localCurrencyTaxableAmount?: Maybe<Scalars['Float']['output']>;
  messageCountryCode?: Maybe<Scalars['String']['output']>;
  messageFileName?: Maybe<Scalars['String']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  netAmount?: Maybe<Scalars['Float']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  originalInvoiceNumber?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerVatCode?: Maybe<Scalars['String']['output']>;
  partnerVatCodeId?: Maybe<Scalars['Float']['output']>;
  partnerVatCountry?: Maybe<Scalars['String']['output']>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  processCodeId?: Maybe<Scalars['Float']['output']>;
  processingStatusFlag?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  taxableAmount?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type EcapDocumentInput = {
  agreementReference?: InputMaybe<Scalars['String']['input']>;
  bmwBusinessAreaId?: InputMaybe<Scalars['Float']['input']>;
  bmwBusinessUnitId?: InputMaybe<Scalars['Float']['input']>;
  bmwCompanyCity?: InputMaybe<Scalars['String']['input']>;
  bmwCompanyCountryCode?: InputMaybe<Scalars['String']['input']>;
  bmwCompanyPostalCode?: InputMaybe<Scalars['String']['input']>;
  bmwCompanyStreet1?: InputMaybe<Scalars['String']['input']>;
  bmwCompanyStreet2?: InputMaybe<Scalars['String']['input']>;
  bmwCompanyTaxId?: InputMaybe<Scalars['String']['input']>;
  bmwContactDepartment?: InputMaybe<Scalars['String']['input']>;
  bmwContactEmail?: InputMaybe<Scalars['String']['input']>;
  bmwContactName?: InputMaybe<Scalars['String']['input']>;
  bmwContactTelephone?: InputMaybe<Scalars['String']['input']>;
  bmwGroupPaymentRequest?: InputMaybe<Scalars['Boolean']['input']>;
  bmwIsRetailOutlet?: InputMaybe<Scalars['Boolean']['input']>;
  companyCode?: InputMaybe<Scalars['String']['input']>;
  companyPartnerId?: InputMaybe<Scalars['Float']['input']>;
  companyVatCodeId?: InputMaybe<Scalars['Float']['input']>;
  currencyCodeId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryNumber?: InputMaybe<Scalars['String']['input']>;
  documentDate?: InputMaybe<Scalars['String']['input']>;
  documentFormatId?: InputMaybe<Scalars['Float']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  documentStatusId?: InputMaybe<Scalars['Float']['input']>;
  documentTypeId?: InputMaybe<Scalars['Float']['input']>;
  earlyPaymentDescription?: InputMaybe<Scalars['String']['input']>;
  earlyPaymentDiscountDate?: InputMaybe<Scalars['String']['input']>;
  earlyPaymentDiscountDueDate?: InputMaybe<Scalars['String']['input']>;
  exchangeRate?: InputMaybe<Scalars['Float']['input']>;
  exchangeRateDate?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  isOrderNumberNotRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isTemplateDocument?: InputMaybe<Scalars['Boolean']['input']>;
  localCurrencyCodeId?: InputMaybe<Scalars['String']['input']>;
  localCurrencyGrossAmount?: InputMaybe<Scalars['Float']['input']>;
  localCurrencyNetAmount?: InputMaybe<Scalars['Float']['input']>;
  localCurrencyTaxAmount?: InputMaybe<Scalars['Float']['input']>;
  localCurrencyTaxableAmount?: InputMaybe<Scalars['Float']['input']>;
  netAmount?: InputMaybe<Scalars['Float']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  originalInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  partnerVatCodeId?: InputMaybe<Scalars['Float']['input']>;
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  processCodeId?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  taxableAmount?: InputMaybe<Scalars['Float']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
};

export type EimDashboardActivePartnerCountResponse = {
  __typename?: 'EIMDashboardActivePartnerCountResponse';
  groupCountData?: Maybe<Array<ActivePartnerGroupCountData>>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type EimDashboardActivePartnerResponse = {
  __typename?: 'EIMDashboardActivePartnerResponse';
  company?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type EimDashboardCardsResponse = {
  __typename?: 'EIMDashboardCardsResponse';
  fail?: Maybe<Scalars['Float']['output']>;
  inbound?: Maybe<Scalars['Float']['output']>;
  outbound?: Maybe<Scalars['Float']['output']>;
  overdue?: Maybe<Scalars['Float']['output']>;
  pass?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  transb?: Maybe<Scalars['Float']['output']>;
  transit?: Maybe<Scalars['Float']['output']>;
};

export type EimDashboardCountryDetailErrorMessageResponse = {
  __typename?: 'EIMDashboardCountryDetailErrorMessageResponse';
  count?: Maybe<Scalars['Float']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type EimDashboardCountryDetailMetricsResponse = {
  __typename?: 'EIMDashboardCountryDetailMetricsResponse';
  avgTransitDays?: Maybe<Scalars['Float']['output']>;
  failedCount?: Maybe<Scalars['Float']['output']>;
  failureRate?: Maybe<Scalars['Float']['output']>;
  inTransitCount?: Maybe<Scalars['Float']['output']>;
  overdueCount?: Maybe<Scalars['Float']['output']>;
  stpRate?: Maybe<Scalars['Float']['output']>;
  successfulCount?: Maybe<Scalars['Float']['output']>;
  totalProcessed?: Maybe<Scalars['Float']['output']>;
};

export type EimDashboardCountryDetailResponse = {
  __typename?: 'EIMDashboardCountryDetailResponse';
  hourlyTrend?: Maybe<Array<EimDashboardPartnerInvoiceHourlyTrendResponse>>;
  metrics?: Maybe<EimDashboardCountryDetailMetricsResponse>;
  topErrorMessages?: Maybe<Array<EimDashboardCountryDetailErrorMessageResponse>>;
  topPartners?: Maybe<Array<EimDashboardPartnerInvoiceSummaryResponse>>;
};

export type EimDashboardPartnerInvoiceHourlyTrendResponse = {
  __typename?: 'EIMDashboardPartnerInvoiceHourlyTrendResponse';
  failedCount?: Maybe<Scalars['Float']['output']>;
  hourLabel?: Maybe<Scalars['String']['output']>;
  successfulCount?: Maybe<Scalars['Float']['output']>;
};

export type EimDashboardPartnerInvoiceSummaryResponse = {
  __typename?: 'EIMDashboardPartnerInvoiceSummaryResponse';
  company?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type EimDashboardRequest = {
  company?: InputMaybe<Array<Scalars['String']['input']>>;
  companyGroup?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  m_interface?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  partner_country?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Scalars['String']['input']>;
  process?: InputMaybe<Array<Scalars['String']['input']>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type EimExecutiveDashboardRequest = {
  partnerGroup?: InputMaybe<Scalars['String']['input']>;
  periodEnd: Scalars['String']['input'];
  periodStart: Scalars['String']['input'];
  processType?: InputMaybe<Scalars['String']['input']>;
};

export type EimExecutiveDashboardResponse = {
  __typename?: 'EIMExecutiveDashboardResponse';
  coverage: CoverageSectionMetrics;
  flowHealth: FlowHealthSectionMetrics;
  metadata: DashboardMetadata;
  risk: RiskSectionMetrics;
  volume: VolumeSectionMetrics;
};

export type EimExecutiveDashboardV2Request = {
  company?: InputMaybe<Array<Scalars['String']['input']>>;
  companyGroup?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  m_interface?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  partner_country?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Scalars['String']['input']>;
  process?: InputMaybe<Array<Scalars['String']['input']>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type EimInvoiceStatus = {
  __typename?: 'EIMInvoiceStatus';
  Blob_Id?: Maybe<Scalars['Float']['output']>;
  apar?: Maybe<Scalars['String']['output']>;
  bmw_int_reference?: Maybe<Scalars['String']['output']>;
  c_status?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  clearing_house?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  complete_date?: Maybe<Scalars['String']['output']>;
  creation_ts?: Maybe<Scalars['String']['output']>;
  cross_border?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  document_available?: Maybe<Scalars['Boolean']['output']>;
  document_type?: Maybe<Scalars['String']['output']>;
  downloaded?: Maybe<Scalars['Boolean']['output']>;
  duplicate?: Maybe<Scalars['Float']['output']>;
  ebox_folder?: Maybe<Scalars['String']['output']>;
  edi_agreement_date?: Maybe<Scalars['String']['output']>;
  edp_relevant?: Maybe<Scalars['Boolean']['output']>;
  ext_reference?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  final_completion?: Maybe<Scalars['String']['output']>;
  gross_amount?: Maybe<Scalars['Float']['output']>;
  group_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  id_partner?: Maybe<Scalars['Float']['output']>;
  incident_no?: Maybe<Scalars['String']['output']>;
  insert_ts?: Maybe<Scalars['String']['output']>;
  insert_user?: Maybe<Scalars['String']['output']>;
  invoice_date?: Maybe<Scalars['String']['output']>;
  log_info_id?: Maybe<Scalars['Float']['output']>;
  log_obj_id?: Maybe<Scalars['Float']['output']>;
  log_status_id?: Maybe<Scalars['Float']['output']>;
  m_format?: Maybe<Scalars['String']['output']>;
  m_interface?: Maybe<Scalars['String']['output']>;
  m_invprocess?: Maybe<Scalars['String']['output']>;
  m_process?: Maybe<Scalars['String']['output']>;
  m_provider?: Maybe<Scalars['String']['output']>;
  md_process_id?: Maybe<Scalars['Float']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  original_log_obj_id?: Maybe<Scalars['Float']['output']>;
  partner_country?: Maybe<Scalars['String']['output']>;
  partner_name?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  process?: Maybe<Scalars['String']['output']>;
  process_code?: Maybe<Scalars['String']['output']>;
  process_error?: Maybe<Scalars['String']['output']>;
  received_date?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  route_id?: Maybe<Scalars['String']['output']>;
  sdi_number?: Maybe<Scalars['String']['output']>;
  shippartnerno?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_reason?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['String']['output']>;
  step_number?: Maybe<Scalars['Float']['output']>;
  sys_id?: Maybe<Scalars['String']['output']>;
  system_id?: Maybe<Scalars['Float']['output']>;
  target_directory?: Maybe<Scalars['String']['output']>;
  tax_amount?: Maybe<Scalars['Float']['output']>;
  update_user?: Maybe<Scalars['String']['output']>;
  updatetime?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  vin_number?: Maybe<Scalars['String']['output']>;
};

export type EimMessagesFilters = {
  __typename?: 'EIMMessagesFilters';
  company?: Maybe<Array<GridFilter>>;
  duplicate?: Maybe<Array<GridFilter>>;
  group_name?: Maybe<Array<GridFilter>>;
  m_format?: Maybe<Array<GridFilter>>;
  m_interface?: Maybe<Array<GridFilter>>;
  process?: Maybe<Array<GridFilter>>;
  status?: Maybe<Array<GridFilter>>;
  step?: Maybe<Array<GridFilter>>;
  step_number?: Maybe<Array<GridFilter>>;
  sys_id?: Maybe<Array<GridFilter>>;
};

export type EimMonitoringGridRequest = {
  Blob_Id?: InputMaybe<Scalars['Float']['input']>;
  agGridFilters?: InputMaybe<Scalars['JSON']['input']>;
  apar?: InputMaybe<Scalars['String']['input']>;
  bmw_int_reference?: InputMaybe<Scalars['String']['input']>;
  c_status?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  clearing_house?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Array<Scalars['String']['input']>>;
  companyGroup?: InputMaybe<Scalars['String']['input']>;
  complete_date?: InputMaybe<Scalars['String']['input']>;
  creation_ts?: InputMaybe<Scalars['String']['input']>;
  cross_border?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dashBoardFilters?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  document_available?: InputMaybe<Scalars['Boolean']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  duplicate?: InputMaybe<Array<Scalars['String']['input']>>;
  ebox_folder?: InputMaybe<Scalars['String']['input']>;
  edi_agreement_date?: InputMaybe<Scalars['String']['input']>;
  edp_relevant?: InputMaybe<Scalars['Boolean']['input']>;
  ext_reference?: InputMaybe<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  final_completion?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  gross_amount?: InputMaybe<Scalars['Float']['input']>;
  group_name?: InputMaybe<Array<Scalars['String']['input']>>;
  id_partner?: InputMaybe<Scalars['Float']['input']>;
  insert_ts?: InputMaybe<Scalars['String']['input']>;
  insert_user?: InputMaybe<Scalars['String']['input']>;
  invStatusDetails?: InputMaybe<Scalars['Boolean']['input']>;
  inv_status?: InputMaybe<Array<Scalars['String']['input']>>;
  invoice_date?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  log_info_id?: InputMaybe<Scalars['Float']['input']>;
  log_obj_id?: InputMaybe<Scalars['Float']['input']>;
  log_status_id?: InputMaybe<Scalars['Float']['input']>;
  m_format?: InputMaybe<Array<Scalars['String']['input']>>;
  m_interface?: InputMaybe<Array<Scalars['String']['input']>>;
  m_invprocess?: InputMaybe<Scalars['String']['input']>;
  m_process?: InputMaybe<Scalars['String']['input']>;
  m_provider?: InputMaybe<Scalars['String']['input']>;
  md_process_id?: InputMaybe<Scalars['Float']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
  original_log_obj_id?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  partner_country?: InputMaybe<Scalars['String']['input']>;
  partner_name?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Scalars['String']['input']>;
  process?: InputMaybe<Array<Scalars['String']['input']>>;
  process_code?: InputMaybe<Scalars['String']['input']>;
  process_error?: InputMaybe<Scalars['String']['input']>;
  received_date?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  route_id?: InputMaybe<Scalars['String']['input']>;
  sdi_number?: InputMaybe<Scalars['String']['input']>;
  shippartnerno?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  status_reason?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Array<Scalars['String']['input']>>;
  step_number?: InputMaybe<Array<Scalars['String']['input']>>;
  sys_id?: InputMaybe<Array<Scalars['String']['input']>>;
  system_id?: InputMaybe<Scalars['Float']['input']>;
  target_directory?: InputMaybe<Scalars['String']['input']>;
  tax_amount?: InputMaybe<Scalars['Float']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  update_user?: InputMaybe<Scalars['String']['input']>;
  updatetime?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  vin_number?: InputMaybe<Scalars['String']['input']>;
};

export type EimMonitoringGridResponse = {
  __typename?: 'EIMMonitoringGridResponse';
  invoiceStatusesList?: Maybe<Array<EimInvoiceStatus>>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type EimStatusUpdateRequest = {
  listOfInvoices: Array<CurrentInvoiceStatus>;
  new_status: Scalars['String']['input'];
};

export type EimUpdateResponse = {
  __typename?: 'EIMUpdateResponse';
  updatedRows: Scalars['Float']['output'];
};

export type EcDocumentIds = {
  ecDocumentId?: InputMaybe<Scalars['Float']['input']>;
};

export type EcapEntitlementPartner = {
  __typename?: 'EcapEntitlementPartner';
  appliedRuleIds?: Maybe<Array<Scalars['Float']['output']>>;
  category?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<EntitlementCompany>>;
  entitlements?: Maybe<Array<Scalars['String']['output']>>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerInDB?: Maybe<Scalars['Boolean']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerOu?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
};

export type EcapUserEntitlementResult = {
  __typename?: 'EcapUserEntitlementResult';
  appliedRuleIds?: Maybe<Array<Scalars['Float']['output']>>;
  distinctEntitlements?: Maybe<Array<Scalars['String']['output']>>;
  partners?: Maybe<Array<EcapEntitlementPartner>>;
};

export type EditBannerResponse = {
  __typename?: 'EditBannerResponse';
  response?: Maybe<Scalars['String']['output']>;
};

export type EditNotificationResponse = {
  __typename?: 'EditNotificationResponse';
  response?: Maybe<Scalars['String']['output']>;
};

export type EntitledCompany = {
  __typename?: 'EntitledCompany';
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
};

export type EntitledPartner = {
  __typename?: 'EntitledPartner';
  category?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
};

export type Entitlement = {
  __typename?: 'Entitlement';
  description?: Maybe<Scalars['String']['output']>;
  entitlement?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  presentInRules?: Maybe<Scalars['String']['output']>;
  rulesWithWildcards?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type EntitlementAuditReport = {
  __typename?: 'EntitlementAuditReport';
  details?: Maybe<Array<EntitlementAuditReportDetail>>;
  entitlement?: Maybe<Scalars['String']['output']>;
  entitlementDescription?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  latestAuditTime?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  rowId?: Maybe<Scalars['Float']['output']>;
  ruleId?: Maybe<Scalars['Float']['output']>;
};

export type EntitlementAuditReportDetail = {
  __typename?: 'EntitlementAuditReportDetail';
  allowedOrBlocked?: Maybe<Scalars['String']['output']>;
  auditAction?: Maybe<Scalars['String']['output']>;
  auditId?: Maybe<Scalars['Float']['output']>;
  auditTime?: Maybe<Scalars['String']['output']>;
  b2xRole?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  enterpriseRole?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  objectClass?: Maybe<Scalars['String']['output']>;
  otherEntitlementsOnRule?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  permissionRole?: Maybe<Scalars['String']['output']>;
  ruleDescription?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type EntitlementCompany = {
  __typename?: 'EntitlementCompany';
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
};

export type EntitlementCompanyInput = {
  companyCode?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Float']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
};

export type EntitlementFilter = {
  allowedOrBlocked?: InputMaybe<Scalars['String']['input']>;
  auditAction?: InputMaybe<Scalars['String']['input']>;
  auditDate?: InputMaybe<Array<Scalars['String']['input']>>;
  auditTimeFrom?: InputMaybe<Scalars['String']['input']>;
  auditTimeTo?: InputMaybe<Scalars['String']['input']>;
  b2xRole?: InputMaybe<Scalars['String']['input']>;
  companyCode?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  entitlementGroup?: InputMaybe<Array<Scalars['String']['input']>>;
  entitlementName?: InputMaybe<Scalars['String']['input']>;
  insertDateFrom?: InputMaybe<Scalars['String']['input']>;
  insertDateFromTo?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  objectClass?: InputMaybe<Scalars['String']['input']>;
  partnerNo?: InputMaybe<Scalars['String']['input']>;
  updateDateFrom?: InputMaybe<Scalars['String']['input']>;
  updateDateTo?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type EntitlementGroup = {
  __typename?: 'EntitlementGroup';
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  updateAction?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type EntitlementGroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  phraseId?: InputMaybe<Scalars['String']['input']>;
  updateAction?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export type EntitlementInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entitlement?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  phraseId?: InputMaybe<Scalars['String']['input']>;
  updateAction?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export type EntitlementPartner = {
  __typename?: 'EntitlementPartner';
  appliedRuleIds?: Maybe<Array<Scalars['Float']['output']>>;
  category?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<EntitlementCompany>>;
  entitlements?: Maybe<Array<Scalars['String']['output']>>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerInDB?: Maybe<Scalars['Boolean']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerOu?: Maybe<Scalars['String']['output']>;
};

export type EntitlementPartnerInput = {
  appliedRuleIds?: InputMaybe<Array<Scalars['Float']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  companies?: InputMaybe<Array<EntitlementCompanyInput>>;
  entitlements?: InputMaybe<Array<Scalars['String']['input']>>;
  partnerId?: InputMaybe<Scalars['Float']['input']>;
  partnerInDB?: InputMaybe<Scalars['Boolean']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  partnerNo?: InputMaybe<Scalars['String']['input']>;
  partnerOu?: InputMaybe<Scalars['String']['input']>;
};

export type EntitlementPartnerWithDetail = {
  __typename?: 'EntitlementPartnerWithDetail';
  appliedRuleIds?: Maybe<Array<Scalars['Float']['output']>>;
  category?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<EntitlementCompany>>;
  details?: Maybe<Array<EntitlementPartnerWithDetail>>;
  entitlements?: Maybe<Array<Scalars['String']['output']>>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerInDB?: Maybe<Scalars['Boolean']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerNumberType?: Maybe<Scalars['String']['output']>;
  partnerOu?: Maybe<Scalars['String']['output']>;
};

export type EntitlementReport = {
  __typename?: 'EntitlementReport';
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<EntitlementReportDetail>>;
  groupId?: Maybe<Scalars['String']['output']>;
  rowId?: Maybe<Scalars['Float']['output']>;
};

export type EntitlementReportDetail = {
  __typename?: 'EntitlementReportDetail';
  actualEntitlements?: Maybe<Scalars['String']['output']>;
  allowedOrBlocked?: Maybe<Scalars['String']['output']>;
  b2xRole?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  enterpriseRole?: Maybe<Scalars['String']['output']>;
  groupIds?: Maybe<Array<Scalars['String']['output']>>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  objectClass?: Maybe<Scalars['String']['output']>;
  otherEntitlementsOnRule?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  permissionRole?: Maybe<Scalars['String']['output']>;
  ruleDescription?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type EntitlementRule = {
  __typename?: 'EntitlementRule';
  actualEntitlements?: Maybe<Scalars['String']['output']>;
  allowFlag?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entitlements?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  userB2XRole?: Maybe<Scalars['String']['output']>;
  userDepartment?: Maybe<Scalars['String']['output']>;
  userEnterpriseRole?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userObjectClass?: Maybe<Scalars['String']['output']>;
  userPermissionRole?: Maybe<Scalars['String']['output']>;
};

export type EntitlementRuleInput = {
  allowFlag?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entitlements?: InputMaybe<Scalars['String']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  ruleId?: InputMaybe<Scalars['Float']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
  userB2XRole?: InputMaybe<Scalars['String']['input']>;
  userDepartment?: InputMaybe<Scalars['String']['input']>;
  userEnterpriseRole?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userObjectClass?: InputMaybe<Scalars['String']['input']>;
  userPermissionRole?: InputMaybe<Scalars['String']['input']>;
};

export type ExceptionMetricsSummary = {
  __typename?: 'ExceptionMetricsSummary';
  failedCount: Scalars['Int']['output'];
  failureRate: Scalars['Float']['output'];
  overdueCount: Scalars['Int']['output'];
};

export type ExemptionType = {
  __typename?: 'ExemptionType';
  id?: Maybe<Scalars['Float']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  taxExemptionType?: Maybe<Scalars['String']['output']>;
  taxLawReferenceId?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type FailureReasonSummary = {
  __typename?: 'FailureReasonSummary';
  failedCount: Scalars['Int']['output'];
  failureRate: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  overdueCount: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
  volume: Scalars['Int']['output'];
};

export type FetchBlobRequest = {
  bmwInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  companyCode?: InputMaybe<Scalars['String']['input']>;
  fetchType?: InputMaybe<Scalars['String']['input']>;
  invreceiptdate?: InputMaybe<Scalars['String']['input']>;
  partnerInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  partnerNumber?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type FlowHealthSectionMetrics = {
  __typename?: 'FlowHealthSectionMetrics';
  avgTransitDays: Scalars['Float']['output'];
  onTimeDelta: Scalars['Float']['output'];
  onTimeRate: Scalars['Float']['output'];
  onTimeTarget: Scalars['Float']['output'];
  onTimeThreshold: Scalars['Float']['output'];
  previousAvgTransitDays: Scalars['Float']['output'];
  previousOnTimeRate: Scalars['Float']['output'];
  previousStpRate: Scalars['Float']['output'];
  stpDelta: Scalars['Float']['output'];
  stpRate: Scalars['Float']['output'];
  stpRateTrendByDay: Array<FlowHealthTrendPoint>;
  stpRateTrendByMonth: Array<FlowHealthTrendPoint>;
  stpRateTrendByYear: Array<FlowHealthTrendPoint>;
  stpTarget: Scalars['Float']['output'];
  stpThreshold: Scalars['Float']['output'];
  transitDelta: Scalars['String']['output'];
};

export type FlowHealthTrendPoint = {
  __typename?: 'FlowHealthTrendPoint';
  avgTransitDays: Scalars['Float']['output'];
  month: Scalars['String']['output'];
  onTimeRate: Scalars['Float']['output'];
  stpRate: Scalars['Float']['output'];
};

export type FlowStageMetricsSummary = {
  __typename?: 'FlowStageMetricsSummary';
  avgTransitDays: Scalars['Float']['output'];
  mProcess: Scalars['String']['output'];
  stage: Scalars['String']['output'];
  stepNumber?: Maybe<Scalars['Int']['output']>;
  transitionCount: Scalars['Int']['output'];
};

export type FormatType = {
  __typename?: 'FormatType';
  documentFormat?: Maybe<Scalars['String']['output']>;
  documentFormatId?: Maybe<Scalars['Float']['output']>;
  formatDescription?: Maybe<Scalars['String']['output']>;
  incomingId?: Maybe<Scalars['Float']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
};

export type GeneratedPdf = {
  __typename?: 'GeneratedPDF';
  blobId: Scalars['Float']['output'];
  creationTime?: Maybe<Scalars['String']['output']>;
};

export type GenericEntityListBorderoEdpData = {
  __typename?: 'GenericEntityListBorderoEdpData';
  entity?: Maybe<Array<BorderoEdpData>>;
  rawType?: Maybe<Scalars['JSON']['output']>;
  type?: Maybe<Scalars['JSON']['output']>;
};

export type GetAllNotificationsInTableResponse = {
  __typename?: 'GetAllNotificationsInTableResponse';
  activeFromDate?: Maybe<Scalars['String']['output']>;
  activeToDate?: Maybe<Scalars['String']['output']>;
  entitlements?: Maybe<Array<Scalars['String']['output']>>;
  linkAddress?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  notificationId?: Maybe<Scalars['Float']['output']>;
  notificationType?: Maybe<Scalars['String']['output']>;
};

export type GoLiveResponse = {
  __typename?: 'GoLiveResponse';
  confirmedGoLiveDate?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  provisionalGoLiveDate?: Maybe<Scalars['String']['output']>;
  submissionDate?: Maybe<Scalars['String']['output']>;
};

export type GraphQlQueryInput = {
  actionName?: InputMaybe<Scalars['String']['input']>;
  operationName?: InputMaybe<Scalars['String']['input']>;
  partnerNumberList?: InputMaybe<Array<Scalars['String']['input']>>;
  userName?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Scalars['String']['input']>;
};

export type GridFilter = {
  __typename?: 'GridFilter';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GroupMetricsSummary = {
  __typename?: 'GroupMetricsSummary';
  country: Scalars['String']['output'];
  failedCount: Scalars['Int']['output'];
  groupName: Scalars['String']['output'];
  inTransitCount: Scalars['Int']['output'];
  successfulCount: Scalars['Int']['output'];
  totalInvoices: Scalars['Int']['output'];
};

export type IObtAddressModel = {
  aenderungDatum?: InputMaybe<Scalars['String']['input']>;
  aenderungUser?: InputMaybe<Scalars['String']['input']>;
  anlageDatum?: InputMaybe<Scalars['String']['input']>;
  anlageUser?: InputMaybe<Scalars['String']['input']>;
  companycode: Scalars['String']['input'];
  department?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  idpartner: Scalars['Int']['input'];
  mail?: InputMaybe<Scalars['String']['input']>;
  name1?: InputMaybe<Scalars['String']['input']>;
  name2?: InputMaybe<Scalars['String']['input']>;
  partnerno: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  valid?: InputMaybe<Scalars['String']['input']>;
};

export type IObtChannelModel = {
  channeltype: Scalars['String']['input'];
  companycode: Scalars['String']['input'];
  count: Scalars['String']['input'];
  direction: Scalars['String']['input'];
  format: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  idpartner: Scalars['Int']['input'];
  invprocess: Scalars['String']['input'];
  newProcess: Scalars['Boolean']['input'];
  newValidTo?: InputMaybe<Scalars['String']['input']>;
  partnerno: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  routeId: Scalars['String']['input'];
  status: Scalars['String']['input'];
  validfrom?: InputMaybe<Scalars['String']['input']>;
  validto?: InputMaybe<Scalars['String']['input']>;
};

export type IObtConfigAddressModel = {
  __typename?: 'IObtConfigAddressModel';
  city?: Maybe<Scalars['String']['output']>;
  companycode?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countrycode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pobox?: Maybe<Scalars['String']['output']>;
  postalcode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type IObtConfigBankModel = {
  __typename?: 'IObtConfigBankModel';
  BIC?: Maybe<Scalars['String']['output']>;
  IBAN?: Maybe<Scalars['String']['output']>;
  account_holder?: Maybe<Scalars['String']['output']>;
  accountno?: Maybe<Scalars['String']['output']>;
  bank_code?: Maybe<Scalars['String']['output']>;
  bank_name?: Maybe<Scalars['String']['output']>;
  companycode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  sortNo?: Maybe<Scalars['Int']['output']>;
};

export type IObtConfigCommonModel = {
  __typename?: 'IObtConfigCommonModel';
  ceo?: Maybe<Scalars['String']['output']>;
  chairman?: Maybe<Scalars['String']['output']>;
  company_name_addon?: Maybe<Scalars['String']['output']>;
  companycode?: Maybe<Scalars['String']['output']>;
  companycodeaddress?: Maybe<Scalars['String']['output']>;
  companyname?: Maybe<Scalars['String']['output']>;
  companynameshort?: Maybe<Scalars['String']['output']>;
  contact_email?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  internet?: Maybe<Scalars['String']['output']>;
  management?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  registercourt?: Maybe<Scalars['String']['output']>;
  registercourt_short?: Maybe<Scalars['String']['output']>;
  taxid?: Maybe<Scalars['String']['output']>;
  vatcode?: Maybe<Scalars['String']['output']>;
};

export type IObtConfigWaveModel = {
  __typename?: 'IObtConfigWaveModel';
  id_rollout?: Maybe<Scalars['Int']['output']>;
  rollout?: Maybe<Scalars['String']['output']>;
  startdate?: Maybe<Scalars['String']['output']>;
};

export type IObtContactModel = {
  __typename?: 'IObtContactModel';
  aenderungDatum?: Maybe<Scalars['String']['output']>;
  aenderungUser?: Maybe<Scalars['String']['output']>;
  anlageDatum?: Maybe<Scalars['String']['output']>;
  anlageUser?: Maybe<Scalars['String']['output']>;
  companycode?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idpartner?: Maybe<Scalars['Int']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  name1?: Maybe<Scalars['String']['output']>;
  name2?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type IObtContactModelInput = {
  aenderungDatum?: InputMaybe<Scalars['String']['input']>;
  aenderungUser?: InputMaybe<Scalars['String']['input']>;
  anlageDatum?: InputMaybe<Scalars['String']['input']>;
  anlageUser?: InputMaybe<Scalars['String']['input']>;
  companycode?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  idpartner?: InputMaybe<Scalars['Int']['input']>;
  mail?: InputMaybe<Scalars['String']['input']>;
  name1?: InputMaybe<Scalars['String']['input']>;
  name2?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  valid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IObtExistingContactsRequestInput = {
  partnerno?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IObtGridColumnFilterInput = {
  conditionJoin?: InputMaybe<Scalars['String']['input']>;
  dataType?: InputMaybe<Scalars['String']['input']>;
  field: Scalars['String']['input'];
  operator?: InputMaybe<Scalars['String']['input']>;
  secondOperator?: InputMaybe<Scalars['String']['input']>;
  secondValue?: InputMaybe<Scalars['String']['input']>;
  secondValueTo?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueTo?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IObtPartnerCompanyModel = {
  companycode: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  idpartner: Scalars['Int']['input'];
  partnerno: Scalars['String']['input'];
  remark?: InputMaybe<Scalars['String']['input']>;
};

export type IObtPartnerLegalInput = {
  checkdigit?: InputMaybe<Scalars['String']['input']>;
  codicedest?: InputMaybe<Scalars['String']['input']>;
  companycode?: InputMaybe<Scalars['String']['input']>;
  fineaddress?: InputMaybe<Scalars['String']['input']>;
  idpartner?: InputMaybe<Scalars['Int']['input']>;
  leitwegsEmail?: InputMaybe<Scalars['String']['input']>;
  leitwegsId?: InputMaybe<Scalars['String']['input']>;
  localcode?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Scalars['String']['input']>;
  pecaddress?: InputMaybe<Scalars['String']['input']>;
  peppolId?: InputMaybe<Scalars['String']['input']>;
  roughaddress?: InputMaybe<Scalars['String']['input']>;
};

export type IObtSearchModel = {
  basIn?: InputMaybe<Scalars['Boolean']['input']>;
  blockcindicator?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  companycode?: InputMaybe<Array<Scalars['String']['input']>>;
  countrycode?: InputMaybe<Array<Scalars['String']['input']>>;
  eboxOut?: InputMaybe<Scalars['Boolean']['input']>;
  endonboarding?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  golivebis?: InputMaybe<Scalars['String']['input']>;
  golivefrom?: InputMaybe<Scalars['String']['input']>;
  gridFilter?: InputMaybe<Scalars['String']['input']>;
  gridSelectedPartnerMassUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  idAddress?: InputMaybe<Scalars['Int']['input']>;
  idCompany?: InputMaybe<Scalars['Int']['input']>;
  idpartner?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lieferant?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  masterpartnerno?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  onboardingdate?: InputMaybe<Scalars['String']['input']>;
  onboardingstatus?: InputMaybe<Scalars['String']['input']>;
  onboardingwave?: InputMaybe<Array<Scalars['String']['input']>>;
  openTextIn?: InputMaybe<Scalars['Boolean']['input']>;
  openTextOut?: InputMaybe<Scalars['Boolean']['input']>;
  pageNo: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  partnername?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Scalars['String']['input']>;
  partnertype?: InputMaybe<Scalars['String']['input']>;
  phoneno?: InputMaybe<Scalars['String']['input']>;
  printIn?: InputMaybe<Scalars['Boolean']['input']>;
  printOut?: InputMaybe<Scalars['Boolean']['input']>;
  remark?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  rollout?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchwave?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  supplyOnOut?: InputMaybe<Scalars['Boolean']['input']>;
  surveyStatus?: InputMaybe<Scalars['String']['input']>;
  sysid?: InputMaybe<Array<Scalars['String']['input']>>;
  uploadRequest?: InputMaybe<Array<IObtUploadRequest>>;
  webEdiDirectIn?: InputMaybe<Scalars['Boolean']['input']>;
  webEdiIn?: InputMaybe<Scalars['Boolean']['input']>;
  webEdiOut?: InputMaybe<Scalars['Boolean']['input']>;
  withContactDetails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IObtSearchSelectOption = {
  __typename?: 'IObtSearchSelectOption';
  companyCodes?: Maybe<Array<IObtSelectOption>>;
  countries?: Maybe<Array<IObtSelectOption>>;
  languages?: Maybe<Array<IObtSelectOption>>;
  rollouts?: Maybe<Array<IObtSelectOption>>;
  systemCodes?: Maybe<Array<IObtSelectOption>>;
};

export type IObtSelectOption = {
  __typename?: 'IObtSelectOption';
  _id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type IObtSurveySearchCriteriaInput = {
  columnFilters?: InputMaybe<Array<IObtGridColumnFilterInput>>;
  companycode?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  insertDateFrom?: InputMaybe<Scalars['String']['input']>;
  insertDateTo?: InputMaybe<Scalars['String']['input']>;
  masterPartnerNo?: InputMaybe<Scalars['String']['input']>;
  pageNo?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  partnername?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Scalars['String']['input']>;
  partnertype?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sorters?: InputMaybe<Array<IObtSurveySearchCriteriaSorterInput>>;
  status?: InputMaybe<Scalars['String']['input']>;
  surveyId?: InputMaybe<Scalars['Int']['input']>;
  surveyStatus?: InputMaybe<Scalars['String']['input']>;
  surveyStatusId?: InputMaybe<Scalars['String']['input']>;
  surveyType?: InputMaybe<Scalars['String']['input']>;
  systemCode?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  vatCode?: InputMaybe<Scalars['String']['input']>;
  withContactOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IObtSurveySearchCriteriaSorterInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
};

export type IObtUploadRequest = {
  category?: InputMaybe<Scalars['String']['input']>;
  companycode?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Scalars['String']['input']>;
  sysid?: InputMaybe<Scalars['String']['input']>;
};

export type IObtUploadResponse = {
  __typename?: 'IObtUploadResponse';
  category?: Maybe<Scalars['String']['output']>;
  companycode?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  sysid?: Maybe<Scalars['String']['output']>;
};

export type IPortalUser = {
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  insert_time?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type IUserRights = {
  assigned?: Maybe<Scalars['Float']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyLinkExists?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  processCodeId?: Maybe<Scalars['Float']['output']>;
  processCodeName?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Float']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  rowno?: Maybe<Scalars['Float']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  systemCompanyId?: Maybe<Scalars['Float']['output']>;
  systemId?: Maybe<Scalars['Float']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type IncomingDocuments = {
  __typename?: 'IncomingDocuments';
  area?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  dateReceived?: Maybe<Scalars['String']['output']>;
  documentIncomingId?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  logObjectId?: Maybe<Scalars['Float']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  processError?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

export type IncomingDocumentsSummary = {
  __typename?: 'IncomingDocumentsSummary';
  firstOccurance?: Maybe<Scalars['String']['output']>;
  lastOccurance?: Maybe<Scalars['String']['output']>;
  processError?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type IntakeMetricsSummary = {
  __typename?: 'IntakeMetricsSummary';
  inboundCount: Scalars['Int']['output'];
  outboundCount: Scalars['Int']['output'];
  totalProcessed: Scalars['Int']['output'];
};

export type InvoiceFilter = {
  bmwdocno?: InputMaybe<OpValue>;
  busarea?: InputMaybe<Array<Scalars['String']['input']>>;
  compcode?: InputMaybe<Array<Scalars['String']['input']>>;
  confirmationno?: InputMaybe<OpValue>;
  deliverynotedateFrom?: InputMaybe<Scalars['String']['input']>;
  deliverynotedateUntil?: InputMaybe<Scalars['String']['input']>;
  deliverynoteno?: InputMaybe<OpValue>;
  doccurrency?: InputMaybe<Array<Scalars['String']['input']>>;
  docdateFrom?: InputMaybe<Scalars['String']['input']>;
  docdateUntil?: InputMaybe<Scalars['String']['input']>;
  extinvoice?: InputMaybe<OpValue>;
  gross?: InputMaybe<OpValue>;
  invdirection?: InputMaybe<Array<Scalars['String']['input']>>;
  invprocess?: InputMaybe<Array<Scalars['String']['input']>>;
  invstat?: InputMaybe<Array<Scalars['String']['input']>>;
  language?: InputMaybe<Scalars['String']['input']>;
  partnerinvno?: InputMaybe<OpValue>;
  partnerno?: InputMaybe<Array<Scalars['String']['input']>>;
  paymadviceno?: InputMaybe<OpValue>;
  paymentdateFrom?: InputMaybe<Scalars['String']['input']>;
  paymentdateUntil?: InputMaybe<Scalars['String']['input']>;
  plantcode?: InputMaybe<Array<Scalars['String']['input']>>;
  plantname?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseorderno?: InputMaybe<OpValue>;
  rejectiondateFrom?: InputMaybe<Scalars['String']['input']>;
  rejectiondateUntil?: InputMaybe<Scalars['String']['input']>;
  settletype?: InputMaybe<Array<Scalars['String']['input']>>;
  spaborderno?: InputMaybe<OpValue>;
  totpaymamnt?: InputMaybe<OpValue>;
};

export type InvoiceHeadDto = {
  __typename?: 'InvoiceHeadDTO';
  basedate?: Maybe<Scalars['String']['output']>;
  bmwdocno?: Maybe<Scalars['String']['output']>;
  busarea?: Maybe<Scalars['String']['output']>;
  companycode?: Maybe<Scalars['String']['output']>;
  companyname?: Maybe<Scalars['String']['output']>;
  compcode?: Maybe<Scalars['String']['output']>;
  contactap?: Maybe<Scalars['String']['output']>;
  contactcomplaint?: Maybe<Scalars['String']['output']>;
  contactinvoice?: Maybe<Scalars['String']['output']>;
  cumulativeno?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliverynoteNo?: Maybe<Scalars['String']['output']>;
  deliverynoteno?: Maybe<Scalars['String']['output']>;
  doccurrency?: Maybe<Scalars['String']['output']>;
  docdate?: Maybe<Scalars['String']['output']>;
  doctype?: Maybe<Scalars['String']['output']>;
  documentdate?: Maybe<Scalars['String']['output']>;
  duedate?: Maybe<Scalars['String']['output']>;
  dunnarchvie?: Maybe<Scalars['String']['output']>;
  dunnlevel?: Maybe<Scalars['String']['output']>;
  extinvoice?: Maybe<Scalars['String']['output']>;
  fiscalyear?: Maybe<Scalars['String']['output']>;
  gross?: Maybe<Scalars['Float']['output']>;
  grossamount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invdirection?: Maybe<Scalars['String']['output']>;
  invoicestatus?: Maybe<Scalars['String']['output']>;
  invprocess?: Maybe<Scalars['String']['output']>;
  invreceiptdate?: Maybe<Scalars['String']['output']>;
  invstat?: Maybe<Scalars['String']['output']>;
  invstatcode?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  maxrows?: Maybe<Scalars['Float']['output']>;
  net?: Maybe<Scalars['Float']['output']>;
  partnerinvno?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  paymadviceno?: Maybe<Scalars['String']['output']>;
  paymdate?: Maybe<Scalars['String']['output']>;
  paymentdate?: Maybe<Scalars['String']['output']>;
  paymentnumber?: Maybe<Scalars['String']['output']>;
  paymentterm?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<InvoicePositionDto>>;
  purchaseOrderNo?: Maybe<Scalars['String']['output']>;
  purchasemail?: Maybe<Scalars['String']['output']>;
  purchasename?: Maybe<Scalars['String']['output']>;
  purchaseorderno?: Maybe<Scalars['String']['output']>;
  purchasephone?: Maybe<Scalars['String']['output']>;
  recipientmail?: Maybe<Scalars['String']['output']>;
  recipientname?: Maybe<Scalars['String']['output']>;
  recipientphone?: Maybe<Scalars['String']['output']>;
  rejectionLetterFileName?: Maybe<Scalars['String']['output']>;
  rejectiondate?: Maybe<Scalars['String']['output']>;
  rejectionletteruri?: Maybe<Scalars['String']['output']>;
  settletype?: Maybe<Scalars['String']['output']>;
  taxamount?: Maybe<Scalars['Float']['output']>;
  taxrate?: Maybe<Scalars['Float']['output']>;
  totpaymamnt?: Maybe<Scalars['Float']['output']>;
  xSuiteRejectionUrl?: Maybe<Scalars['String']['output']>;
};

export type InvoicePositionDto = {
  __typename?: 'InvoicePositionDTO';
  confirmationno?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliverynotedate?: Maybe<Scalars['String']['output']>;
  deliverynoteno?: Maybe<Scalars['String']['output']>;
  duedate?: Maybe<Scalars['String']['output']>;
  headId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  materialdocno?: Maybe<Scalars['String']['output']>;
  netamount?: Maybe<Scalars['Float']['output']>;
  plantcode?: Maybe<Scalars['String']['output']>;
  plantname?: Maybe<Scalars['String']['output']>;
  purchasemail?: Maybe<Scalars['String']['output']>;
  purchasename?: Maybe<Scalars['String']['output']>;
  purchaseorderitem?: Maybe<Scalars['String']['output']>;
  purchaseorderno?: Maybe<Scalars['String']['output']>;
  purchasephone?: Maybe<Scalars['String']['output']>;
  receiptdate?: Maybe<Scalars['String']['output']>;
  recipientmail?: Maybe<Scalars['String']['output']>;
  recipientname?: Maybe<Scalars['String']['output']>;
  recipientphone?: Maybe<Scalars['String']['output']>;
  spaborderno?: Maybe<Scalars['String']['output']>;
  taxrate?: Maybe<Scalars['Float']['output']>;
};

export type KpiAggregatesQuery = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  reports?: InputMaybe<Array<Scalars['String']['input']>>;
  toDate?: InputMaybe<Scalars['String']['input']>;
};

export type KpiAggregatesResponse = {
  __typename?: 'KPIAggregatesResponse';
  count?: Maybe<Scalars['Float']['output']>;
  dayOfYear?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  reportName?: Maybe<Scalars['String']['output']>;
};

export type Ly5Response = {
  __typename?: 'LY5Response';
  bmwdocno?: Maybe<Scalars['String']['output']>;
  claimstatus?: Maybe<Scalars['String']['output']>;
  compcode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extinvoice?: Maybe<Scalars['String']['output']>;
  givolume?: Maybe<Scalars['Float']['output']>;
  handsurchamnt?: Maybe<Scalars['Float']['output']>;
  invReference?: Maybe<Scalars['String']['output']>;
  invbaselinedate?: Maybe<Scalars['String']['output']>;
  invpostdate?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  materialno?: Maybe<Scalars['String']['output']>;
  matshareamnt?: Maybe<Scalars['Float']['output']>;
  maxrows?: Maybe<Scalars['Float']['output']>;
  overduestatus?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  ponumber?: Maybe<Scalars['String']['output']>;
  poposition?: Maybe<Scalars['String']['output']>;
  supplclaimno?: Maybe<Scalars['String']['output']>;
  totalamnt?: Maybe<Scalars['Float']['output']>;
};

export type Ly6Request = {
  compcode?: InputMaybe<Array<Scalars['String']['input']>>;
  language?: InputMaybe<Scalars['String']['input']>;
  overdueStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  partnerno?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseOrderNumber?: InputMaybe<OpValue>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  validityDateFrom?: InputMaybe<Scalars['String']['input']>;
  validityDateUntil?: InputMaybe<Scalars['String']['input']>;
};

export type Ly6Response = {
  __typename?: 'LY6Response';
  bmwdocno?: Maybe<Scalars['String']['output']>;
  compcode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  extinvoice?: Maybe<Scalars['String']['output']>;
  fixedcostno?: Maybe<Scalars['String']['output']>;
  invbaselinedate?: Maybe<Scalars['String']['output']>;
  invpostdate?: Maybe<Scalars['String']['output']>;
  itemstatus?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  maxrows?: Maybe<Scalars['Float']['output']>;
  netamount?: Maybe<Scalars['Float']['output']>;
  overduestatus?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  ponumber?: Maybe<Scalars['String']['output']>;
};

export type Ly7Request = {
  compcode?: InputMaybe<Array<Scalars['String']['input']>>;
  language?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseOrderNumber?: InputMaybe<OpValue>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  validityDateFrom?: InputMaybe<Scalars['String']['input']>;
  validityDateUntil?: InputMaybe<Scalars['String']['input']>;
};

export type Ly7Response = {
  __typename?: 'LY7Response';
  bmwdocno?: Maybe<Scalars['String']['output']>;
  compcode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliverypostdate?: Maybe<Scalars['String']['output']>;
  documentdate?: Maybe<Scalars['String']['output']>;
  extinvoice?: Maybe<Scalars['String']['output']>;
  fsdnumber?: Maybe<Scalars['String']['output']>;
  grnumber?: Maybe<Scalars['String']['output']>;
  itemstatus?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  maxrows?: Maybe<Scalars['Float']['output']>;
  netamount?: Maybe<Scalars['Float']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  ponumber?: Maybe<Scalars['String']['output']>;
};

export type LdapPartnerResult = {
  __typename?: 'LdapPartnerResult';
  countryCodeEU?: Maybe<Array<Scalars['String']['output']>>;
  countryCodePlate?: Maybe<Array<Scalars['String']['output']>>;
  currency?: Maybe<Array<Scalars['String']['output']>>;
  localAdmin?: Maybe<Array<Scalars['String']['output']>>;
  localAdminUsers?: Maybe<Array<LdapUserResult>>;
  masterAdmin?: Maybe<Array<Scalars['String']['output']>>;
  masterAdminDeputy?: Maybe<Array<Scalars['String']['output']>>;
  masterAdminDeputyUsers?: Maybe<Array<LdapUserResult>>;
  masterAdminUsers?: Maybe<Array<LdapUserResult>>;
  objectClass?: Maybe<Array<Scalars['String']['output']>>;
  ou?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  supplierBaseNumber?: Maybe<Array<Scalars['String']['output']>>;
  supplierExtNumber?: Maybe<Array<Scalars['String']['output']>>;
  supplierName?: Maybe<Array<Scalars['String']['output']>>;
  supplierNameExt1?: Maybe<Array<Scalars['String']['output']>>;
  telephoneNumber?: Maybe<Array<Scalars['String']['output']>>;
};

export type LdapUserResult = {
  __typename?: 'LdapUserResult';
  allEnterpriseRoles?: Maybe<Array<Scalars['String']['output']>>;
  allSupplierNumbers?: Maybe<Array<Scalars['String']['output']>>;
  departmentNumber?: Maybe<Array<Scalars['String']['output']>>;
  enterpriserole1?: Maybe<Array<Scalars['String']['output']>>;
  enterpriserole2?: Maybe<Array<Scalars['String']['output']>>;
  givenName?: Maybe<Scalars['String']['output']>;
  internalUser?: Maybe<Scalars['Boolean']['output']>;
  loginName?: Maybe<Scalars['String']['output']>;
  mail?: Maybe<Scalars['String']['output']>;
  objectClass?: Maybe<Array<Scalars['String']['output']>>;
  permissionrole?: Maybe<Array<Scalars['String']['output']>>;
  sn?: Maybe<Scalars['String']['output']>;
  supplierBaseNumber?: Maybe<Array<Scalars['String']['output']>>;
  supplierExtNumber?: Maybe<Array<Scalars['String']['output']>>;
  uid?: Maybe<Scalars['String']['output']>;
};

export type LegalFormType = {
  __typename?: 'LegalFormType';
  legalFormType?: Maybe<Scalars['String']['output']>;
  legalFormTypeId: Scalars['ID']['output'];
  phraseId?: Maybe<Scalars['String']['output']>;
};

export type LineItems = {
  __typename?: 'LineItems';
  bmwPartnerNumber?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryNo?: Maybe<Scalars['String']['output']>;
  ecDocumentDetailId?: Maybe<Scalars['Float']['output']>;
  ecDocumentId?: Maybe<Scalars['Float']['output']>;
  exemptionReason?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  inventoryNumber?: Maybe<Scalars['String']['output']>;
  itemDescription?: Maybe<Scalars['String']['output']>;
  lineNo?: Maybe<Scalars['Float']['output']>;
  netAmount?: Maybe<Scalars['Float']['output']>;
  orderNumber?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  srmReferenceNumber?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  taxExemptionTypeId?: Maybe<Scalars['Float']['output']>;
  taxLawReferenceId?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  toolLocation?: Maybe<Scalars['String']['output']>;
  toolSupplyingCountry?: Maybe<Scalars['String']['output']>;
  unitOfMeasureFreeText?: Maybe<Scalars['String']['output']>;
  unitOfMeasureId?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
  unitQuantity?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type LineItemsInput = {
  bmwPartnerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryNo?: InputMaybe<Scalars['String']['input']>;
  ecDocumentDetailId?: InputMaybe<Scalars['Float']['input']>;
  ecDocumentId?: InputMaybe<Scalars['Float']['input']>;
  exemptionReason?: InputMaybe<Scalars['String']['input']>;
  grossAmount?: InputMaybe<Scalars['Float']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  inventoryNumber?: InputMaybe<Scalars['String']['input']>;
  itemDescription?: InputMaybe<Scalars['String']['input']>;
  lineNo?: InputMaybe<Scalars['Float']['input']>;
  netAmount?: InputMaybe<Scalars['Float']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  srmReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  taxExemptionTypeId?: InputMaybe<Scalars['Float']['input']>;
  taxLawReferenceId?: InputMaybe<Scalars['Float']['input']>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  toolLocation?: InputMaybe<Scalars['String']['input']>;
  toolSupplyingCountry?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureFreeText?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasureId?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
  unitQuantity?: InputMaybe<Scalars['Float']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
};

export type LogInfoData = {
  __typename?: 'LogInfoData';
  apar?: Maybe<Scalars['String']['output']>;
  bmwIntReference?: Maybe<Scalars['String']['output']>;
  cStatus?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  completeDate?: Maybe<Scalars['String']['output']>;
  crossBorder?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  documentAvailable?: Maybe<Scalars['Boolean']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  duplicate?: Maybe<Scalars['String']['output']>;
  eboxFolder?: Maybe<Scalars['String']['output']>;
  ediAgreementDate?: Maybe<Scalars['String']['output']>;
  extReference?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  finalCompletion?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  insertTs?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  invStatus?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['String']['output']>;
  logInfoId?: Maybe<Scalars['Float']['output']>;
  logObjId?: Maybe<Scalars['Float']['output']>;
  mFormat?: Maybe<Scalars['String']['output']>;
  mInvprocess?: Maybe<Scalars['String']['output']>;
  mProcess?: Maybe<Scalars['String']['output']>;
  mProvider?: Maybe<Scalars['String']['output']>;
  mdProcessId?: Maybe<Scalars['Float']['output']>;
  originalLogObjId?: Maybe<Scalars['Float']['output']>;
  partnerCountry?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  processError?: Maybe<Scalars['String']['output']>;
  receivedDate?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  sdiNumber?: Maybe<Scalars['String']['output']>;
  sysId?: Maybe<Scalars['String']['output']>;
  systemId?: Maybe<Scalars['Float']['output']>;
  targetDirectory?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  updatetime?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  vinNumber?: Maybe<Scalars['String']['output']>;
};

export type LogInfoErrorView = {
  __typename?: 'LogInfoErrorView';
  apar?: Maybe<Scalars['String']['output']>;
  bmwIntReference?: Maybe<Scalars['String']['output']>;
  cStatus?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  companyExists?: Maybe<Scalars['Float']['output']>;
  companyPartnerId?: Maybe<Scalars['Float']['output']>;
  completeDate?: Maybe<Scalars['String']['output']>;
  cppartPartnerId?: Maybe<Scalars['Float']['output']>;
  cpprocPartnerId?: Maybe<Scalars['Float']['output']>;
  crossBorder?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  currencyOk?: Maybe<Scalars['Float']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  documentAvailable?: Maybe<Scalars['Boolean']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  duplicate?: Maybe<Scalars['String']['output']>;
  eboxFolder?: Maybe<Scalars['String']['output']>;
  ediAgreementDate?: Maybe<Scalars['String']['output']>;
  extReference?: Maybe<Scalars['String']['output']>;
  failReason?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileNameOk?: Maybe<Scalars['Float']['output']>;
  finalCompletion?: Maybe<Scalars['String']['output']>;
  formatExists?: Maybe<Scalars['Float']['output']>;
  formatOk?: Maybe<Scalars['Float']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  insertDateOk?: Maybe<Scalars['Float']['output']>;
  insertTs?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  invStatus?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['String']['output']>;
  invoiceDateOk?: Maybe<Scalars['Float']['output']>;
  logInfoId?: Maybe<Scalars['Float']['output']>;
  logObjId?: Maybe<Scalars['Float']['output']>;
  mFormat?: Maybe<Scalars['String']['output']>;
  mInvprocess?: Maybe<Scalars['String']['output']>;
  mProcess?: Maybe<Scalars['String']['output']>;
  mProvider?: Maybe<Scalars['String']['output']>;
  mdProcessId?: Maybe<Scalars['Float']['output']>;
  openTextTypeExists?: Maybe<Scalars['Float']['output']>;
  originalLogObjId?: Maybe<Scalars['String']['output']>;
  partnerCountry?: Maybe<Scalars['String']['output']>;
  partnerCountryOk?: Maybe<Scalars['Float']['output']>;
  partnerExists?: Maybe<Scalars['Float']['output']>;
  partnerLinkedToCompany?: Maybe<Scalars['Float']['output']>;
  partnerLinkedToCompanyAndProcess?: Maybe<Scalars['Float']['output']>;
  partnerLinkedToCompanyAndSystemId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerNoOk?: Maybe<Scalars['Float']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  processCodeOk?: Maybe<Scalars['Float']['output']>;
  processError?: Maybe<Scalars['String']['output']>;
  receivedDate?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  sdiNumber?: Maybe<Scalars['String']['output']>;
  sysId?: Maybe<Scalars['String']['output']>;
  sysIdExactMatch?: Maybe<Scalars['Float']['output']>;
  sysIdOk?: Maybe<Scalars['Float']['output']>;
  sysIdPartnerId?: Maybe<Scalars['Float']['output']>;
  systemId?: Maybe<Scalars['Float']['output']>;
  targetDirectory?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  updatetime?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  uuidOk?: Maybe<Scalars['Float']['output']>;
  vinNumber?: Maybe<Scalars['String']['output']>;
};

export type MissingInvoice = {
  __typename?: 'MissingInvoice';
  attachmentPending?: Maybe<Scalars['String']['output']>;
  blobId?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyCodeFromPartnerCompanySystem?: Maybe<Scalars['String']['output']>;
  companyCodeIssue?: Maybe<Scalars['String']['output']>;
  companyNameFromPartnerCompanySystem?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['String']['output']>;
  companyPartnerIdIssue?: Maybe<Scalars['String']['output']>;
  companyVatCode?: Maybe<Scalars['String']['output']>;
  companyVatCodeFromCompanyVatCode?: Maybe<Scalars['String']['output']>;
  companyVatCodeIssue?: Maybe<Scalars['String']['output']>;
  companyVatCountryCode?: Maybe<Scalars['String']['output']>;
  companyVatCountryCodeFromCompanyVatCode?: Maybe<Scalars['String']['output']>;
  companyVatCountryCodeIssue?: Maybe<Scalars['String']['output']>;
  correctCompanyPartnerId?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryCodeAddressIssue?: Maybe<Scalars['String']['output']>;
  discrepancies?: Maybe<Scalars['Boolean']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  ecDocumentId?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  logInfoId?: Maybe<Scalars['Float']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  partnerAddressIssue?: Maybe<Scalars['String']['output']>;
  partnerAddressTypeFromPartnerAddress?: Maybe<Scalars['String']['output']>;
  partnerCityFromPartnerAddress?: Maybe<Scalars['String']['output']>;
  partnerCountryCodeFromPartnerAddress?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNameFromPartnerCompanySystem?: Maybe<Scalars['String']['output']>;
  partnerNameIssue?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerNoFromPartnerCompanySystem?: Maybe<Scalars['String']['output']>;
  partnerNoIssue?: Maybe<Scalars['String']['output']>;
  partnerPostalCodeFromPartnerAddress?: Maybe<Scalars['String']['output']>;
  partnerRegionCodeFromPartnerAddress?: Maybe<Scalars['String']['output']>;
  partnerRegionFromPartnerAddress?: Maybe<Scalars['String']['output']>;
  partnerStreet1FromPartnerAddress?: Maybe<Scalars['String']['output']>;
  partnerStreet2FromPartnerAddress?: Maybe<Scalars['String']['output']>;
  partnerVatCode?: Maybe<Scalars['String']['output']>;
  partnerVatCodeFromPartnerVatCode?: Maybe<Scalars['String']['output']>;
  partnerVatCodeIssue?: Maybe<Scalars['String']['output']>;
  partnerVatCountryCode?: Maybe<Scalars['String']['output']>;
  partnerVatCountryCodeFromPartnerVatCode?: Maybe<Scalars['String']['output']>;
  partnerVatCountryCodeIssue?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  processingStatusFlag?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type MissingInvoiceGrouped = {
  __typename?: 'MissingInvoiceGrouped';
  processingStatusFlag?: Maybe<Scalars['String']['output']>;
  rowNo?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  Portal_AcceptMasterData?: Maybe<Scalars['String']['output']>;
  Portal_AcceptQueryContact?: Maybe<Scalars['String']['output']>;
  Portal_AssignUser?: Maybe<Scalars['String']['output']>;
  Portal_RemoveSurvey?: Maybe<Scalars['String']['output']>;
  Portal_SetResponsibleUser?: Maybe<Scalars['String']['output']>;
  addBannerData: AddBannerResponse;
  addNotificationData: AddNotificationResponse;
  addPortalUser: PortalUser;
  assignPartner?: Maybe<Array<Partner>>;
  associateWithBlob?: Maybe<SupportingDocumentResponse>;
  copyDocumentRecord?: Maybe<Scalars['Float']['output']>;
  createDocumentRecord?: Maybe<DocumentRecord>;
  createMissingCompanyProcessCodes?: Maybe<Scalars['Float']['output']>;
  createNotificationTemplateData: NotificationTemplateResponse;
  createPostgresECDocument?: Maybe<Scalars['Boolean']['output']>;
  createSurvey?: Maybe<Array<SurveyCreateResult>>;
  createSurveyFromMasterSurvey?: Maybe<Array<SurveyCreateResult>>;
  createUserGuide: UserGuide;
  createUserGuideGroup: UserGuideGroup;
  deleteBannerData: DeleteBannerResponse;
  deleteBlobFile: BlobDeleteResult;
  deleteDocumentRecord?: Maybe<Scalars['String']['output']>;
  deleteSupportingDocument: DeleteResponse;
  deleteSurveyContactByType?: Maybe<Scalars['String']['output']>;
  deleteUserGuide: Scalars['Boolean']['output'];
  deleteUserGuideGroup: Scalars['Boolean']['output'];
  editBannerData: EditBannerResponse;
  editNotificationData: EditNotificationResponse;
  getAllRouteChannelsAndFormats?: Maybe<OnbRouteChannelFormats>;
  insertObtIncEcapChannel?: Maybe<OnbPartnerChannel>;
  insertSurveyChannels?: Maybe<Array<SurveyChannelResponse>>;
  logGraphQLQuery: Scalars['String']['output'];
  mutateAssignedUserRights?: Maybe<Array<UserRightsOutput>>;
  mutateDocumentRecord?: Maybe<DocumentRecord>;
  mutateUserPreferences?: Maybe<Preferences>;
  obtCancelPartnerChannel: Scalars['String']['output'];
  obtDeletePartnerLegalDetail?: Maybe<ObtPartnerLegal>;
  obtDeletePartnerLegalVatCode?: Maybe<ObtPartnerVatNipCodeResult>;
  obtRemoveCompanyLeitwegID: Scalars['String']['output'];
  obtRemoveCompanyPeppolID: Scalars['String']['output'];
  obtUpdateAddressDetail?: Maybe<ObtPartnerAddress>;
  obtUpdateChannelDetail?: Maybe<ObtPartnerChannel>;
  obtUpdateCompanyLeitwegID: Scalars['String']['output'];
  obtUpdateCompanyPeppolID: Scalars['String']['output'];
  obtUpdateContactDetail?: Maybe<IObtContactModel>;
  obtUpdateContactStatus?: Maybe<Scalars['Int']['output']>;
  obtUpdateLietwegsLegalChannel: Scalars['String']['output'];
  obtUpdateMasterPartnerNo: Scalars['String']['output'];
  obtUpdatePartnerCompanyDetails?: Maybe<ObtPartnerCompany>;
  obtUpdatePartnerLegalDetail?: Maybe<ObtPartnerLegal>;
  obtUpdatePartnerLegalVatCode?: Maybe<ObtPartnerVatNipCodeResult>;
  obtUploadExcelFile: Array<IObtUploadResponse>;
  obtUploadPartnerContactsFile: Array<IObtContactModel>;
  reprocessECDocuments?: Maybe<Scalars['Float']['output']>;
  saveConnectivityPeppolDetailsForSurvey: SurveyConnectivityPeppolResponse;
  saveConnectivityTestFile: Array<SurveyConnectivityTestFileReport>;
  sendUploadedDocumentsToFavorCockpit: Scalars['Float']['output'];
  updateAgreementDownloaded: SurveyResponse;
  updateAgreementInfo: SurveyResponse;
  updateDocumentRecord?: Maybe<DocumentRecord>;
  updateEIMInvoiceStatuses: EimUpdateResponse;
  updateEcapDocumentStatus?: Maybe<EcapDocument>;
  updateEntitlement: EntitlementReportDetail;
  updateEntitlementB2XRoles: Array<B2xRoles>;
  updateEntitlementGroups: Array<EntitlementGroup>;
  updateEntitlementObjectClass: Array<ObjectClass>;
  updateEntitlementType: Array<Entitlement>;
  updateMultipleDownloadStatus: Scalars['String']['output'];
  updateNotificationReadData: NotificationUpdateResponse;
  updateSingleDownloadStatus: Scalars['String']['output'];
  updateSurveyConnectivityAs2: SurveyResponse;
  updateSurveyConnectivityOftp2: SurveyConnectivityOftp2Response;
  updateSurveyConnectivitySmtp: SurveyConnectivitySmtpResponse;
  updateSurveyConnectivityVda: Array<SurveyConnectivityVdaiResponse>;
  updateSurveyContact: SurveyContactResponse;
  updateSurveyReopenData: SurveyResponse;
  updateSurveySubmitData: SurveyResponse;
  updateUserGuide: UserGuide;
  updateUserGuideGroup: UserGuideGroup;
  uploadBlobFile: TfBlobResponse;
  uploadEcapDocument?: Maybe<TfBlobResponse>;
  uploadUserGuideDocument: UserGuideBlob;
};


export type MutationPortal_AcceptMasterDataArgs = {
  surveyIds: Array<SurveyMasterStatusInput>;
};


export type MutationPortal_AcceptQueryContactArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationPortal_AssignUserArgs = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationPortal_RemoveSurveyArgs = {
  surveyIds: Array<SurveyMasterDataType>;
};


export type MutationPortal_SetResponsibleUserArgs = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddBannerDataArgs = {
  addBannerInput: AddBannerInput;
  authentication: Scalars['String']['input'];
};


export type MutationAddNotificationDataArgs = {
  addNotificationInput: Array<AddNotificationInput>;
  authentication: Scalars['String']['input'];
};


export type MutationAddPortalUserArgs = {
  portalUserInput: PortalUserInput;
};


export type MutationAssignPartnerArgs = {
  assignPartner: AssignPartner;
};


export type MutationAssociateWithBlobArgs = {
  blobInfo: BlobInfo;
};


export type MutationCopyDocumentRecordArgs = {
  documentId: Scalars['Float']['input'];
};


export type MutationCreateDocumentRecordArgs = {
  documentRecord: DocumentRecordInput;
};


export type MutationCreateMissingCompanyProcessCodesArgs = {
  companyProcessingCodeRecords: Array<CompanyProcessingCodeRecordsInput>;
};


export type MutationCreateNotificationTemplateDataArgs = {
  authentication: Scalars['String']['input'];
  notificationTemplateInput: Array<NotificationTemplateInput>;
};


export type MutationCreatePostgresEcDocumentArgs = {
  documentId: Scalars['Float']['input'];
};


export type MutationCreateSurveyArgs = {
  surveyCreateRequests: Array<SurveyCreateRequest>;
};


export type MutationCreateSurveyFromMasterSurveyArgs = {
  copySurveyRequest: CopySurveyRequest;
};


export type MutationCreateUserGuideArgs = {
  input: UserGuideRequest;
};


export type MutationCreateUserGuideGroupArgs = {
  input: UserGuideGroupRequest;
};


export type MutationDeleteBannerDataArgs = {
  authentication: Scalars['String']['input'];
  bannerId: Scalars['Float']['input'];
};


export type MutationDeleteBlobFileArgs = {
  appName: Scalars['String']['input'];
  blobId: Scalars['Float']['input'];
};


export type MutationDeleteDocumentRecordArgs = {
  documentId: Scalars['Float']['input'];
};


export type MutationDeleteSupportingDocumentArgs = {
  attachmentId: Scalars['String']['input'];
};


export type MutationDeleteSurveyContactByTypeArgs = {
  contactTypeId: Scalars['Float']['input'];
  groupId: Scalars['String']['input'];
};


export type MutationDeleteUserGuideArgs = {
  id: Scalars['Float']['input'];
};


export type MutationDeleteUserGuideGroupArgs = {
  id: Scalars['Float']['input'];
};


export type MutationEditBannerDataArgs = {
  authentication: Scalars['String']['input'];
  bannerEditRequest: BannerEditRequest;
};


export type MutationEditNotificationDataArgs = {
  authentication: Scalars['String']['input'];
  notificationEditRequest: NotificationEditRequest;
};


export type MutationInsertObtIncEcapChannelArgs = {
  companyCode: Scalars['String']['input'];
  partnerNo: Scalars['String']['input'];
  systemCode: Scalars['String']['input'];
};


export type MutationInsertSurveyChannelsArgs = {
  includedSurveyIds: Scalars['String']['input'];
  partnerType: Scalars['String']['input'];
  surveyChannels: Array<SurveyChannelInput>;
};


export type MutationLogGraphQlQueryArgs = {
  graphQLQueryInput: GraphQlQueryInput;
};


export type MutationMutateAssignedUserRightsArgs = {
  userId: Scalars['Float']['input'];
  userRights: Array<UserRightsInput>;
};


export type MutationMutateDocumentRecordArgs = {
  documentRecord: DocumentRecordInput;
};


export type MutationMutateUserPreferencesArgs = {
  preferences: SetUserPreferences;
};


export type MutationObtCancelPartnerChannelArgs = {
  channelId: Scalars['Float']['input'];
  status: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
};


export type MutationObtDeletePartnerLegalDetailArgs = {
  legalModel: IObtPartnerLegalInput;
};


export type MutationObtDeletePartnerLegalVatCodeArgs = {
  idpartner: Scalars['Float']['input'];
  partnerno: Scalars['String']['input'];
  vatCode: Scalars['String']['input'];
};


export type MutationObtRemoveCompanyLeitwegIdArgs = {
  companycode: Scalars['String']['input'];
  idpartner: Scalars['Float']['input'];
  partnerno: Scalars['String']['input'];
};


export type MutationObtRemoveCompanyPeppolIdArgs = {
  companycode: Scalars['String']['input'];
  idpartner: Scalars['Float']['input'];
  partnerno: Scalars['String']['input'];
};


export type MutationObtUpdateAddressDetailArgs = {
  addressModel: IObtAddressModel;
};


export type MutationObtUpdateChannelDetailArgs = {
  channelModel: IObtChannelModel;
};


export type MutationObtUpdateCompanyLeitwegIdArgs = {
  companycode: Scalars['String']['input'];
  idpartner: Scalars['Float']['input'];
  leitwegid: Scalars['String']['input'];
  leitwegsemail: Scalars['String']['input'];
  partnerno: Scalars['String']['input'];
};


export type MutationObtUpdateCompanyPeppolIdArgs = {
  companycode: Scalars['String']['input'];
  idpartner: Scalars['Float']['input'];
  partnerno: Scalars['String']['input'];
  peppolId: Scalars['String']['input'];
};


export type MutationObtUpdateContactDetailArgs = {
  contactModel: IObtContactModelInput;
};


export type MutationObtUpdateContactStatusArgs = {
  idContact: Scalars['Float']['input'];
};


export type MutationObtUpdateLietwegsLegalChannelArgs = {
  companyCode: Scalars['String']['input'];
  idPartner: Scalars['Float']['input'];
  partnerNo: Scalars['String']['input'];
};


export type MutationObtUpdateMasterPartnerNoArgs = {
  idpartner: Scalars['Float']['input'];
  masterpartnerno: Scalars['String']['input'];
  partnerno: Scalars['String']['input'];
};


export type MutationObtUpdatePartnerCompanyDetailsArgs = {
  partnerCompany: IObtPartnerCompanyModel;
};


export type MutationObtUpdatePartnerLegalDetailArgs = {
  legalModel: IObtPartnerLegalInput;
};


export type MutationObtUpdatePartnerLegalVatCodeArgs = {
  idpartner: Scalars['Float']['input'];
  partnerno: Scalars['String']['input'];
  vatCode: Scalars['String']['input'];
};


export type MutationObtUploadExcelFileArgs = {
  fileBase64: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationObtUploadPartnerContactsFileArgs = {
  fileBase64: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationReprocessEcDocumentsArgs = {
  documentIdList: Array<EcDocumentIds>;
};


export type MutationSaveConnectivityPeppolDetailsForSurveyArgs = {
  groupId: Scalars['String']['input'];
  peppolDetails: SurveyConnectivityPeppolInput;
};


export type MutationSaveConnectivityTestFileArgs = {
  groupId: Scalars['String']['input'];
  testFile: SurveyConnectivityTestFileInput;
};


export type MutationSendUploadedDocumentsToFavorCockpitArgs = {
  request: SendUploadedDocumentsToFavorCockpitInput;
};


export type MutationUpdateAgreementDownloadedArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationUpdateAgreementInfoArgs = {
  surveyAgreementInput: SurveyAgreementInput;
};


export type MutationUpdateDocumentRecordArgs = {
  documentRecord: DocumentRecordInput;
};


export type MutationUpdateEimInvoiceStatusesArgs = {
  env: Scalars['String']['input'];
  request: EimStatusUpdateRequest;
};


export type MutationUpdateEcapDocumentStatusArgs = {
  documentId: Scalars['Float']['input'];
  documentStatusId: Scalars['Float']['input'];
};


export type MutationUpdateEntitlementArgs = {
  entitlementRule: EntitlementRuleInput;
};


export type MutationUpdateEntitlementB2XRolesArgs = {
  b2xRoles: Array<B2xRolesInput>;
};


export type MutationUpdateEntitlementGroupsArgs = {
  entitlementGroups: Array<EntitlementGroupInput>;
};


export type MutationUpdateEntitlementObjectClassArgs = {
  objectClasses: Array<ObjectClassInput>;
};


export type MutationUpdateEntitlementTypeArgs = {
  entitlementTypes: Array<EntitlementInput>;
};


export type MutationUpdateMultipleDownloadStatusArgs = {
  documentDownloadInputs: Array<DocumentDownloadInput>;
};


export type MutationUpdateNotificationReadDataArgs = {
  authentication: Scalars['String']['input'];
  notificationInput: Array<NotificationInput>;
};


export type MutationUpdateSingleDownloadStatusArgs = {
  documentDownloadInput: DocumentDownloadInput;
};


export type MutationUpdateSurveyConnectivityAs2Args = {
  groupId: Scalars['String']['input'];
  surveyAgreementConnectivityAs2: SurveyAgreementConnectivityAs2;
};


export type MutationUpdateSurveyConnectivityOftp2Args = {
  groupId: Scalars['String']['input'];
  surveyConnectivityOFTP2: SurveyConnectivityOftp2Input;
};


export type MutationUpdateSurveyConnectivitySmtpArgs = {
  groupId: Scalars['String']['input'];
  surveyConnectivitySMTP: SurveyConnectivitySmtpInput;
};


export type MutationUpdateSurveyConnectivityVdaArgs = {
  groupId: Scalars['String']['input'];
  surveyConnectivityVDAInput: SurveyConnectivityVdaInput;
};


export type MutationUpdateSurveyContactArgs = {
  groupId: Scalars['String']['input'];
  surveyContact: SurveyContactInput;
};


export type MutationUpdateSurveyReopenDataArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationUpdateSurveySubmitDataArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationUpdateUserGuideArgs = {
  input: UserGuideRequest;
};


export type MutationUpdateUserGuideGroupArgs = {
  input: UserGuideGroupRequest;
};


export type MutationUploadBlobFileArgs = {
  blobFile: BlobFileInput;
};


export type MutationUploadEcapDocumentArgs = {
  blobFile: BlobFileInput;
};


export type MutationUploadUserGuideDocumentArgs = {
  input: UserGuideDocUploadInput;
};

export type NotificationCountResponse = {
  __typename?: 'NotificationCountResponse';
  notificationCount?: Maybe<Scalars['Float']['output']>;
};

export type NotificationEditRequest = {
  activeFromDate?: InputMaybe<Scalars['String']['input']>;
  activeToDate?: InputMaybe<Scalars['String']['input']>;
  linkAddress?: InputMaybe<Scalars['String']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  notificationId?: InputMaybe<Scalars['Float']['input']>;
};

export type NotificationInput = {
  notificationId?: InputMaybe<Scalars['Float']['input']>;
  readFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationResponse = {
  __typename?: 'NotificationResponse';
  audience?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  linkAddress?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  menu?: Maybe<Scalars['String']['output']>;
  notificationId?: Maybe<Scalars['Float']['output']>;
  notificationType?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  readDate?: Maybe<Scalars['String']['output']>;
  readFlag?: Maybe<Scalars['Boolean']['output']>;
  templateData?: Maybe<Scalars['String']['output']>;
  templateText?: Maybe<Scalars['String']['output']>;
};

export type NotificationTemplateInput = {
  insertUser?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateText?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationTemplateResponse = {
  __typename?: 'NotificationTemplateResponse';
  response?: Maybe<Scalars['String']['output']>;
};

export type NotificationUpdateResponse = {
  __typename?: 'NotificationUpdateResponse';
  response?: Maybe<Scalars['String']['output']>;
};

export type ObjectClass = {
  __typename?: 'ObjectClass';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  updateAction?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  userObjectClass?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type ObjectClassInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  phraseId?: InputMaybe<Scalars['String']['input']>;
  updateAction?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
  userObjectClass?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['Float']['input']>;
};

export type ObtChannelFormat = {
  __typename?: 'ObtChannelFormat';
  category?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Array<Scalars['String']['output']>>;
  companyCode?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Array<Scalars['String']['output']>>;
  invProcess?: Maybe<Array<Scalars['String']['output']>>;
  provider?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['String']['output']>;
};

export type ObtContactResponse = {
  __typename?: 'ObtContactResponse';
  aenderungDatum?: Maybe<Scalars['String']['output']>;
  aenderungUser?: Maybe<Scalars['String']['output']>;
  anlageDatum?: Maybe<Scalars['String']['output']>;
  anlageUser?: Maybe<Scalars['String']['output']>;
  companycode?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id_partner?: Maybe<Scalars['Int']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type ObtPartnerAddress = {
  __typename?: 'ObtPartnerAddress';
  aenderungDatum?: Maybe<Scalars['String']['output']>;
  aenderungUser?: Maybe<Scalars['String']['output']>;
  anlageDatum?: Maybe<Scalars['String']['output']>;
  anlageUser?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countrycode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  partnername?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pobox?: Maybe<Scalars['String']['output']>;
  postalcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  registercourt?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
};

export type ObtPartnerChannel = {
  __typename?: 'ObtPartnerChannel';
  aenderungDatum?: Maybe<Scalars['String']['output']>;
  aenderungUser?: Maybe<Scalars['String']['output']>;
  anlageDatum?: Maybe<Scalars['String']['output']>;
  anlageUser?: Maybe<Scalars['String']['output']>;
  channeltype?: Maybe<Scalars['String']['output']>;
  companycode?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  eskerOnboarded?: Maybe<Scalars['Boolean']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  formatVersion?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idpartner?: Maybe<Scalars['Int']['output']>;
  invprocess?: Maybe<Scalars['String']['output']>;
  newProcess?: Maybe<Scalars['Boolean']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  routeId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  validfrom?: Maybe<Scalars['String']['output']>;
  validto?: Maybe<Scalars['String']['output']>;
};

export type ObtPartnerCompany = {
  __typename?: 'ObtPartnerCompany';
  aenderungDatum?: Maybe<Scalars['String']['output']>;
  aenderungUser?: Maybe<Scalars['String']['output']>;
  anlageDatum?: Maybe<Scalars['String']['output']>;
  anlageUser?: Maybe<Scalars['String']['output']>;
  aparpartnerlink?: Maybe<Scalars['String']['output']>;
  cbuno?: Maybe<Scalars['String']['output']>;
  companycode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idpartner?: Maybe<Scalars['Int']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
};

export type ObtPartnerDetailResponse = {
  __typename?: 'ObtPartnerDetailResponse';
  partnerAddress?: Maybe<ObtPartnerAddress>;
  partnerChannel?: Maybe<Array<ObtPartnerChannel>>;
  partnerCompany?: Maybe<ObtPartnerCompany>;
  partnerContact?: Maybe<Array<IObtContactModel>>;
  partnerDoc?: Maybe<Array<ObtPartnerDoc>>;
  partnerLegal?: Maybe<Array<ObtPartnerLegal>>;
  partnerMain?: Maybe<ObtPartnerMain>;
  partnerRun?: Maybe<Array<ObtPartnerRun>>;
  partnerVatcode?: Maybe<Array<ObtPartnerVatcode>>;
};

export type ObtPartnerDoc = {
  __typename?: 'ObtPartnerDoc';
  aenderungDatum?: Maybe<Scalars['String']['output']>;
  aenderungUser?: Maybe<Scalars['String']['output']>;
  anlageDatum?: Maybe<Scalars['String']['output']>;
  anlageUser?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  companycode?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invType?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type ObtPartnerLegal = {
  __typename?: 'ObtPartnerLegal';
  codicedest?: Maybe<Scalars['String']['output']>;
  hstcode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idpartner?: Maybe<Scalars['Int']['output']>;
  leitwegsEmail?: Maybe<Scalars['String']['output']>;
  leitwegsId?: Maybe<Scalars['String']['output']>;
  localcode?: Maybe<Scalars['String']['output']>;
  pecaddress?: Maybe<Scalars['String']['output']>;
  peppolId?: Maybe<Scalars['String']['output']>;
};

export type ObtPartnerMain = {
  __typename?: 'ObtPartnerMain';
  activity?: Maybe<Scalars['String']['output']>;
  blockReason?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  masterpartnerno?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  systemid?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type ObtPartnerRun = {
  __typename?: 'ObtPartnerRun';
  companycode?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  estimateOnboardingDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idpartner?: Maybe<Scalars['Int']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  startOnboarding?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  wave?: Maybe<Scalars['String']['output']>;
};

export type ObtPartnerVatNipCodeResult = {
  __typename?: 'ObtPartnerVatNipCodeResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ObtPartnerVatcode = {
  __typename?: 'ObtPartnerVatcode';
  aenderungDatum?: Maybe<Scalars['String']['output']>;
  aenderungUser?: Maybe<Scalars['String']['output']>;
  anlageDatum?: Maybe<Scalars['String']['output']>;
  anlageUser?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  vatcode?: Maybe<Scalars['String']['output']>;
};

export type ObtPeppolData = {
  __typename?: 'ObtPeppolData';
  country?: Maybe<Scalars['String']['output']>;
  icdcode?: Maybe<Scalars['String']['output']>;
  schemeid?: Maybe<Scalars['String']['output']>;
  schemename?: Maybe<Scalars['String']['output']>;
  valididlength?: Maybe<Scalars['Int']['output']>;
};

export type ObtSurveyDetails = {
  __typename?: 'ObtSurveyDetails';
  agreementAcceptedDate?: Maybe<Scalars['String']['output']>;
  agreementApproverEmail?: Maybe<Scalars['String']['output']>;
  agreementApproverName?: Maybe<Scalars['String']['output']>;
  agreementDownloaded?: Maybe<Scalars['Boolean']['output']>;
  agreementStatusDate?: Maybe<Scalars['String']['output']>;
  agreementStatusId?: Maybe<Scalars['Int']['output']>;
  agreementType?: Maybe<Scalars['String']['output']>;
  agreementTypeId?: Maybe<Scalars['Int']['output']>;
  apArPartnerLink?: Maybe<Scalars['String']['output']>;
  assignedPartnerUserId?: Maybe<Scalars['Int']['output']>;
  assignedPartnerUserName?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelReasonPhraseId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  channelDataAcceptedDate?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['Int']['output']>;
  confirmedGoLiveDate?: Maybe<Scalars['String']['output']>;
  connectivityInfoDate?: Maybe<Scalars['String']['output']>;
  connectivityUpdateTime?: Maybe<Scalars['String']['output']>;
  contactVolume?: Maybe<Scalars['Int']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  dateSurveySentToProvider?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  masterDataAcceptedDate?: Maybe<Scalars['String']['output']>;
  masterDataInsertTime?: Maybe<Scalars['String']['output']>;
  masterPartnerNo?: Maybe<Scalars['String']['output']>;
  otSurveyStatus?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  provisionalGoLiveDate?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  surveyActiveStatus?: Maybe<Scalars['Boolean']['output']>;
  surveyId?: Maybe<Scalars['Int']['output']>;
  surveyRequest?: Maybe<Scalars['String']['output']>;
  surveySentDate?: Maybe<Scalars['String']['output']>;
  surveySentToProvider?: Maybe<Scalars['Boolean']['output']>;
  surveyStartDate?: Maybe<Scalars['String']['output']>;
  surveyStatus?: Maybe<Scalars['String']['output']>;
  surveyStatusId?: Maybe<Scalars['Int']['output']>;
  surveySubmissionDate?: Maybe<Scalars['String']['output']>;
  surveyType?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  technicalContactEmail?: Maybe<Scalars['String']['output']>;
  technicalContactName?: Maybe<Scalars['String']['output']>;
  technicalContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  waveId?: Maybe<Scalars['String']['output']>;
};

export type ObtSurveyDetailsResponse = {
  __typename?: 'ObtSurveyDetailsResponse';
  surveyList?: Maybe<Array<ObtSurveyDetails>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ObtUserRestriction = {
  __typename?: 'ObtUserRestriction';
  companyCode?: Maybe<Scalars['String']['output']>;
  departmentCode?: Maybe<Scalars['String']['output']>;
  legalTabName?: Maybe<Scalars['String']['output']>;
};

export type ObtVatNipInfo = {
  __typename?: 'ObtVatNipInfo';
  countrycode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  vatcode?: Maybe<Scalars['String']['output']>;
};

export type OnbPartnerChannel = {
  __typename?: 'OnbPartnerChannel';
  channeltype: Scalars['String']['output'];
  companycode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idpartner: Scalars['Float']['output'];
  invprocess: Scalars['String']['output'];
  partnerno: Scalars['String']['output'];
  validto: Scalars['String']['output'];
};

export type OnbRouteChannelFormats = {
  __typename?: 'OnbRouteChannelFormats';
  channels?: Maybe<Array<OnbRoutesChannel>>;
  formats?: Maybe<Array<OnbRoutesFormats>>;
};

export type OnbRoutesChannel = {
  __typename?: 'OnbRoutesChannel';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

export type OnbRoutesFormats = {
  __typename?: 'OnbRoutesFormats';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
};

export type OpValue = {
  cacheKey?: InputMaybe<Scalars['String']['input']>;
  empty?: InputMaybe<Scalars['Boolean']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  opCode?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OverdueTrendPoint = {
  __typename?: 'OverdueTrendPoint';
  month: Scalars['String']['output'];
  overdueCount: Scalars['Int']['output'];
};

export type Partner = {
  __typename?: 'Partner';
  category?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyIds?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['Float']['output']>;
  partnerId: Scalars['Float']['output'];
  partnerName: Scalars['String']['output'];
  partnerNo: Scalars['String']['output'];
  processes?: Maybe<Array<Process>>;
};

export type PartnerAddressData = {
  __typename?: 'PartnerAddressData';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  pobox?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  postalcodePobox?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type PartnerVatCodes = {
  __typename?: 'PartnerVATCodes';
  country?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerVatId?: Maybe<Scalars['Float']['output']>;
  vatCode?: Maybe<Scalars['String']['output']>;
};

export type PartnerWithVatCodes = {
  __typename?: 'PartnerWithVATCodes';
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  vatCodes?: Maybe<Array<PartnerVatCodes>>;
};

export type PendingDocument = {
  __typename?: 'PendingDocument';
  amount?: Maybe<Scalars['Float']['output']>;
  area?: Maybe<Scalars['String']['output']>;
  areaId?: Maybe<Scalars['Float']['output']>;
  azContainerName?: Maybe<Scalars['String']['output']>;
  azDownloadFileName?: Maybe<Scalars['String']['output']>;
  azItemPathName?: Maybe<Scalars['String']['output']>;
  azStorageType?: Maybe<Scalars['String']['output']>;
  blobId?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dateReceived?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['Float']['output']>;
  downloadLink?: Maybe<Scalars['String']['output']>;
  downloaded?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  filePrefix?: Maybe<Scalars['String']['output']>;
  insertTs?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  logObjId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  updatetime?: Maybe<Scalars['String']['output']>;
};

export type PortalUser = IPortalUser & {
  __typename?: 'PortalUser';
  departmentnumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  insert_time?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
  realm?: Maybe<Scalars['String']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  role_id?: Maybe<Scalars['Float']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  uid?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type PortalUserExtended = {
  __typename?: 'PortalUserExtended';
  bmwUniqueUid?: Maybe<Scalars['String']['output']>;
  bmwUniqueUidQ?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  employeeType?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  loginName?: Maybe<Scalars['String']['output']>;
  objectClass?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type PortalUserInput = {
  bmwUniqueUid?: InputMaybe<Scalars['String']['input']>;
  bmwUniqueUidQ?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employe?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  loginName?: InputMaybe<Scalars['String']['input']>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  role_id?: InputMaybe<Scalars['Float']['input']>;
  user_id?: InputMaybe<Scalars['Float']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type PortalWebEamConfig = {
  __typename?: 'PortalWebEAMConfig';
  defaultRealm?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Portion = {
  __typename?: 'Portion';
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canSubmit?: Maybe<Scalars['Boolean']['output']>;
  canUpdate?: Maybe<Scalars['Boolean']['output']>;
  issues?: Maybe<Array<Scalars['String']['output']>>;
  portionName?: Maybe<Scalars['String']['output']>;
  portionSequence?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['Float']['output']>;
};

export type Preferences = {
  __typename?: 'Preferences';
  dateFormat?: Maybe<Scalars['String']['output']>;
  decimalSeparator?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  thousandSeparator?: Maybe<Scalars['String']['output']>;
  userSettingsId?: Maybe<Scalars['Float']['output']>;
};

export type Process = {
  __typename?: 'Process';
  phraseId: Scalars['String']['output'];
  processCode: Scalars['String']['output'];
  processCodeId: Scalars['Float']['output'];
  processName: Scalars['String']['output'];
};

export type ProcessingMetricsSummary = {
  __typename?: 'ProcessingMetricsSummary';
  avgTransitDays: Scalars['Float']['output'];
  inTransitCount: Scalars['Int']['output'];
  onTimeRate: Scalars['Float']['output'];
  stpRate: Scalars['Float']['output'];
};

export type PurchaseOderLineItem = {
  __typename?: 'PurchaseOderLineItem';
  busArea?: Maybe<Scalars['String']['output']>;
  changedate?: Maybe<Scalars['String']['output']>;
  contactGrEmail?: Maybe<Scalars['String']['output']>;
  contactGrName?: Maybe<Scalars['String']['output']>;
  deliveryNoteDate?: Maybe<Scalars['String']['output']>;
  deliveryaddress?: Maybe<Scalars['String']['output']>;
  headId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoiceQuantity?: Maybe<Scalars['String']['output']>;
  invoicedValue?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  materialText?: Maybe<Scalars['String']['output']>;
  nettitemvalue?: Maybe<Scalars['String']['output']>;
  openQuantity?: Maybe<Scalars['String']['output']>;
  openValue?: Maybe<Scalars['String']['output']>;
  plantName?: Maybe<Scalars['String']['output']>;
  poItem?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  pounit?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  DraftDocumentList?: Maybe<Array<DraftList>>;
  OAuth_getWebEamConfiguration?: Maybe<PortalWebEamConfig>;
  OAuth_getWebEamSessionLogoutUrl?: Maybe<Scalars['String']['output']>;
  OAuth_getWebEamUserInfo?: Maybe<WebEamUserInfo>;
  OAuth_getWebEamValidateToken?: Maybe<Scalars['Boolean']['output']>;
  PortalUser_getPortalUserInfoByEmail?: Maybe<PortalUser>;
  Portal_AddSurveyData?: Maybe<Array<SurveySummaryData>>;
  Portal_GetSurveyContactMasterData?: Maybe<Array<SurveyPartnerContactsData>>;
  Portal_GetSurveyData?: Maybe<Array<SurveySummaryData>>;
  Portal_GetSurveyPartnerMasterData?: Maybe<Array<SurveyMasterData>>;
  Portal_getSurveyChannels?: Maybe<Array<SurveyChannelResponse>>;
  allActivePartnerCountryDetail?: Maybe<EimDashboardCountryDetailResponse>;
  allActivePartnerCountryMetrics?: Maybe<Array<CountryMetricsSummary>>;
  allActivePartnerData?: Maybe<Array<EimDashboardActivePartnerResponse>>;
  allActivePartnerDataDownload?: Maybe<EimDashboardActivePartnerResponse>;
  allActivePartnerInvoiceHourlyTrend?: Maybe<Array<EimDashboardPartnerInvoiceHourlyTrendResponse>>;
  allActivePartnerInvoiceSummary?: Maybe<Array<EimDashboardPartnerInvoiceSummaryResponse>>;
  allCompaniesByPartnerNumber?: Maybe<Array<AssignedCompany>>;
  allCompaniesForEntitlement?: Maybe<Array<EntitledCompany>>;
  allCompaniesForUser?: Maybe<Array<AssignedCompany>>;
  allCompanyInfoByCompanyPartnerId?: Maybe<Array<CompanyInfo>>;
  allPartnersByPartnerNo?: Maybe<Array<AssignedPartner>>;
  allPartnersForUser?: Maybe<Array<Partner>>;
  allProcessCode?: Maybe<Array<SelectDropdowns>>;
  allProcessCodeByUser?: Maybe<Array<Process>>;
  allVatCodesByCompanyId?: Maybe<Array<VatCodes>>;
  countAllActivePartnerData?: Maybe<EimDashboardActivePartnerCountResponse>;
  countEIMInvoices?: Maybe<EimMonitoringGridResponse>;
  createConfirmationOfArrivalPDF: GeneratedPdf;
  deleteSapSystemConfig?: Maybe<SapSystemUpdate>;
  downloadDocument: DocumentDownloadResponse;
  downloadDocumentEcap: DocumentDownloadResponses;
  downloadDocumentEcapTLogInfo: DocumentDownloadResponses;
  downloadECapDocument: SurveyDocumentResponse;
  downloadMultipleDocument: DocumentDownloadResponse;
  downloadSurveyDocument: SurveyDocumentResponse;
  downloadUserGuideDocument: UserGuideDocumentResponse;
  eimExecutiveDashboard?: Maybe<EimExecutiveDashboardResponse>;
  eimExecutiveDashboardChannelMetrics: Array<ChannelMetricsSummary>;
  eimExecutiveDashboardCountryMetrics: Array<CountryMetricsSummary>;
  eimExecutiveDashboardFlowStageMetrics: Array<FlowStageMetricsSummary>;
  eimExecutiveDashboardGroupMetrics: Array<GroupMetricsSummary>;
  eimExecutiveDashboardSystemMetrics: Array<SystemMetricsSummary>;
  eimExecutiveDashboardTopFailureCompanyCodes: Array<TopFailureCompanySummary>;
  eimExecutiveDashboardTopFailureProcesses: Array<TopFailureProcessSummary>;
  eimExecutiveDashboardTopFailureReasons: Array<FailureReasonSummary>;
  eimExecutiveDashboardV2CountryDetail?: Maybe<EimDashboardCountryDetailResponse>;
  eimExecutiveDashboardV2CountryMetrics?: Maybe<Array<CountryMetricsSummary>>;
  findCR1ReportResults?: Maybe<Array<Cr1Response>>;
  findCZReport?: Maybe<Array<CzResponse>>;
  findLY4Report?: Maybe<Array<RevaluationHeadDto>>;
  findLY5Report?: Maybe<Array<Ly5Response>>;
  findLY6Report?: Maybe<Array<Ly6Response>>;
  findLY7Report?: Maybe<Array<Ly7Response>>;
  findNR5ReportResults?: Maybe<Array<Sr5Response>>;
  findPaymentReportResults?: Maybe<Array<Sr4Response>>;
  findSR1ReportResults?: Maybe<Array<Sr1Response>>;
  findSR2ReportResults?: Maybe<Array<Sr2Response>>;
  findSR5ReportResults?: Maybe<Array<Sr5Response>>;
  findTNR1ReportResults?: Maybe<Array<CommissionHeader>>;
  getAgreementHistory: EcapAgreementHistory;
  getAgreementHistoryV2: EcapAgreementHistory;
  getAgreementInfo: Array<EcapAgreementInfo>;
  getAllBanners?: Maybe<Array<BannerAllResponse>>;
  getAllDocumentTypes?: Maybe<Array<SelectDocType>>;
  getAllEntitlements: Array<Entitlement>;
  getAllLegalFormTypes?: Maybe<Array<LegalFormType>>;
  getAllMessagesFilters?: Maybe<EimMessagesFilters>;
  getAllNotificationsInTable?: Maybe<Array<GetAllNotificationsInTableResponse>>;
  getAllPortalUsers?: Maybe<Array<PortalUser>>;
  getAllUnitOfMeasureValues?: Maybe<Array<UnitOfMeasure>>;
  getAllUserGuideGroups: Array<UserGuideGroup>;
  getAllUserGuides: Array<UserGuide>;
  getAllUserRights?: Maybe<Array<UserRightsOutput>>;
  getB2XRoles: Array<B2xRoles>;
  getBannerDetailsData?: Maybe<Array<BannerDetailsResponse>>;
  getBusinessAreaList?: Maybe<Array<BusinessArea>>;
  getBusinessUnitList?: Maybe<Array<BusinessUnit>>;
  getCFOReporting: CfoReportingResponse;
  getCompanyAddressDetailsByCompanyId?: Maybe<Array<CompanyAddress>>;
  getCompanyDefaultTaxId?: Maybe<CompanyDefaultTaxId>;
  getCompanyInfoByCompanyPartnerNo?: Maybe<CompanyInfo>;
  getCompanyInfoByCompanyPartnerNoCategory?: Maybe<CompanyInfo>;
  getConnectivityPeppolDetailsForSurvey: Array<SurveyConnectivityPeppolResponse>;
  getConnectivityTestFileReport: Array<SurveyConnectivityTestFileReport>;
  getCountryInfo?: Maybe<CountryCode>;
  getCountryList?: Maybe<Array<CountryCode>>;
  getCurrencyList?: Maybe<Array<CurrencyCode>>;
  getDashCardCount?: Maybe<EimDashboardCardsResponse>;
  getDefaultChannelFormat?: Maybe<DocumentFormatChannelData>;
  getDefaultProcessCodes?: Maybe<Array<DocumentProcessCode>>;
  getDocumentFormat?: Maybe<Array<SelectFormat>>;
  getDocumentRecord?: Maybe<DocumentRecord>;
  getDocumentStatus?: Maybe<Array<SelectStatus>>;
  getDocumentTemplateDropdown?: Maybe<Array<DocumentTemplateDropdownResult>>;
  getDocumentUserEntitlementResultByUserId?: Maybe<UserEntitlementResult>;
  getDocumentsCount: DocumentCount;
  getDownloadedRejectionLetters: Array<DownloadedRejectionLetter>;
  getDuplicateDocumentNumberFlag?: Maybe<DuplicateDocNoWarningFlag>;
  getEAICreatedDocumentDetailList?: Maybe<Array<EcapCreatedDocument>>;
  getEIMInvoices?: Maybe<EimMonitoringGridResponse>;
  getEcapSelfEntitlementResultByFilter?: Maybe<EcapUserEntitlementResult>;
  getEcapUserCaptureEntitlementResultByUserId?: Maybe<EcapUserEntitlementResult>;
  getEcapUserEntitlementResultByUserId?: Maybe<UserEntitlementResult>;
  getEntitlementAuditReport: Array<EntitlementAuditReport>;
  getEntitlementGroupList: Array<EntitlementGroup>;
  getEntitlementReport: Array<EntitlementReport>;
  getEntitlementReportByRuleIds: Array<EntitlementReport>;
  getEntitlementRules: Array<EntitlementRule>;
  getFilteredDocumentTypes?: Maybe<Array<SelectDocType>>;
  getFilteredRulesWithRuleType?: Maybe<Array<Rules>>;
  getFilteredRulesWithTypeSubType?: Maybe<Array<Rules>>;
  getFsmPartnerDocsList?: Maybe<Array<DocList>>;
  getFullLogInfoErrorReport?: Maybe<Array<LogInfoErrorView>>;
  getGoLiveDates?: Maybe<GoLiveResponse>;
  getIncomingDocuments: Array<IncomingDocuments>;
  getIncomingDocumentsSummary: Array<IncomingDocumentsSummary>;
  getKPIUsageForInfoPortal: Array<KpiAggregatesResponse>;
  getLdapPartnerResultByPartnerNo?: Maybe<Array<LdapPartnerResult>>;
  getLdapUserResultByUserId?: Maybe<LdapUserResult>;
  getLogInfoDocumentCount?: Maybe<Scalars['Float']['output']>;
  getLogInfoErrors?: Maybe<Array<LogInfoData>>;
  getMissingInvoicesDocsList: Array<MissingInvoice>;
  getMissingInvoicesDocsListGrouped: Array<MissingInvoiceGrouped>;
  getNotificationCount?: Maybe<NotificationCountResponse>;
  getNotificationEntitlementsDropdown?: Maybe<Array<SelectNotificationEntitlementsDropdownResponse>>;
  getNotificationTemplateNamesDropDown?: Maybe<Array<SelectNotificationTemplateNameDropdownResponse>>;
  getNotificationTemplateText?: Maybe<Array<SelectNotificationTemplateTextResponse>>;
  getNotifications?: Maybe<Array<NotificationResponse>>;
  getObjectClassList: Array<ObjectClass>;
  getPartnerAddressByPartnerId?: Maybe<Array<PartnerAddressData>>;
  getPartnerByCompanyPartnerId?: Maybe<CompanyPartner>;
  getPartnerDocsList?: Maybe<Array<DocList>>;
  getPartnerDocuments?: Maybe<Array<Document>>;
  getPartnerForUser?: Maybe<Array<Partner>>;
  getPartnerLinks?: Maybe<Array<EntitlementPartnerWithDetail>>;
  getPartnerVATInfoByPartnerNo?: Maybe<PartnerWithVatCodes>;
  getPartnerVATInfoByPartnerNoCodSystemCodeCategories?: Maybe<PartnerWithVatCodes>;
  getPartnersByCompanyCodesAndFilter?: Maybe<Array<EntitledPartner>>;
  getPendingDocuments: Array<PendingDocument>;
  getPortalUser?: Maybe<Array<PortalUser>>;
  getProcessCodeName?: Maybe<Array<SurveyDocumentProcessChannelCodeResponse>>;
  getProcessCodes?: Maybe<Array<SelectProcessCode>>;
  getProviderDocumentType?: Maybe<Array<SelectDocType>>;
  getRegionInfo?: Maybe<RegionCode>;
  getRegionList?: Maybe<Array<RegionCode>>;
  getSapSystemConfig: Array<SapSystemUpdate>;
  getSelectDropDown?: Maybe<Array<SelectDropdowns>>;
  getSelectDropDownFromCoCodeEntitlement?: Maybe<Array<SelectDropdowns>>;
  getSelfEntitlementResultByFilter?: Maybe<UserEntitlementResult>;
  getSummaryLogInfoErrorReport?: Maybe<Array<TLogInfoSummaryData>>;
  getSurveyAgreementApprovalData?: Maybe<SurveyAgreementApprovalData>;
  getSurveyAgreementDocList?: Maybe<Array<SurveyAgreementDocList>>;
  getSurveyAgreementStatusList?: Maybe<Array<SurveyAgreementStatusList>>;
  getSurveyConnectivityAs2?: Maybe<Array<SurveyAgreementConnectivityAs2Response>>;
  getSurveyConnectivityOftp2BySurvey?: Maybe<Array<SurveyConnectivityOftp2Response>>;
  getSurveyConnectivitySmtpBySurvey?: Maybe<Array<SurveyConnectivitySmtpResponse>>;
  getSurveyConnectivityVda?: Maybe<Array<SurveyConnectivityVdaiResponse>>;
  getSurveyContactByType?: Maybe<Array<SurveyContactResponse>>;
  getSurveyList?: Maybe<Array<SurveyOverviewList>>;
  getSurveyManagementList?: Maybe<Array<SurveyManagementListResponse>>;
  getSurveyStatusList?: Maybe<Array<SurveyStatusSelectDropdowns>>;
  getSurveyVerifyReport?: Maybe<SurveyVerifyOutput>;
  getTableData: Array<TableDataResponse>;
  getTableMetaData: Array<TableMetaData>;
  getTaxExemptions?: Maybe<Array<ExemptionType>>;
  getTaxLawReferences?: Maybe<Array<TaxLawReference>>;
  getTemplateDocumentList?: Maybe<Array<TemplateList>>;
  getTemplatePartnerCount?: Maybe<Scalars['Float']['output']>;
  getTranslationByPhraseIDAndLanguage?: Maybe<TranslationResponse>;
  getTranslations?: Maybe<Array<TranslationResponse>>;
  getUnavailableDocsVolume: UnavailableVolume;
  getUploadDocumentsForBordero?: Maybe<Array<BorderoUploadDocument>>;
  getUserEntitlementResultByUserId?: Maybe<UserEntitlementResult>;
  getUserEntitlementResultByUserIdAndEntitlement?: Maybe<UserEntitlementResult>;
  getUserEntitlementResultByUserIdAndFilter?: Maybe<UserEntitlementResult>;
  getUserGuide?: Maybe<UserGuide>;
  getUserGuideUploadLanguages?: Maybe<UserGuideLanguages>;
  getUserGuidesDocList?: Maybe<Array<UserGuidesDocList>>;
  infoPortalSelect?: Maybe<Array<DropDown>>;
  listBorderosForCarrier?: Maybe<GenericEntityListBorderoEdpData>;
  listProcessCodes?: Maybe<Array<SelectProcessCode>>;
  obtDownloadPartnerDetails: Scalars['String']['output'];
  obtDownloadSurveyExcel?: Maybe<Scalars['String']['output']>;
  obtDownloadSurveyPartnerChannelDetails?: Maybe<Array<ObtPartnerChannel>>;
  obtDownloadSurveyPartnerContactDetails?: Maybe<Array<IObtContactModel>>;
  obtDownloadSurveyPartnerData?: Maybe<ObtSurveyDetailsResponse>;
  obtExistingPartnerContacts?: Maybe<Array<ObtContactResponse>>;
  obtGetConfigAddress?: Maybe<Array<IObtConfigAddressModel>>;
  obtGetConfigBank?: Maybe<Array<IObtConfigBankModel>>;
  obtGetConfigCommon?: Maybe<Array<IObtConfigCommonModel>>;
  obtGetObtChannelData: Array<ObtChannelFormat>;
  obtGetObtPeppolData?: Maybe<Array<ObtPeppolData>>;
  obtGetPartnerDetails?: Maybe<ObtPartnerDetailResponse>;
  obtGetPartnerLegalVatNipInfo?: Maybe<ObtVatNipInfo>;
  obtGetSearchSelectionOptions?: Maybe<IObtSearchSelectOption>;
  obtGetUserRestriction?: Maybe<Array<ObtUserRestriction>>;
  obtGetUserRole: Scalars['String']['output'];
  obtGetWaves?: Maybe<Array<IObtConfigWaveModel>>;
  obtRefreshPartnerChannelsDetails?: Maybe<Array<ObtPartnerChannel>>;
  obtRefreshPartnerContactDetails?: Maybe<Array<IObtContactModel>>;
  obtSearchSurvey?: Maybe<ObtSurveyDetailsResponse>;
  obtSearchSurveyHistory?: Maybe<Array<ObtSurveyDetails>>;
  obtSearchSurveyHistoryByCompanyCodePartnerNo?: Maybe<Array<ObtSurveyDetails>>;
  reprocessDocumentsIncoming: ReprocessResponse;
  retrieveDocumentByBlobIdAndApplicationType: SurveyDocumentResponse;
  retrieveInvoicesReport?: Maybe<Array<InvoiceHeadDto>>;
  retrieveRejectionLetterByURL: SurveyDocumentValue;
  retrieveSupportingDocuments?: Maybe<Array<SupportingDocumentResponse>>;
  searchPortalUsers?: Maybe<Array<PortalUserExtended>>;
  updateSapSystemConfig: SapSystemUpdate;
  userPreferences?: Maybe<Array<DisplayPreference>>;
  validateUser?: Maybe<ValidateUserResponse>;
};


export type QueryDraftDocumentListArgs = {
  draftListInput: DraftListInput;
};


export type QueryOAuth_GetWebEamConfigurationArgs = {
  realm: Scalars['String']['input'];
};


export type QueryOAuth_GetWebEamSessionLogoutUrlArgs = {
  realm: Scalars['String']['input'];
  tokenId: Scalars['String']['input'];
};


export type QueryOAuth_GetWebEamUserInfoArgs = {
  token: Scalars['String']['input'];
};


export type QueryOAuth_GetWebEamValidateTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryPortalUser_GetPortalUserInfoByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryPortal_AddSurveyDataArgs = {
  groupId: Scalars['String']['input'];
  surveyIds: Array<SurveyMasterDataType>;
};


export type QueryPortal_GetSurveyContactMasterDataArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryPortal_GetSurveyDataArgs = {
  groupId: Scalars['String']['input'];
  surveyIds: Array<SurveyMasterDataType>;
};


export type QueryPortal_GetSurveyPartnerMasterDataArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryPortal_GetSurveyChannelsArgs = {
  companyCode: Scalars['String']['input'];
  partnerType: Scalars['String']['input'];
  surveyId: Scalars['Float']['input'];
};


export type QueryAllActivePartnerCountryDetailArgs = {
  request: EimDashboardRequest;
};


export type QueryAllActivePartnerCountryMetricsArgs = {
  request: EimDashboardRequest;
};


export type QueryAllActivePartnerDataArgs = {
  request: EimDashboardRequest;
};


export type QueryAllActivePartnerDataDownloadArgs = {
  request: EimDashboardRequest;
};


export type QueryAllActivePartnerInvoiceHourlyTrendArgs = {
  request: EimDashboardRequest;
};


export type QueryAllActivePartnerInvoiceSummaryArgs = {
  request: EimDashboardRequest;
};


export type QueryAllCompaniesByPartnerNumberArgs = {
  partnerno: Scalars['String']['input'];
  rolename: Scalars['String']['input'];
};


export type QueryAllCompaniesForEntitlementArgs = {
  entitlement: Scalars['String']['input'];
};


export type QueryAllCompaniesForUserArgs = {
  userId: Scalars['Float']['input'];
};


export type QueryAllCompanyInfoByCompanyPartnerIdArgs = {
  companyCode: Scalars['String']['input'];
  partnerId: Scalars['Float']['input'];
};


export type QueryAllPartnersByPartnerNoArgs = {
  partnerNo: Scalars['String']['input'];
};


export type QueryAllPartnersForUserArgs = {
  userId: Scalars['Float']['input'];
};


export type QueryAllProcessCodeByUserArgs = {
  userId: Scalars['Float']['input'];
};


export type QueryAllVatCodesByCompanyIdArgs = {
  companyId: Scalars['Float']['input'];
};


export type QueryCountEimInvoicesArgs = {
  env: Scalars['String']['input'];
  request: EimMonitoringGridRequest;
};


export type QueryCreateConfirmationOfArrivalPdfArgs = {
  input: Cr1PdfRequest;
  language: Scalars['String']['input'];
};


export type QueryDeleteSapSystemConfigArgs = {
  id: Scalars['Float']['input'];
};


export type QueryDownloadDocumentArgs = {
  documentDownloadInput: DocumentDownloadInput;
};


export type QueryDownloadDocumentEcapArgs = {
  documentDownloadInputs: Array<DocumentDownloadInputs>;
};


export type QueryDownloadDocumentEcapTLogInfoArgs = {
  documentDownloadInputs: Array<DocumentDownloadInputs>;
};


export type QueryDownloadECapDocumentArgs = {
  blobId: Scalars['Float']['input'];
};


export type QueryDownloadMultipleDocumentArgs = {
  documentDownloadInputs: Array<DocumentDownloadInput>;
};


export type QueryDownloadSurveyDocumentArgs = {
  blobId: Scalars['Float']['input'];
};


export type QueryDownloadUserGuideDocumentArgs = {
  blobId: Scalars['Float']['input'];
};


export type QueryEimExecutiveDashboardArgs = {
  request: EimExecutiveDashboardRequest;
};


export type QueryEimExecutiveDashboardChannelMetricsArgs = {
  request: EimExecutiveDashboardRequest;
};


export type QueryEimExecutiveDashboardCountryMetricsArgs = {
  request: EimExecutiveDashboardRequest;
};


export type QueryEimExecutiveDashboardFlowStageMetricsArgs = {
  request: EimExecutiveDashboardRequest;
};


export type QueryEimExecutiveDashboardGroupMetricsArgs = {
  request: EimExecutiveDashboardRequest;
};


export type QueryEimExecutiveDashboardSystemMetricsArgs = {
  request: EimExecutiveDashboardRequest;
};


export type QueryEimExecutiveDashboardTopFailureCompanyCodesArgs = {
  request: EimExecutiveDashboardRequest;
};


export type QueryEimExecutiveDashboardTopFailureProcessesArgs = {
  request: EimExecutiveDashboardRequest;
};


export type QueryEimExecutiveDashboardTopFailureReasonsArgs = {
  request: EimExecutiveDashboardRequest;
};


export type QueryEimExecutiveDashboardV2CountryDetailArgs = {
  request: EimExecutiveDashboardV2Request;
};


export type QueryEimExecutiveDashboardV2CountryMetricsArgs = {
  request: EimExecutiveDashboardV2Request;
};


export type QueryFindCr1ReportResultsArgs = {
  cr1Query: Cr1Filter;
};


export type QueryFindCzReportArgs = {
  czgenericFilter: CzGenericFilter;
  reportName: Scalars['String']['input'];
};


export type QueryFindLy4ReportArgs = {
  revaluationFilter: RevaluationFilter;
};


export type QueryFindLy5ReportArgs = {
  ly5Request: Ly6Request;
};


export type QueryFindLy6ReportArgs = {
  ly6Request: Ly6Request;
};


export type QueryFindLy7ReportArgs = {
  ly7Request: Ly7Request;
};


export type QueryFindNr5ReportResultsArgs = {
  nr5Query: Sr5Request;
};


export type QueryFindPaymentReportResultsArgs = {
  reportType: Scalars['String']['input'];
  sr4Query: Sr4Request;
};


export type QueryFindSr1ReportResultsArgs = {
  reportName: Scalars['String']['input'];
  sr1Query: Sr1Request;
};


export type QueryFindSr2ReportResultsArgs = {
  reportName: Scalars['String']['input'];
  sr2Query: Sr2Request;
};


export type QueryFindSr5ReportResultsArgs = {
  sr5Query: Sr5Request;
};


export type QueryFindTnr1ReportResultsArgs = {
  tnr1Query: CommissionFilterInput;
};


export type QueryGetAgreementHistoryArgs = {
  companyPartnerId: Scalars['Float']['input'];
};


export type QueryGetAgreementHistoryV2Args = {
  companyCode: Scalars['String']['input'];
  partnerNo: Scalars['String']['input'];
  systemCode: Scalars['String']['input'];
};


export type QueryGetAgreementInfoArgs = {
  category: Scalars['String']['input'];
  companyCode: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  moduleCode: Scalars['String']['input'];
};


export type QueryGetAllUserRightsArgs = {
  userId: Scalars['Float']['input'];
};


export type QueryGetCfoReportingArgs = {
  companyCode?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type QueryGetCompanyAddressDetailsByCompanyIdArgs = {
  addressType: Scalars['String']['input'];
  companyId: Scalars['Float']['input'];
};


export type QueryGetCompanyDefaultTaxIdArgs = {
  companyCode: Scalars['String']['input'];
  companyVatCountryCode: Scalars['String']['input'];
};


export type QueryGetCompanyInfoByCompanyPartnerNoArgs = {
  companyCode: Scalars['String']['input'];
  partnerNo: Scalars['String']['input'];
};


export type QueryGetCompanyInfoByCompanyPartnerNoCategoryArgs = {
  category: Scalars['String']['input'];
  companyCode: Scalars['String']['input'];
  partnerNo: Scalars['String']['input'];
  systemCode: Scalars['String']['input'];
};


export type QueryGetConnectivityPeppolDetailsForSurveyArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetConnectivityTestFileReportArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetCountryInfoArgs = {
  countryId: Scalars['String']['input'];
};


export type QueryGetDashCardCountArgs = {
  request: EimDashboardRequest;
};


export type QueryGetDefaultChannelFormatArgs = {
  companyCode: Scalars['String']['input'];
  direction: Scalars['String']['input'];
  partnerType: Scalars['String']['input'];
  processCode: Scalars['String']['input'];
};


export type QueryGetDefaultProcessCodesArgs = {
  companyCode: Scalars['String']['input'];
  partnerType: Scalars['String']['input'];
};


export type QueryGetDocumentRecordArgs = {
  documentId: Scalars['Float']['input'];
  mode: Scalars['String']['input'];
};


export type QueryGetDocumentUserEntitlementResultByUserIdArgs = {
  entitlement: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetDownloadedRejectionLettersArgs = {
  invoiceFilter: InvoiceFilter;
};


export type QueryGetDuplicateDocumentNumberFlagArgs = {
  documentNumberInput: Scalars['String']['input'];
  partnerNumberInput: Scalars['String']['input'];
};


export type QueryGetEaiCreatedDocumentDetailListArgs = {
  dataModel: DataModel;
  days: Scalars['Float']['input'];
  pageNumber: Scalars['Float']['input'];
  pageSize: Scalars['Float']['input'];
};


export type QueryGetEimInvoicesArgs = {
  env: Scalars['String']['input'];
  request: EimMonitoringGridRequest;
};


export type QueryGetEcapSelfEntitlementResultByFilterArgs = {
  entitlement: Scalars['String']['input'];
  pageNumber: Scalars['Float']['input'];
  pageSize: Scalars['Float']['input'];
  partnerName: Scalars['String']['input'];
};


export type QueryGetEcapUserCaptureEntitlementResultByUserIdArgs = {
  authentication: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetEcapUserEntitlementResultByUserIdArgs = {
  authentication: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetEntitlementAuditReportArgs = {
  entitlementFilter: EntitlementFilter;
};


export type QueryGetEntitlementReportArgs = {
  entitlementFilter: EntitlementFilter;
};


export type QueryGetEntitlementReportByRuleIdsArgs = {
  ruleIds: Array<Scalars['Float']['input']>;
};


export type QueryGetEntitlementRulesArgs = {
  ruleIds: Array<Scalars['Float']['input']>;
};


export type QueryGetFilteredDocumentTypesArgs = {
  entitlement: Scalars['String']['input'];
};


export type QueryGetFilteredRulesWithRuleTypeArgs = {
  ruleType: Scalars['String']['input'];
};


export type QueryGetFilteredRulesWithTypeSubTypeArgs = {
  ruleSubType: Scalars['String']['input'];
  ruleType: Scalars['String']['input'];
};


export type QueryGetFsmPartnerDocsListArgs = {
  docListInput: DocListInput;
};


export type QueryGetFullLogInfoErrorReportArgs = {
  days: Scalars['Float']['input'];
};


export type QueryGetGoLiveDatesArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetIncomingDocumentsArgs = {
  processError: Scalars['String']['input'];
};


export type QueryGetKpiUsageForInfoPortalArgs = {
  kpiQuery: KpiAggregatesQuery;
};


export type QueryGetLdapPartnerResultByPartnerNoArgs = {
  authentication: Scalars['String']['input'];
  partnerNo: Scalars['String']['input'];
};


export type QueryGetLdapUserResultByUserIdArgs = {
  authentication: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetLogInfoDocumentCountArgs = {
  days: Scalars['Float']['input'];
};


export type QueryGetLogInfoErrorsArgs = {
  dataModel: DataModel;
  days: Scalars['Float']['input'];
  pageNumber: Scalars['Float']['input'];
  pageSize: Scalars['Float']['input'];
  selectedProcessError: Scalars['String']['input'];
};


export type QueryGetMissingInvoicesDocsListArgs = {
  docListInput: DocListInput;
};


export type QueryGetMissingInvoicesDocsListGroupedArgs = {
  docListInput: DocListInput;
};


export type QueryGetNotificationTemplateTextArgs = {
  messageTemplateId: Scalars['String']['input'];
};


export type QueryGetPartnerAddressByPartnerIdArgs = {
  pageNumber: Scalars['Float']['input'];
  pageSize: Scalars['Float']['input'];
  partnerId: Scalars['Float']['input'];
};


export type QueryGetPartnerByCompanyPartnerIdArgs = {
  companyPartnerId: Scalars['Float']['input'];
};


export type QueryGetPartnerDocsListArgs = {
  docListInput: DocListInput;
};


export type QueryGetPartnerDocumentsArgs = {
  documentInput: DocumentInput;
};


export type QueryGetPartnerForUserArgs = {
  userId: Scalars['Float']['input'];
};


export type QueryGetPartnerLinksArgs = {
  entitlementPartnerInput: Array<EntitlementPartnerInput>;
};


export type QueryGetPartnerVatInfoByPartnerNoArgs = {
  companyCode: Scalars['String']['input'];
  partnerNo: Scalars['String']['input'];
};


export type QueryGetPartnerVatInfoByPartnerNoCodSystemCodeCategoriesArgs = {
  categories: Array<Scalars['String']['input']>;
  companyCode: Scalars['String']['input'];
  partnerNo: Scalars['String']['input'];
  systemCode: Scalars['String']['input'];
};


export type QueryGetPartnersByCompanyCodesAndFilterArgs = {
  companyCodes: Array<Scalars['String']['input']>;
  entitlement: Scalars['String']['input'];
  pageNumber: Scalars['Float']['input'];
  pageSize: Scalars['Float']['input'];
  partnerFilter: Scalars['String']['input'];
};


export type QueryGetPortalUserArgs = {
  portalUserInput: PortalUserInput;
};


export type QueryGetProcessCodeNameArgs = {
  processCodes: Array<SurveyDocumentProcessChannelCodeInput>;
};


export type QueryGetProviderDocumentTypeArgs = {
  serviceProviderId: Scalars['Float']['input'];
};


export type QueryGetRegionInfoArgs = {
  regionId: Scalars['String']['input'];
};


export type QueryGetSelectDropDownArgs = {
  select: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type QueryGetSelectDropDownFromCoCodeEntitlementArgs = {
  entitlement: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type QueryGetSelfEntitlementResultByFilterArgs = {
  entitlement: Scalars['String']['input'];
  listOfPartnerNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  pageNumber?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSummaryLogInfoErrorReportArgs = {
  days: Scalars['Float']['input'];
};


export type QueryGetSurveyAgreementApprovalDataArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetSurveyAgreementDocListArgs = {
  portalAgreementTypeId: Scalars['Float']['input'];
};


export type QueryGetSurveyConnectivityAs2Args = {
  groupId: Scalars['String']['input'];
};


export type QueryGetSurveyConnectivityOftp2BySurveyArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetSurveyConnectivitySmtpBySurveyArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetSurveyConnectivityVdaArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetSurveyContactByTypeArgs = {
  contactTypeId: Scalars['Float']['input'];
  groupId: Scalars['String']['input'];
};


export type QueryGetSurveyListArgs = {
  pageNumber: Scalars['Float']['input'];
  pageSize: Scalars['Float']['input'];
  surveyOverviewFilter: SurveyOverviewFilter;
};


export type QueryGetSurveyManagementListArgs = {
  surveyCriteriaType: SurveyCriteriaType;
};


export type QueryGetSurveyVerifyReportArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryGetTableDataArgs = {
  pageNumber?: Scalars['Float']['input'];
  pageSize?: Scalars['Float']['input'];
  tableNames: Array<Scalars['String']['input']>;
};


export type QueryGetTableMetaDataArgs = {
  tableNames: Array<Scalars['String']['input']>;
};


export type QueryGetTemplateDocumentListArgs = {
  templateListInput: TemplateListInput;
};


export type QueryGetTemplatePartnerCountArgs = {
  partnerNo: Scalars['String']['input'];
};


export type QueryGetTranslationByPhraseIdAndLanguageArgs = {
  languageCode: Scalars['String']['input'];
  phraseID: Scalars['String']['input'];
};


export type QueryGetTranslationsArgs = {
  languageCode: Scalars['String']['input'];
};


export type QueryGetUploadDocumentsForBorderoArgs = {
  request: BorderoUploadDocumentsQueryInput;
};


export type QueryGetUserEntitlementResultByUserIdArgs = {
  authRedirectURL: Scalars['String']['input'];
  authentication: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetUserEntitlementResultByUserIdAndEntitlementArgs = {
  entitlement: Scalars['String']['input'];
  pageNumber: Scalars['Float']['input'];
  pageSize: Scalars['Float']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetUserEntitlementResultByUserIdAndFilterArgs = {
  authentication: Scalars['String']['input'];
  entitlement: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type QueryGetUserGuideArgs = {
  id: Scalars['Float']['input'];
};


export type QueryInfoPortalSelectArgs = {
  query: DropDownQuery;
};


export type QueryListBorderosForCarrierArgs = {
  request: BorderoEdpFilter;
};


export type QueryListProcessCodesArgs = {
  select: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type QueryObtDownloadPartnerDetailsArgs = {
  filters: IObtSearchModel;
};


export type QueryObtDownloadSurveyExcelArgs = {
  criteria: IObtSurveySearchCriteriaInput;
};


export type QueryObtDownloadSurveyPartnerChannelDetailsArgs = {
  criteria: DownloadSurveyPartnerChannelInput;
};


export type QueryObtDownloadSurveyPartnerContactDetailsArgs = {
  criteria: DownloadSurveyPartnerContactInput;
};


export type QueryObtDownloadSurveyPartnerDataArgs = {
  criteria: IObtSurveySearchCriteriaInput;
};


export type QueryObtExistingPartnerContactsArgs = {
  contactsRequest: IObtExistingContactsRequestInput;
};


export type QueryObtGetObtChannelDataArgs = {
  category: Scalars['String']['input'];
  companyCode: Scalars['String']['input'];
  system: Scalars['String']['input'];
};


export type QueryObtGetObtPeppolDataArgs = {
  country: Scalars['String']['input'];
};


export type QueryObtGetPartnerDetailsArgs = {
  filters: IObtSearchModel;
};


export type QueryObtGetPartnerLegalVatNipInfoArgs = {
  idpartner: Scalars['Float']['input'];
  partnerno: Scalars['String']['input'];
};


export type QueryObtGetSearchSelectionOptionsArgs = {
  lang: Scalars['String']['input'];
};


export type QueryObtRefreshPartnerChannelsDetailsArgs = {
  filters: IObtSearchModel;
};


export type QueryObtRefreshPartnerContactDetailsArgs = {
  filters: IObtSearchModel;
};


export type QueryObtSearchSurveyArgs = {
  criteria: IObtSurveySearchCriteriaInput;
};


export type QueryObtSearchSurveyHistoryArgs = {
  surveyId: Scalars['Float']['input'];
};


export type QueryObtSearchSurveyHistoryByCompanyCodePartnerNoArgs = {
  category: Scalars['String']['input'];
  companyCode: Scalars['String']['input'];
  partnerNo: Scalars['String']['input'];
  systemCode: Scalars['String']['input'];
};


export type QueryRetrieveDocumentByBlobIdAndApplicationTypeArgs = {
  application: Scalars['String']['input'];
  blobId: Scalars['Float']['input'];
};


export type QueryRetrieveInvoicesReportArgs = {
  invoiceFilter: InvoiceFilter;
  reportName: Scalars['String']['input'];
};


export type QueryRetrieveRejectionLetterByUrlArgs = {
  fetchBlobRequest: FetchBlobRequest;
};


export type QueryRetrieveSupportingDocumentsArgs = {
  documentId: Scalars['String']['input'];
};


export type QuerySearchPortalUsersArgs = {
  portalUserInput: PortalUserInput;
};


export type QueryUpdateSapSystemConfigArgs = {
  input: SapSystemUpdateInput;
};


export type QueryUserPreferencesArgs = {
  preference: Scalars['String']['input'];
};

export type RegionCode = {
  __typename?: 'RegionCode';
  countryCode?: Maybe<CountryCode>;
  id: RegionId;
  phraseId?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type RegionId = {
  __typename?: 'RegionId';
  countryCode: Scalars['ID']['output'];
  regionCode: Scalars['ID']['output'];
};

export type ReprocessResponse = {
  __typename?: 'ReprocessResponse';
  success: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type RevaluationFilter = {
  compcode?: InputMaybe<Array<Scalars['String']['input']>>;
  language?: InputMaybe<Scalars['String']['input']>;
  overdueStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  partnerno?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseordernumber?: InputMaybe<OpValue>;
  revaltype?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  validitydateFrom?: InputMaybe<Scalars['String']['input']>;
  validitydateUntil?: InputMaybe<Scalars['String']['input']>;
};

export type RevaluationHeadDto = {
  __typename?: 'RevaluationHeadDTO';
  bmwdocnumber?: Maybe<Scalars['String']['output']>;
  changedon?: Maybe<Scalars['String']['output']>;
  compcode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  difference?: Maybe<Scalars['Float']['output']>;
  documentdate?: Maybe<Scalars['String']['output']>;
  extinvoice?: Maybe<Scalars['String']['output']>;
  grnumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  materialnumber?: Maybe<Scalars['String']['output']>;
  maxrows?: Maybe<Scalars['Float']['output']>;
  newnetamount?: Maybe<Scalars['Float']['output']>;
  oldnetamount?: Maybe<Scalars['Float']['output']>;
  overduestatus?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  poposition?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<RevaluationPositionDto>>;
  purchaseordernumber?: Maybe<Scalars['String']['output']>;
  revalnumber?: Maybe<Scalars['String']['output']>;
  revaltype?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type RevaluationPositionDto = {
  __typename?: 'RevaluationPositionDTO';
  currency?: Maybe<Scalars['String']['output']>;
  deliverynote?: Maybe<Scalars['String']['output']>;
  diffnet?: Maybe<Scalars['Float']['output']>;
  grnumber?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  materialtext?: Maybe<Scalars['String']['output']>;
  newnet?: Maybe<Scalars['Float']['output']>;
  oldnet?: Maybe<Scalars['Float']['output']>;
  revalnumber?: Maybe<Scalars['String']['output']>;
};

export type RiskSectionMetrics = {
  __typename?: 'RiskSectionMetrics';
  agingBuckets: Array<AgingBucket>;
  failedCount: Scalars['Int']['output'];
  failureRate: Scalars['Float']['output'];
  failureRateDelta: Scalars['Float']['output'];
  failureRateTarget: Scalars['Float']['output'];
  failureRateThreshold: Scalars['Float']['output'];
  overdueAvgDays: Scalars['Float']['output'];
  overdueCount: Scalars['Int']['output'];
  overdueDelta: Scalars['Float']['output'];
  overdueTarget: Scalars['Int']['output'];
  overdueThreshold: Scalars['Int']['output'];
  overdueTrendByMonth: Array<OverdueTrendPoint>;
  previousFailureRate: Scalars['Float']['output'];
  previousOverdueCount: Scalars['Int']['output'];
};

export type Rules = {
  __typename?: 'Rules';
  definition?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Float']['output']>;
  ruleCategory?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['Float']['output']>;
  ruleType?: Maybe<Scalars['String']['output']>;
  ruleTypeId?: Maybe<Scalars['Float']['output']>;
  stopRule?: Maybe<Scalars['Boolean']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type Sr1Request = {
  busArea?: InputMaybe<Array<Scalars['String']['input']>>;
  compCode?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  invoicee?: InputMaybe<Array<Scalars['String']['input']>>;
  itemNumber?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  materialName?: InputMaybe<Scalars['String']['input']>;
  materialNumber?: InputMaybe<Scalars['String']['input']>;
  partnerNo?: InputMaybe<Array<Scalars['String']['input']>>;
  plant?: InputMaybe<Array<Scalars['String']['input']>>;
  plantCode?: InputMaybe<Array<Scalars['String']['input']>>;
  poDateFrom?: InputMaybe<Scalars['String']['input']>;
  poDateUntil?: InputMaybe<Scalars['String']['input']>;
  purchaseEmail?: InputMaybe<Scalars['String']['input']>;
  purchaseName?: InputMaybe<Scalars['String']['input']>;
  purchaseorderNo?: InputMaybe<OpValue>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  settleType?: InputMaybe<Array<Scalars['String']['input']>>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type Sr1Response = {
  __typename?: 'SR1Response';
  busarea?: Maybe<Scalars['String']['output']>;
  busareaname?: Maybe<Scalars['String']['output']>;
  compname?: Maybe<Scalars['String']['output']>;
  contactpoemail?: Maybe<Scalars['String']['output']>;
  contactponame?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoicee?: Maybe<Scalars['String']['output']>;
  invstattxt?: Maybe<Scalars['String']['output']>;
  itemname?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  maxrows?: Maybe<Scalars['String']['output']>;
  partnerlf?: Maybe<Scalars['String']['output']>;
  partnerlfname?: Maybe<Scalars['String']['output']>;
  plant?: Maybe<Scalars['String']['output']>;
  pmnttrms?: Maybe<Scalars['String']['output']>;
  podate?: Maybe<Scalars['String']['output']>;
  podlvstattxt?: Maybe<Scalars['String']['output']>;
  ponumber?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<PurchaseOderLineItem>>;
  potype?: Maybe<Scalars['String']['output']>;
  pounit?: Maybe<Scalars['String']['output']>;
  povalue?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  settletype?: Maybe<Scalars['String']['output']>;
  settletypetxt?: Maybe<Scalars['String']['output']>;
  termsdelivery?: Maybe<Scalars['String']['output']>;
};

export type Sr2GoodsReceiptLineItem = {
  __typename?: 'SR2GoodsReceiptLineItem';
  grqty?: Maybe<Scalars['String']['output']>;
  grscitem?: Maybe<Scalars['String']['output']>;
  grunit?: Maybe<Scalars['String']['output']>;
  headId?: Maybe<Scalars['String']['output']>;
  material?: Maybe<Scalars['String']['output']>;
  materialtext?: Maybe<Scalars['String']['output']>;
};

export type Sr2Request = {
  bmwdocno?: InputMaybe<OpValue>;
  busarea?: InputMaybe<Array<Scalars['String']['input']>>;
  compcode?: InputMaybe<Array<Scalars['String']['input']>>;
  deliverydateFrom?: InputMaybe<Scalars['String']['input']>;
  deliverydateUntil?: InputMaybe<Scalars['String']['input']>;
  deliverynotedateFrom?: InputMaybe<Scalars['String']['input']>;
  deliverynotedateUntil?: InputMaybe<Scalars['String']['input']>;
  deliverynoteno?: InputMaybe<OpValue>;
  docdateFrom?: InputMaybe<Scalars['String']['input']>;
  docdateUntil?: InputMaybe<Scalars['String']['input']>;
  grscdateFrom?: InputMaybe<Scalars['String']['input']>;
  grscdateUntil?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  materialdocumentno?: InputMaybe<OpValue>;
  overduestatus?: InputMaybe<Array<Scalars['String']['input']>>;
  partnerinvno?: InputMaybe<OpValue>;
  partnerno?: InputMaybe<Array<Scalars['String']['input']>>;
  plantcode?: InputMaybe<Array<Scalars['String']['input']>>;
  postingdateFrom?: InputMaybe<Scalars['String']['input']>;
  postingdateUntil?: InputMaybe<Scalars['String']['input']>;
  procurement?: InputMaybe<Array<Scalars['String']['input']>>;
  purchaseorderdateFrom?: InputMaybe<Scalars['String']['input']>;
  purchaseorderdateUntil?: InputMaybe<Scalars['String']['input']>;
  purchaseorderno?: InputMaybe<OpValue>;
  settletype?: InputMaybe<Array<Scalars['String']['input']>>;
  spaborderno?: InputMaybe<OpValue>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Sr2Response = {
  __typename?: 'SR2Response';
  bmwDocNumber?: Maybe<Scalars['String']['output']>;
  bmwdocno?: Maybe<Scalars['String']['output']>;
  businessAreaCode?: Maybe<Scalars['String']['output']>;
  businessAreaName?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliveryNoteDate?: Maybe<Scalars['String']['output']>;
  deliveryNoteNumber?: Maybe<Scalars['String']['output']>;
  deliverypostdate?: Maybe<Scalars['String']['output']>;
  docdate?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  documentdate?: Maybe<Scalars['String']['output']>;
  extinvoice?: Maybe<Scalars['String']['output']>;
  gjahr?: Maybe<Scalars['String']['output']>;
  grScDate?: Maybe<Scalars['String']['output']>;
  grValue?: Maybe<Scalars['Float']['output']>;
  grnumber?: Maybe<Scalars['String']['output']>;
  grstatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoiceDate?: Maybe<Scalars['String']['output']>;
  invoicePostDate?: Maybe<Scalars['String']['output']>;
  invoiceVerificationContactEmail?: Maybe<Scalars['String']['output']>;
  ivContactEmail?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  materialDescription?: Maybe<Scalars['String']['output']>;
  materialDocNumber?: Maybe<Scalars['String']['output']>;
  materialNumber?: Maybe<Scalars['String']['output']>;
  materialText?: Maybe<Scalars['String']['output']>;
  maxrows?: Maybe<Scalars['String']['output']>;
  netamount?: Maybe<Scalars['String']['output']>;
  overduestatus?: Maybe<Scalars['String']['output']>;
  partnerInvoiceNumber?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  plantCode?: Maybe<Scalars['String']['output']>;
  plantName?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Sr2GoodsReceiptLineItem>>;
  procurement?: Maybe<Scalars['String']['output']>;
  purchaseOrderItem?: Maybe<Scalars['String']['output']>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  purchaseorderdate?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  recipientTel?: Maybe<Scalars['String']['output']>;
  settlementType?: Maybe<Scalars['String']['output']>;
  spabNumber?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  xblnrAlt?: Maybe<Scalars['String']['output']>;
};

export type Sr4LineItem = {
  __typename?: 'SR4LineItem';
  bmwdocno?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliverynoteno?: Maybe<Scalars['String']['output']>;
  documentdate?: Maybe<Scalars['String']['output']>;
  extinvoice?: Maybe<Scalars['String']['output']>;
  headId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  invoiceamount?: Maybe<Scalars['Float']['output']>;
  settlementtype?: Maybe<Scalars['String']['output']>;
  spaborderno?: Maybe<Scalars['String']['output']>;
};

export type Sr4Request = {
  bmwdocno?: InputMaybe<OpValue>;
  compcode?: InputMaybe<Array<Scalars['String']['input']>>;
  doccurrency?: InputMaybe<Array<Scalars['String']['input']>>;
  documentdateFrom?: InputMaybe<Scalars['String']['input']>;
  documentdateUntil?: InputMaybe<Scalars['String']['input']>;
  extinvoice?: InputMaybe<OpValue>;
  language?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Array<Scalars['String']['input']>>;
  paymadviceno?: InputMaybe<OpValue>;
  paymdateFrom?: InputMaybe<Scalars['String']['input']>;
  paymdateUntil?: InputMaybe<Scalars['String']['input']>;
  settlementtype?: InputMaybe<Array<Scalars['String']['input']>>;
  spaborderno?: InputMaybe<OpValue>;
  totpaymamnt?: InputMaybe<OpValue>;
};

export type Sr4Response = {
  __typename?: 'SR4Response';
  bankaccount?: Maybe<Scalars['String']['output']>;
  bankcode?: Maybe<Scalars['String']['output']>;
  bmwdocno?: Maybe<Scalars['String']['output']>;
  compcode?: Maybe<Scalars['String']['output']>;
  contactap?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deliverynoteno?: Maybe<Scalars['String']['output']>;
  documentdate?: Maybe<Scalars['String']['output']>;
  extinvoice?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  maxrows?: Maybe<Scalars['Float']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  paymadviceno?: Maybe<Scalars['String']['output']>;
  paymdate?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Sr4LineItem>>;
  swift?: Maybe<Scalars['String']['output']>;
  totpaymamnt?: Maybe<Scalars['Float']['output']>;
};

export type Sr5LineItem = {
  __typename?: 'SR5LineItem';
  amtdoccur?: Maybe<Scalars['Float']['output']>;
  blinedate?: Maybe<Scalars['String']['output']>;
  busarea?: Maybe<Scalars['String']['output']>;
  cleardate?: Maybe<Scalars['String']['output']>;
  clrdocno?: Maybe<Scalars['String']['output']>;
  compcode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  docdate?: Maybe<Scalars['String']['output']>;
  docno?: Maybe<Scalars['String']['output']>;
  doctype?: Maybe<Scalars['String']['output']>;
  duedate?: Maybe<Scalars['String']['output']>;
  dunnlevel?: Maybe<Scalars['String']['output']>;
  headId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  pmntblock?: Maybe<Scalars['String']['output']>;
  pmnttrms?: Maybe<Scalars['String']['output']>;
  pstngdate?: Maybe<Scalars['String']['output']>;
  refdocno?: Maybe<Scalars['String']['output']>;
};

export type Sr5Request = {
  compcode?: InputMaybe<Array<Scalars['String']['input']>>;
  doccurrency?: InputMaybe<Array<Scalars['String']['input']>>;
  keydate?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  partnerno?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Sr5Response = {
  __typename?: 'SR5Response';
  compcode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  keydate?: Maybe<Scalars['String']['output']>;
  logsys?: Maybe<Scalars['String']['output']>;
  maxrows?: Maybe<Scalars['Float']['output']>;
  partnerno?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<Sr5LineItem>>;
  totbalance?: Maybe<Scalars['Float']['output']>;
};

export type SapSystemUpdate = {
  __typename?: 'SapSystemUpdate';
  description: Scalars['String']['output'];
  reportName: Scalars['String']['output'];
  systemStatusList: Array<SystemStatus>;
};

export type SapSystemUpdateInput = {
  description: Scalars['String']['input'];
  reportName: Scalars['String']['input'];
  systemStatusList: Array<SystemStatusInput>;
};

export type SelectDropdowns = {
  __typename?: 'SelectDropdowns';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SelectNotificationEntitlementsDropdownResponse = {
  __typename?: 'SelectNotificationEntitlementsDropdownResponse';
  description?: Maybe<Scalars['String']['output']>;
  entitlement?: Maybe<Scalars['String']['output']>;
};

export type SelectNotificationTemplateNameDropdownResponse = {
  __typename?: 'SelectNotificationTemplateNameDropdownResponse';
  messageTemplateId: Scalars['ID']['output'];
  templateName: Scalars['String']['output'];
};

export type SelectNotificationTemplateTextResponse = {
  __typename?: 'SelectNotificationTemplateTextResponse';
  templateTextDe: Scalars['String']['output'];
  templateTextEn: Scalars['String']['output'];
};

export type SendUploadedDocumentsToFavorCockpitInput = {
  borderoDate?: InputMaybe<Scalars['String']['input']>;
  borderoNumber?: InputMaybe<Scalars['String']['input']>;
  borderoPositionNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  invoiceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SetUserPreferences = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  decimalSeparator?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  thousandSeparator?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
  userSettingsId?: InputMaybe<Scalars['Float']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingInformation = {
  __typename?: 'ShippingInformation';
  ecDocumentShippingInfoId?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  shipFromCity?: Maybe<Scalars['String']['output']>;
  shipFromContact?: Maybe<Scalars['String']['output']>;
  shipFromCountry?: Maybe<Scalars['String']['output']>;
  shipFromCountryCode?: Maybe<Scalars['String']['output']>;
  shipFromCountryPhraseId?: Maybe<Scalars['String']['output']>;
  shipFromDepartment?: Maybe<Scalars['String']['output']>;
  shipFromName?: Maybe<Scalars['String']['output']>;
  shipFromPostalCode?: Maybe<Scalars['String']['output']>;
  shipFromRegion?: Maybe<Scalars['String']['output']>;
  shipFromRegionCode?: Maybe<Scalars['String']['output']>;
  shipFromRegionPhraseId?: Maybe<Scalars['String']['output']>;
  shipFromStreet?: Maybe<Scalars['String']['output']>;
  shipToCity?: Maybe<Scalars['String']['output']>;
  shipToContact?: Maybe<Scalars['String']['output']>;
  shipToCountry?: Maybe<Scalars['String']['output']>;
  shipToCountryCode?: Maybe<Scalars['String']['output']>;
  shipToCountryPhraseId?: Maybe<Scalars['String']['output']>;
  shipToDepartment?: Maybe<Scalars['String']['output']>;
  shipToName?: Maybe<Scalars['String']['output']>;
  shipToPostalCode?: Maybe<Scalars['String']['output']>;
  shipToRegion?: Maybe<Scalars['String']['output']>;
  shipToRegionCode?: Maybe<Scalars['String']['output']>;
  shipToRegionPhraseId?: Maybe<Scalars['String']['output']>;
  shipToStreet?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type ShippingInformationInput = {
  ecDocumentShippingInfoId?: InputMaybe<Scalars['Float']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  shipFromCity?: InputMaybe<Scalars['String']['input']>;
  shipFromContact?: InputMaybe<Scalars['String']['input']>;
  shipFromCountry?: InputMaybe<Scalars['String']['input']>;
  shipFromCountryCode?: InputMaybe<Scalars['String']['input']>;
  shipFromDepartment?: InputMaybe<Scalars['String']['input']>;
  shipFromName?: InputMaybe<Scalars['String']['input']>;
  shipFromPostalCode?: InputMaybe<Scalars['String']['input']>;
  shipFromRegion?: InputMaybe<Scalars['String']['input']>;
  shipFromRegionCode?: InputMaybe<Scalars['String']['input']>;
  shipFromStreet?: InputMaybe<Scalars['String']['input']>;
  shipToCity?: InputMaybe<Scalars['String']['input']>;
  shipToContact?: InputMaybe<Scalars['String']['input']>;
  shipToCountry?: InputMaybe<Scalars['String']['input']>;
  shipToCountryCode?: InputMaybe<Scalars['String']['input']>;
  shipToDepartment?: InputMaybe<Scalars['String']['input']>;
  shipToName?: InputMaybe<Scalars['String']['input']>;
  shipToPostalCode?: InputMaybe<Scalars['String']['input']>;
  shipToRegion?: InputMaybe<Scalars['String']['input']>;
  shipToRegionCode?: InputMaybe<Scalars['String']['input']>;
  shipToStreet?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
};

export type SortModel = {
  colId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierDetails = {
  __typename?: 'SupplierDetails';
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankBranchCode?: Maybe<Scalars['String']['output']>;
  bankIban?: Maybe<Scalars['String']['output']>;
  bankSwiftBicNumber?: Maybe<Scalars['String']['output']>;
  chairmanOfSupervisoryBoard?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  companyRegistryData?: Maybe<Scalars['String']['output']>;
  companyVatCode?: Maybe<Scalars['String']['output']>;
  companyVatCountryCode?: Maybe<Scalars['String']['output']>;
  contactDepartment?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactTelephone?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  documentPartnerProfileId?: Maybe<Scalars['Float']['output']>;
  fiscalRepresentativeAddressCity?: Maybe<Scalars['String']['output']>;
  fiscalRepresentativeAddressCountry?: Maybe<Scalars['String']['output']>;
  fiscalRepresentativeAddressCountryCode?: Maybe<Scalars['String']['output']>;
  fiscalRepresentativeAddressCountryPhraseId?: Maybe<Scalars['String']['output']>;
  fiscalRepresentativeAddressPostalCode?: Maybe<Scalars['String']['output']>;
  fiscalRepresentativeAddressRegion?: Maybe<Scalars['String']['output']>;
  fiscalRepresentativeAddressRegionCode?: Maybe<Scalars['String']['output']>;
  fiscalRepresentativeAddressRegionPhraseId?: Maybe<Scalars['String']['output']>;
  fiscalRepresentativeAddressStreet?: Maybe<Scalars['String']['output']>;
  fiscalRepresentativeName?: Maybe<Scalars['String']['output']>;
  fiscalRepresentativeVatId?: Maybe<Scalars['String']['output']>;
  hasFiscalRepresentative?: Maybe<Scalars['Boolean']['output']>;
  inLiquidation?: Maybe<Scalars['Boolean']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  legalFormType?: Maybe<Scalars['String']['output']>;
  legalFormTypeId?: Maybe<Scalars['Float']['output']>;
  liquidationRemark?: Maybe<Scalars['String']['output']>;
  managingDirector?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerTaxId?: Maybe<Scalars['String']['output']>;
  partnerVatCode?: Maybe<Scalars['String']['output']>;
  partnerVatCountryCode?: Maybe<Scalars['String']['output']>;
  placeOfRegistration?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type SupplierDetailsInput = {
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankBranchCode?: InputMaybe<Scalars['String']['input']>;
  bankIban?: InputMaybe<Scalars['String']['input']>;
  bankSwiftBicNumber?: InputMaybe<Scalars['String']['input']>;
  chairmanOfSupervisoryBoard?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyCode?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  companyRegistryData?: InputMaybe<Scalars['String']['input']>;
  companyVatCode?: InputMaybe<Scalars['String']['input']>;
  companyVatCountryCode?: InputMaybe<Scalars['String']['input']>;
  contactDepartment?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactTelephone?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  documentPartnerProfileId?: InputMaybe<Scalars['Float']['input']>;
  fiscalRepresentativeAddressCity?: InputMaybe<Scalars['String']['input']>;
  fiscalRepresentativeAddressCountry?: InputMaybe<Scalars['String']['input']>;
  fiscalRepresentativeAddressCountryCode?: InputMaybe<Scalars['String']['input']>;
  fiscalRepresentativeAddressPostalCode?: InputMaybe<Scalars['String']['input']>;
  fiscalRepresentativeAddressRegion?: InputMaybe<Scalars['String']['input']>;
  fiscalRepresentativeAddressRegionCode?: InputMaybe<Scalars['String']['input']>;
  fiscalRepresentativeAddressStreet?: InputMaybe<Scalars['String']['input']>;
  fiscalRepresentativeName?: InputMaybe<Scalars['String']['input']>;
  fiscalRepresentativeVatId?: InputMaybe<Scalars['String']['input']>;
  hasFiscalRepresentative?: InputMaybe<Scalars['Boolean']['input']>;
  inLiquidation?: InputMaybe<Scalars['Boolean']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  legalFormTypeId?: InputMaybe<Scalars['Float']['input']>;
  liquidationRemark?: InputMaybe<Scalars['String']['input']>;
  managingDirector?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  partnerNo?: InputMaybe<Scalars['String']['input']>;
  partnerTaxId?: InputMaybe<Scalars['String']['input']>;
  partnerVatCode?: InputMaybe<Scalars['String']['input']>;
  partnerVatCountryCode?: InputMaybe<Scalars['String']['input']>;
  placeOfRegistration?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  systemCode?: InputMaybe<Scalars['String']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
};

export type SupportingDocumentResponse = {
  __typename?: 'SupportingDocumentResponse';
  attachmentId?: Maybe<Scalars['Float']['output']>;
  attachmentType?: Maybe<Scalars['String']['output']>;
  blobId?: Maybe<Scalars['Float']['output']>;
  blobPath?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  sizeInKB?: Maybe<Scalars['Float']['output']>;
};

export type SurveyAgreementApprovalData = {
  __typename?: 'SurveyAgreementApprovalData';
  agreementApproverEmail?: Maybe<Scalars['String']['output']>;
  agreementApproverName?: Maybe<Scalars['String']['output']>;
  agreementStatusDate?: Maybe<Scalars['String']['output']>;
  agreementStatusId?: Maybe<Scalars['Float']['output']>;
};

export type SurveyAgreementConnectivityAs2 = {
  as2CertAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  as2CertAvailableComment?: InputMaybe<Scalars['String']['input']>;
  as2EDIqualifier?: InputMaybe<Scalars['String']['input']>;
  as2EDIqualifierComment?: InputMaybe<Scalars['String']['input']>;
  as2EncryptionAlgorithm?: InputMaybe<Scalars['String']['input']>;
  as2EncryptionAlgorithmComment?: InputMaybe<Scalars['String']['input']>;
  as2Environment?: InputMaybe<Scalars['String']['input']>;
  as2Id?: InputMaybe<Scalars['String']['input']>;
  as2IdComment?: InputMaybe<Scalars['String']['input']>;
  as2MDNSigningAlgorithm?: InputMaybe<Scalars['String']['input']>;
  as2MDNSigningAlgorithmComment?: InputMaybe<Scalars['String']['input']>;
  as2MdnUrl?: InputMaybe<Scalars['String']['input']>;
  as2MdnUrlComment?: InputMaybe<Scalars['String']['input']>;
  as2MessageFormatType?: InputMaybe<Scalars['String']['input']>;
  as2MessageFormatTypeComment?: InputMaybe<Scalars['String']['input']>;
  as2MessageToBeExchanged?: InputMaybe<Scalars['String']['input']>;
  as2MessageToBeExchangedComment?: InputMaybe<Scalars['String']['input']>;
  as2ReceiptCapability?: InputMaybe<Scalars['String']['input']>;
  as2ReceiptCapabilityComment?: InputMaybe<Scalars['String']['input']>;
  as2Server?: InputMaybe<Scalars['String']['input']>;
  as2ServerComment?: InputMaybe<Scalars['String']['input']>;
  as2ServerPort?: InputMaybe<Scalars['Float']['input']>;
  as2ServerPortComment?: InputMaybe<Scalars['String']['input']>;
  as2SigningAlgorithm?: InputMaybe<Scalars['String']['input']>;
  as2SigningAlgorithmComment?: InputMaybe<Scalars['String']['input']>;
  as2SigningCapability?: InputMaybe<Scalars['String']['input']>;
  as2SigningCapabilityComment?: InputMaybe<Scalars['String']['input']>;
  as2Software?: InputMaybe<Scalars['String']['input']>;
  as2SoftwareComment?: InputMaybe<Scalars['String']['input']>;
  as2SoftwareVersion?: InputMaybe<Scalars['String']['input']>;
  as2SoftwareVersionComment?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyAgreementConnectivityAs2Response = {
  __typename?: 'SurveyAgreementConnectivityAs2Response';
  as2CertAvailable?: Maybe<Scalars['Boolean']['output']>;
  as2CertAvailableComment?: Maybe<Scalars['String']['output']>;
  as2EDIqualifier?: Maybe<Scalars['String']['output']>;
  as2EDIqualifierComment?: Maybe<Scalars['String']['output']>;
  as2EncryptionAlgorithm?: Maybe<Scalars['String']['output']>;
  as2EncryptionAlgorithmComment?: Maybe<Scalars['String']['output']>;
  as2Environment?: Maybe<Scalars['String']['output']>;
  as2Id?: Maybe<Scalars['String']['output']>;
  as2IdComment?: Maybe<Scalars['String']['output']>;
  as2MDNSigningAlgorithm?: Maybe<Scalars['String']['output']>;
  as2MDNSigningAlgorithmComment?: Maybe<Scalars['String']['output']>;
  as2MdnUrl?: Maybe<Scalars['String']['output']>;
  as2MdnUrlComment?: Maybe<Scalars['String']['output']>;
  as2MessageFormatType?: Maybe<Scalars['String']['output']>;
  as2MessageFormatTypeComment?: Maybe<Scalars['String']['output']>;
  as2MessageToBeExchanged?: Maybe<Scalars['String']['output']>;
  as2MessageToBeExchangedComment?: Maybe<Scalars['String']['output']>;
  as2ReceiptCapability?: Maybe<Scalars['String']['output']>;
  as2ReceiptCapabilityComment?: Maybe<Scalars['String']['output']>;
  as2Server?: Maybe<Scalars['String']['output']>;
  as2ServerComment?: Maybe<Scalars['String']['output']>;
  as2ServerPort?: Maybe<Scalars['Float']['output']>;
  as2ServerPortComment?: Maybe<Scalars['String']['output']>;
  as2SigningAlgorithm?: Maybe<Scalars['String']['output']>;
  as2SigningAlgorithmComment?: Maybe<Scalars['String']['output']>;
  as2SigningCapability?: Maybe<Scalars['String']['output']>;
  as2SigningCapabilityComment?: Maybe<Scalars['String']['output']>;
  as2Software?: Maybe<Scalars['String']['output']>;
  as2SoftwareComment?: Maybe<Scalars['String']['output']>;
  as2SoftwareVersion?: Maybe<Scalars['String']['output']>;
  as2SoftwareVersionComment?: Maybe<Scalars['String']['output']>;
};

export type SurveyAgreementDocList = {
  __typename?: 'SurveyAgreementDocList';
  agreementDescription?: Maybe<Scalars['String']['output']>;
  agreementId?: Maybe<Scalars['Float']['output']>;
  agreementName?: Maybe<Scalars['String']['output']>;
  agreementTypeId?: Maybe<Scalars['Float']['output']>;
  blobId?: Maybe<Scalars['Float']['output']>;
  languageCode?: Maybe<Scalars['String']['output']>;
};

export type SurveyAgreementInput = {
  agreementApproverEmail?: InputMaybe<Scalars['String']['input']>;
  agreementApproverName?: InputMaybe<Scalars['String']['input']>;
  agreementStatusDate?: InputMaybe<Scalars['String']['input']>;
  agreementStatusId?: InputMaybe<Scalars['Float']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyAgreementStatusList = {
  __typename?: 'SurveyAgreementStatusList';
  agreementStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
};

export type SurveyChannelInput = {
  acceptedDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  channelDefault?: InputMaybe<Scalars['Boolean']['input']>;
  channelTypeId?: InputMaybe<Scalars['Float']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  documentTypeId?: InputMaybe<Scalars['Float']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  formatId?: InputMaybe<Scalars['Float']['input']>;
  processCode?: InputMaybe<Scalars['String']['input']>;
  processCodeId?: InputMaybe<Scalars['Float']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  routeChannelId?: InputMaybe<Scalars['String']['input']>;
  routeFormatId?: InputMaybe<Scalars['String']['input']>;
  surveyChannelId?: InputMaybe<Scalars['Float']['input']>;
  surveyId?: InputMaybe<Scalars['Float']['input']>;
};

export type SurveyChannelResponse = {
  __typename?: 'SurveyChannelResponse';
  acceptedDate?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  channelDefault?: Maybe<Scalars['Boolean']['output']>;
  channelTypeId?: Maybe<Scalars['Float']['output']>;
  defaultChannel?: Maybe<Scalars['String']['output']>;
  defaultFormat?: Maybe<Scalars['String']['output']>;
  documentFormatPhraseId?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  documentTypeId?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  formatId?: Maybe<Scalars['Float']['output']>;
  formatOptions?: Maybe<Array<Scalars['String']['output']>>;
  processCode?: Maybe<Scalars['String']['output']>;
  processCodeId?: Maybe<Scalars['Float']['output']>;
  processCodeName?: Maybe<Scalars['String']['output']>;
  processCodePhraseId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  surveyChannelId?: Maybe<Scalars['Float']['output']>;
  surveyId?: Maybe<Scalars['Float']['output']>;
};

export type SurveyConnectivityOftp2Input = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  certificateAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  certificateAvailableComment?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  fileExchangeMode?: InputMaybe<Scalars['String']['input']>;
  fileExchangeModeComment?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  partnerPullAdvancedCompression?: InputMaybe<Scalars['Boolean']['input']>;
  partnerPullAdvancedCompressionComment?: InputMaybe<Scalars['String']['input']>;
  partnerPullDataFormat?: InputMaybe<Scalars['String']['input']>;
  partnerPullDataFormatComment?: InputMaybe<Scalars['String']['input']>;
  partnerPullEERP?: InputMaybe<Scalars['Boolean']['input']>;
  partnerPullEERPComment?: InputMaybe<Scalars['String']['input']>;
  partnerPullEnryptOrSign?: InputMaybe<Scalars['String']['input']>;
  partnerPullEnryptOrSignComment?: InputMaybe<Scalars['String']['input']>;
  partnerPullEnryptionAlgorithm?: InputMaybe<Scalars['String']['input']>;
  partnerPullEnryptionAlgorithmComment?: InputMaybe<Scalars['String']['input']>;
  partnerPullFixedLength?: InputMaybe<Scalars['Float']['input']>;
  partnerPullFixedLengthComment?: InputMaybe<Scalars['String']['input']>;
  partnerPullSFIDDSNVFN?: InputMaybe<Scalars['String']['input']>;
  partnerPullSFIDDSNVFNComment?: InputMaybe<Scalars['String']['input']>;
  partnerPushDataEncoding?: InputMaybe<Scalars['String']['input']>;
  partnerPushDataEncodingComment?: InputMaybe<Scalars['String']['input']>;
  partnerPushFileTypes?: InputMaybe<Scalars['String']['input']>;
  partnerPushFileTypesComment?: InputMaybe<Scalars['String']['input']>;
  partnerPushNonEDIAPRF?: InputMaybe<Scalars['String']['input']>;
  partnerPushNonEDIAPRFComment?: InputMaybe<Scalars['String']['input']>;
  partnerPushNonEDIOriginator?: InputMaybe<Scalars['String']['input']>;
  partnerPushNonEDIOriginatorComment?: InputMaybe<Scalars['String']['input']>;
  partnerPushNonEDIRecipient?: InputMaybe<Scalars['String']['input']>;
  partnerPushNonEDIRecipientComment?: InputMaybe<Scalars['String']['input']>;
  partnerPushVFN?: InputMaybe<Scalars['String']['input']>;
  partnerPushVFNComment?: InputMaybe<Scalars['String']['input']>;
  passwordAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  passwordAvailableComment?: InputMaybe<Scalars['String']['input']>;
  providerPullEnrypted?: InputMaybe<Scalars['Boolean']['input']>;
  providerPullEnryptedComment?: InputMaybe<Scalars['String']['input']>;
  providerPullFrequency?: InputMaybe<Scalars['String']['input']>;
  providerPullFrequencyComment?: InputMaybe<Scalars['String']['input']>;
  providerPullSigning?: InputMaybe<Scalars['String']['input']>;
  providerPullSigningComment?: InputMaybe<Scalars['String']['input']>;
  providerPushAdvancedCompression?: InputMaybe<Scalars['Boolean']['input']>;
  providerPushAdvancedCompressionComment?: InputMaybe<Scalars['String']['input']>;
  providerPushDataEncoding?: InputMaybe<Scalars['String']['input']>;
  providerPushDataEncodingComments?: InputMaybe<Scalars['String']['input']>;
  providerPushDataFormat?: InputMaybe<Scalars['String']['input']>;
  providerPushDataFormatComment?: InputMaybe<Scalars['String']['input']>;
  providerPushEERP?: InputMaybe<Scalars['Boolean']['input']>;
  providerPushEERPComment?: InputMaybe<Scalars['String']['input']>;
  providerPushEnryptOrSign?: InputMaybe<Scalars['String']['input']>;
  providerPushEnryptOrSignComment?: InputMaybe<Scalars['String']['input']>;
  providerPushEnryptionAlgorithm?: InputMaybe<Scalars['String']['input']>;
  providerPushEnryptionAlgorithmComment?: InputMaybe<Scalars['String']['input']>;
  providerPushFixedLength?: InputMaybe<Scalars['Float']['input']>;
  providerPushFixedLengthComment?: InputMaybe<Scalars['String']['input']>;
  providerPushSFIDDSNVFN?: InputMaybe<Scalars['String']['input']>;
  providerPushSFIDDSNVFNComment?: InputMaybe<Scalars['String']['input']>;
  providerPushSFIDDestination?: InputMaybe<Scalars['String']['input']>;
  providerPushSFIDDestinationComment?: InputMaybe<Scalars['String']['input']>;
  providerPushSigningAlgorithm?: InputMaybe<Scalars['String']['input']>;
  providerPushSigningAlgorithmComment?: InputMaybe<Scalars['String']['input']>;
  sSIDCode?: InputMaybe<Scalars['String']['input']>;
  sSIDCodeComment?: InputMaybe<Scalars['String']['input']>;
  securityPreference?: InputMaybe<Scalars['String']['input']>;
  securityPreferenceComment?: InputMaybe<Scalars['String']['input']>;
  serverAddress?: InputMaybe<Scalars['String']['input']>;
  serverAddressComment?: InputMaybe<Scalars['String']['input']>;
  serverPort?: InputMaybe<Scalars['Float']['input']>;
  serverPortComment?: InputMaybe<Scalars['String']['input']>;
  sfidCode?: InputMaybe<Scalars['String']['input']>;
  sfidCodeComment?: InputMaybe<Scalars['String']['input']>;
  surveyConnectivityId?: InputMaybe<Scalars['Float']['input']>;
  surveyId?: InputMaybe<Scalars['Float']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
  useCryptographicAuthentication?: InputMaybe<Scalars['Boolean']['input']>;
  useCryptographicAuthenticationComment?: InputMaybe<Scalars['String']['input']>;
  useTLS?: InputMaybe<Scalars['Boolean']['input']>;
  useTLSComment?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyConnectivityOftp2Response = {
  __typename?: 'SurveyConnectivityOFTP2Response';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  certificateAvailable?: Maybe<Scalars['Boolean']['output']>;
  certificateAvailableComment?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  fileExchangeMode?: Maybe<Scalars['String']['output']>;
  fileExchangeModeComment?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  partnerPullAdvancedCompression?: Maybe<Scalars['Boolean']['output']>;
  partnerPullAdvancedCompressionComment?: Maybe<Scalars['String']['output']>;
  partnerPullDataFormat?: Maybe<Scalars['String']['output']>;
  partnerPullDataFormatComment?: Maybe<Scalars['String']['output']>;
  partnerPullEERP?: Maybe<Scalars['Boolean']['output']>;
  partnerPullEERPComment?: Maybe<Scalars['String']['output']>;
  partnerPullEnryptOrSign?: Maybe<Scalars['String']['output']>;
  partnerPullEnryptOrSignComment?: Maybe<Scalars['String']['output']>;
  partnerPullEnryptionAlgorithm?: Maybe<Scalars['String']['output']>;
  partnerPullEnryptionAlgorithmComment?: Maybe<Scalars['String']['output']>;
  partnerPullFixedLength?: Maybe<Scalars['Float']['output']>;
  partnerPullFixedLengthComment?: Maybe<Scalars['String']['output']>;
  partnerPullSFIDDSNVFN?: Maybe<Scalars['String']['output']>;
  partnerPullSFIDDSNVFNComment?: Maybe<Scalars['String']['output']>;
  partnerPushDataEncoding?: Maybe<Scalars['String']['output']>;
  partnerPushDataEncodingComment?: Maybe<Scalars['String']['output']>;
  partnerPushFileTypes?: Maybe<Scalars['String']['output']>;
  partnerPushFileTypesComment?: Maybe<Scalars['String']['output']>;
  partnerPushNonEDIAPRF?: Maybe<Scalars['String']['output']>;
  partnerPushNonEDIAPRFComment?: Maybe<Scalars['String']['output']>;
  partnerPushNonEDIOriginator?: Maybe<Scalars['String']['output']>;
  partnerPushNonEDIOriginatorComment?: Maybe<Scalars['String']['output']>;
  partnerPushNonEDIRecipient?: Maybe<Scalars['String']['output']>;
  partnerPushNonEDIRecipientComment?: Maybe<Scalars['String']['output']>;
  partnerPushVFN?: Maybe<Scalars['String']['output']>;
  partnerPushVFNComment?: Maybe<Scalars['String']['output']>;
  passwordAvailable?: Maybe<Scalars['Boolean']['output']>;
  passwordAvailableComment?: Maybe<Scalars['String']['output']>;
  providerPullEnrypted?: Maybe<Scalars['Boolean']['output']>;
  providerPullEnryptedComment?: Maybe<Scalars['String']['output']>;
  providerPullFrequency?: Maybe<Scalars['String']['output']>;
  providerPullFrequencyComment?: Maybe<Scalars['String']['output']>;
  providerPullSigning?: Maybe<Scalars['String']['output']>;
  providerPullSigningComment?: Maybe<Scalars['String']['output']>;
  providerPushAdvancedCompression?: Maybe<Scalars['Boolean']['output']>;
  providerPushAdvancedCompressionComment?: Maybe<Scalars['String']['output']>;
  providerPushDataEncoding?: Maybe<Scalars['String']['output']>;
  providerPushDataEncodingComments?: Maybe<Scalars['String']['output']>;
  providerPushDataFormat?: Maybe<Scalars['String']['output']>;
  providerPushDataFormatComment?: Maybe<Scalars['String']['output']>;
  providerPushEERP?: Maybe<Scalars['Boolean']['output']>;
  providerPushEERPComment?: Maybe<Scalars['String']['output']>;
  providerPushEnryptOrSign?: Maybe<Scalars['String']['output']>;
  providerPushEnryptOrSignComment?: Maybe<Scalars['String']['output']>;
  providerPushEnryptionAlgorithm?: Maybe<Scalars['String']['output']>;
  providerPushEnryptionAlgorithmComment?: Maybe<Scalars['String']['output']>;
  providerPushFixedLength?: Maybe<Scalars['Float']['output']>;
  providerPushFixedLengthComment?: Maybe<Scalars['String']['output']>;
  providerPushSFIDDSNVFN?: Maybe<Scalars['String']['output']>;
  providerPushSFIDDSNVFNComment?: Maybe<Scalars['String']['output']>;
  providerPushSFIDDestination?: Maybe<Scalars['String']['output']>;
  providerPushSFIDDestinationComment?: Maybe<Scalars['String']['output']>;
  providerPushSigningAlgorithm?: Maybe<Scalars['String']['output']>;
  providerPushSigningAlgorithmComment?: Maybe<Scalars['String']['output']>;
  sSIDCode?: Maybe<Scalars['String']['output']>;
  sSIDCodeComment?: Maybe<Scalars['String']['output']>;
  securityPreference?: Maybe<Scalars['String']['output']>;
  securityPreferenceComment?: Maybe<Scalars['String']['output']>;
  serverAddress?: Maybe<Scalars['String']['output']>;
  serverAddressComment?: Maybe<Scalars['String']['output']>;
  serverPort?: Maybe<Scalars['Float']['output']>;
  serverPortComment?: Maybe<Scalars['String']['output']>;
  sfidCode?: Maybe<Scalars['String']['output']>;
  sfidCodeComment?: Maybe<Scalars['String']['output']>;
  surveyConnectivityId?: Maybe<Scalars['Float']['output']>;
  surveyId?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  useCryptographicAuthentication?: Maybe<Scalars['Boolean']['output']>;
  useCryptographicAuthenticationComment?: Maybe<Scalars['String']['output']>;
  useTLS?: Maybe<Scalars['Boolean']['output']>;
  useTLSComment?: Maybe<Scalars['String']['output']>;
};

export type SurveyConnectivityPeppolInput = {
  environment?: InputMaybe<Scalars['String']['input']>;
  receivingPeppolId?: InputMaybe<Scalars['String']['input']>;
  receivingPeppolIdComment?: InputMaybe<Scalars['String']['input']>;
  sendingPeppolId?: InputMaybe<Scalars['String']['input']>;
  sendingPeppolIdComment?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyConnectivityPeppolResponse = {
  __typename?: 'SurveyConnectivityPeppolResponse';
  environment?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  receivingPeppolId?: Maybe<Scalars['String']['output']>;
  receivingPeppolIdComment?: Maybe<Scalars['String']['output']>;
  sendingPeppolId?: Maybe<Scalars['String']['output']>;
  sendingPeppolIdComment?: Maybe<Scalars['String']['output']>;
  surveyConnectivityId?: Maybe<Scalars['Float']['output']>;
  surveyID?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type SurveyConnectivitySmtpInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  dcInvoiceCompanyEmailAddress?: InputMaybe<Scalars['String']['input']>;
  dcInvoiceCompanyEmailAddressComment?: InputMaybe<Scalars['String']['input']>;
  dcPaymentAdviceCompanyEmailAddress?: InputMaybe<Scalars['String']['input']>;
  dcPaymentAdviceCompanyEmailAddressComment?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  partnerInboundAttachmentFilenameRequirements?: InputMaybe<Scalars['String']['input']>;
  partnerInboundAttachmentFilenameRequirementsComment?: InputMaybe<Scalars['String']['input']>;
  partnerInboundEmailBodyText?: InputMaybe<Scalars['String']['input']>;
  partnerInboundEmailBodyTextComment?: InputMaybe<Scalars['String']['input']>;
  partnerInboundMaximumEmailSizeMegaBytes?: InputMaybe<Scalars['Float']['input']>;
  partnerInboundMaximumEmailSizeMegaBytesComment?: InputMaybe<Scalars['String']['input']>;
  partnerInboundMessageCC?: InputMaybe<Scalars['String']['input']>;
  partnerInboundMessageCCComment?: InputMaybe<Scalars['String']['input']>;
  partnerInboundMessageDataFileInEmailBody?: InputMaybe<Scalars['Boolean']['input']>;
  partnerInboundMessageDataFileInEmailBodyComment?: InputMaybe<Scalars['String']['input']>;
  partnerInboundMessageSubject?: InputMaybe<Scalars['String']['input']>;
  partnerInboundMessageSubjectComment?: InputMaybe<Scalars['String']['input']>;
  partnerInboundMessageTo?: InputMaybe<Scalars['String']['input']>;
  partnerInboundMessageToComment?: InputMaybe<Scalars['String']['input']>;
  partnerOutboundMessageDataFileInEmailBody?: InputMaybe<Scalars['Boolean']['input']>;
  partnerOutboundMessageDataFileInEmailBodyComment?: InputMaybe<Scalars['String']['input']>;
  partnerOutboundMessageFrom?: InputMaybe<Scalars['String']['input']>;
  partnerOutboundMessageFromComment?: InputMaybe<Scalars['String']['input']>;
  partnerOutboundMessageSubject?: InputMaybe<Scalars['String']['input']>;
  partnerOutboundMessageSubjectComment?: InputMaybe<Scalars['String']['input']>;
  surveyConnectivityId?: InputMaybe<Scalars['Float']['input']>;
  surveyId?: InputMaybe<Scalars['Float']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyConnectivitySmtpResponse = {
  __typename?: 'SurveyConnectivitySMTPResponse';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  dcInvoiceCompanyEmailAddress?: Maybe<Scalars['String']['output']>;
  dcInvoiceCompanyEmailAddressComment?: Maybe<Scalars['String']['output']>;
  dcPaymentAdviceCompanyEmailAddress?: Maybe<Scalars['String']['output']>;
  dcPaymentAdviceCompanyEmailAddressComment?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  partnerInboundAttachmentFilenameRequirements?: Maybe<Scalars['String']['output']>;
  partnerInboundAttachmentFilenameRequirementsComment?: Maybe<Scalars['String']['output']>;
  partnerInboundEmailBodyText?: Maybe<Scalars['String']['output']>;
  partnerInboundEmailBodyTextComment?: Maybe<Scalars['String']['output']>;
  partnerInboundMaximumEmailSizeMegaBytes?: Maybe<Scalars['Float']['output']>;
  partnerInboundMaximumEmailSizeMegaBytesComment?: Maybe<Scalars['String']['output']>;
  partnerInboundMessageCC?: Maybe<Scalars['String']['output']>;
  partnerInboundMessageCCComment?: Maybe<Scalars['String']['output']>;
  partnerInboundMessageDataFileInEmailBody?: Maybe<Scalars['Boolean']['output']>;
  partnerInboundMessageDataFileInEmailBodyComment?: Maybe<Scalars['String']['output']>;
  partnerInboundMessageSubject?: Maybe<Scalars['String']['output']>;
  partnerInboundMessageSubjectComment?: Maybe<Scalars['String']['output']>;
  partnerInboundMessageTo?: Maybe<Scalars['String']['output']>;
  partnerInboundMessageToComment?: Maybe<Scalars['String']['output']>;
  partnerOutboundMessageDataFileInEmailBody?: Maybe<Scalars['Boolean']['output']>;
  partnerOutboundMessageDataFileInEmailBodyComment?: Maybe<Scalars['String']['output']>;
  partnerOutboundMessageFrom?: Maybe<Scalars['String']['output']>;
  partnerOutboundMessageFromComment?: Maybe<Scalars['String']['output']>;
  partnerOutboundMessageSubject?: Maybe<Scalars['String']['output']>;
  partnerOutboundMessageSubjectComment?: Maybe<Scalars['String']['output']>;
  surveyConnectivityId?: Maybe<Scalars['Float']['output']>;
  surveyId?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type SurveyConnectivityTestFileInput = {
  documentFormatId?: InputMaybe<Scalars['Float']['input']>;
  fileBlobId?: InputMaybe<Scalars['Float']['input']>;
  fileError?: InputMaybe<Scalars['String']['input']>;
  fileStatus?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  processCodeId?: InputMaybe<Scalars['Float']['input']>;
  submittedForValidation?: InputMaybe<Scalars['String']['input']>;
  surveyId?: InputMaybe<Scalars['Float']['input']>;
  testFileId?: InputMaybe<Scalars['Float']['input']>;
  validationPassed?: InputMaybe<Scalars['String']['input']>;
  validationReference?: InputMaybe<Scalars['String']['input']>;
  validationResultBlobId?: InputMaybe<Scalars['Float']['input']>;
  validationStatus?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyConnectivityTestFileReport = {
  __typename?: 'SurveyConnectivityTestFileReport';
  currentVersionNumber?: Maybe<Scalars['String']['output']>;
  documentFormat?: Maybe<Scalars['String']['output']>;
  documentFormatId?: Maybe<Scalars['Float']['output']>;
  fileBlobId?: Maybe<Scalars['Float']['output']>;
  fileError?: Maybe<Scalars['String']['output']>;
  fileStatus?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  processCodeId?: Maybe<Scalars['Float']['output']>;
  processCodeName?: Maybe<Scalars['String']['output']>;
  rowId?: Maybe<Scalars['Float']['output']>;
  subList?: Maybe<Array<SurveyConnectivityTestFileReport>>;
  submittedForValidation?: Maybe<Scalars['String']['output']>;
  surveyId?: Maybe<Scalars['Float']['output']>;
  surveyValidationStatusDescr?: Maybe<Scalars['String']['output']>;
  testFileId?: Maybe<Scalars['Float']['output']>;
  validationPassed?: Maybe<Scalars['String']['output']>;
  validationReference?: Maybe<Scalars['String']['output']>;
  validationResultBlobId?: Maybe<Scalars['Float']['output']>;
  validationStatus?: Maybe<Scalars['String']['output']>;
  validationStatusPhraseId?: Maybe<Scalars['String']['output']>;
  versionNumber?: Maybe<Scalars['String']['output']>;
};

export type SurveyConnectivityVdaiResponse = {
  __typename?: 'SurveyConnectivityVDAIResponse';
  dcInvoiceEdiIdentifier?: Maybe<Scalars['String']['output']>;
  dcInvoiceEdiIdentifierComment?: Maybe<Scalars['String']['output']>;
  dcInvoiceEdiQualifier?: Maybe<Scalars['String']['output']>;
  dcInvoiceEdiQualifierComment?: Maybe<Scalars['String']['output']>;
  dcPadEdiIdentifier?: Maybe<Scalars['String']['output']>;
  dcPadEdiIdentifierComment?: Maybe<Scalars['String']['output']>;
  dcPadEdiQualifier?: Maybe<Scalars['String']['output']>;
  dcPadEdiQualifierComment?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Scalars['String']['output']>;
  surveyConnectivityId?: Maybe<Scalars['Float']['output']>;
  surveyId?: Maybe<Scalars['Float']['output']>;
};

export type SurveyConnectivityVdaInput = {
  dcInvoiceEdiIdentifier?: InputMaybe<Scalars['String']['input']>;
  dcInvoiceEdiIdentifierComment?: InputMaybe<Scalars['String']['input']>;
  dcInvoiceEdiQualifier?: InputMaybe<Scalars['String']['input']>;
  dcInvoiceEdiQualifierComment?: InputMaybe<Scalars['String']['input']>;
  dcPadEdiIdentifier?: InputMaybe<Scalars['String']['input']>;
  dcPadEdiIdentifierComment?: InputMaybe<Scalars['String']['input']>;
  dcPadEdiQualifier?: InputMaybe<Scalars['String']['input']>;
  dcPadEdiQualifierComment?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Scalars['String']['input']>;
  surveyConnectivityId?: InputMaybe<Scalars['Float']['input']>;
  surveyId?: InputMaybe<Scalars['Float']['input']>;
};

export type SurveyContactInput = {
  contactComment?: InputMaybe<Scalars['String']['input']>;
  contactEmailAddres?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  contactLastName?: InputMaybe<Scalars['String']['input']>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  contactTypeId?: InputMaybe<Scalars['Float']['input']>;
  insertTime?: InputMaybe<Scalars['String']['input']>;
  insertUser?: InputMaybe<Scalars['String']['input']>;
  surveyContactId?: InputMaybe<Scalars['Float']['input']>;
  surveyId?: InputMaybe<Scalars['Float']['input']>;
  updateTime?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyContactResponse = {
  __typename?: 'SurveyContactResponse';
  contactComment?: Maybe<Scalars['String']['output']>;
  contactEmailAddres?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  contactTypeId?: Maybe<Scalars['Float']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  surveyContactId?: Maybe<Scalars['Float']['output']>;
  surveyId?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type SurveyCreateRequest = {
  category?: InputMaybe<Scalars['String']['input']>;
  companyCode?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  partnerNo?: InputMaybe<Scalars['String']['input']>;
  surveyId?: InputMaybe<Scalars['Float']['input']>;
  surveyStatusId?: InputMaybe<Scalars['Float']['input']>;
  surveyTypeId?: InputMaybe<Scalars['Float']['input']>;
  systemCode?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyCreateResult = {
  __typename?: 'SurveyCreateResult';
  errorText?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['String']['output']>;
  surveyId?: Maybe<Scalars['Float']['output']>;
};

export type SurveyCriteriaType = {
  companyCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  filterOption?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  partnerNo?: InputMaybe<Scalars['String']['input']>;
  surveyId?: InputMaybe<Scalars['Float']['input']>;
  surveyStatusId?: InputMaybe<Scalars['Float']['input']>;
};

export type SurveyDocumentProcessChannelCodeInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  defaultAlternative?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  processCode?: InputMaybe<Scalars['String']['input']>;
  processCodeId?: InputMaybe<Scalars['Float']['input']>;
  processCodeName?: InputMaybe<Scalars['String']['input']>;
  updatedChannel?: InputMaybe<Scalars['String']['input']>;
  updatedFormat?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyDocumentProcessChannelCodeResponse = {
  __typename?: 'SurveyDocumentProcessChannelCodeResponse';
  channel?: Maybe<Scalars['String']['output']>;
  defaultAlternative?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  processCodeId?: Maybe<Scalars['Float']['output']>;
  processCodeName?: Maybe<Scalars['String']['output']>;
  updatedChannel?: Maybe<Scalars['String']['output']>;
  updatedFormat?: Maybe<Scalars['String']['output']>;
};

export type SurveyDocumentResponse = {
  __typename?: 'SurveyDocumentResponse';
  success?: Maybe<Scalars['String']['output']>;
  value?: Maybe<SurveyDocumentValue>;
};

export type SurveyDocumentValue = {
  __typename?: 'SurveyDocumentValue';
  encodedFileData?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
};

export type SurveyManagementListResponse = {
  __typename?: 'SurveyManagementListResponse';
  agreementTypeId?: Maybe<Scalars['Float']['output']>;
  assignedPartnerUser?: Maybe<Scalars['String']['output']>;
  assignedPartnerUserId?: Maybe<Scalars['Float']['output']>;
  categoryCode?: Maybe<Scalars['String']['output']>;
  categoryDescription?: Maybe<Scalars['String']['output']>;
  categoryPhraseId?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  includedPartnerIds?: Maybe<Scalars['String']['output']>;
  includedSurveyIds?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  masterDataStatusPhraseId?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerVolume?: Maybe<Scalars['Float']['output']>;
  surveyId?: Maybe<Scalars['String']['output']>;
  surveySentDate?: Maybe<Scalars['String']['output']>;
  surveySource?: Maybe<Scalars['String']['output']>;
  surveyStartDate?: Maybe<Scalars['String']['output']>;
  surveyStatus?: Maybe<Scalars['String']['output']>;
  surveyStatusPhraseId?: Maybe<Scalars['String']['output']>;
  surveyVolume?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type SurveyMasterData = {
  __typename?: 'SurveyMasterData';
  partnerRecord?: Maybe<SurveyPartnerData>;
  surveySummaryRecord?: Maybe<SurveySummaryData>;
};

export type SurveyMasterDataType = {
  surveyId?: InputMaybe<Scalars['Float']['input']>;
};

export type SurveyMasterStatusInput = {
  masterDataStatusId?: InputMaybe<Scalars['Float']['input']>;
  surveyId?: InputMaybe<Scalars['Float']['input']>;
};

export type SurveyOverviewFilter = {
  companyCode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  masterPartnerNo?: InputMaybe<Scalars['Boolean']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  partnerNo?: InputMaybe<Scalars['String']['input']>;
  partnerType?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  surveyId?: InputMaybe<Scalars['Float']['input']>;
  surveyIdList?: InputMaybe<Array<Scalars['Float']['input']>>;
  surveyStatus?: InputMaybe<Scalars['String']['input']>;
  surveyStatusId?: InputMaybe<Scalars['Float']['input']>;
  systemCode?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyOverviewList = {
  __typename?: 'SurveyOverviewList';
  agreementType?: Maybe<Scalars['String']['output']>;
  agreementTypeId?: Maybe<Scalars['Float']['output']>;
  assignedPartnerUser?: Maybe<Scalars['String']['output']>;
  assignedPartnerUserId?: Maybe<Scalars['Float']['output']>;
  categoryCode?: Maybe<Scalars['String']['output']>;
  categoryDescription?: Maybe<Scalars['String']['output']>;
  categoryPhraseId?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  includedPartnerIds?: Maybe<Scalars['String']['output']>;
  includedSurveyIds?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  masterDataStatusPhraseId?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerVolume?: Maybe<Scalars['Float']['output']>;
  rowNo?: Maybe<Scalars['Float']['output']>;
  surveyId?: Maybe<Scalars['Float']['output']>;
  surveySentDate?: Maybe<Scalars['String']['output']>;
  surveySource?: Maybe<Scalars['String']['output']>;
  surveyStartDate?: Maybe<Scalars['String']['output']>;
  surveyStatus?: Maybe<Scalars['String']['output']>;
  surveyStatusId?: Maybe<Scalars['Float']['output']>;
  surveyStatusPhraseId?: Maybe<Scalars['String']['output']>;
  surveyVolume?: Maybe<Scalars['Float']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type SurveyPartnerAddressData = {
  __typename?: 'SurveyPartnerAddressData';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  pobox?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  postalcodePobox?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type SurveyPartnerContactsData = {
  __typename?: 'SurveyPartnerContactsData';
  PartnerNo?: Maybe<Scalars['String']['output']>;
  User_Role?: Maybe<Scalars['String']['output']>;
  assignedPartnerUserId?: Maybe<Scalars['Float']['output']>;
  b2bUserHasAccessToPartner?: Maybe<Scalars['Boolean']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  contactUserId?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  hasB2BUser?: Maybe<Scalars['Boolean']['output']>;
  hasEdocUser?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  responsibleUser?: Maybe<Scalars['Boolean']['output']>;
  user_Role?: Maybe<Scalars['String']['output']>;
};

export type SurveyPartnerData = {
  __typename?: 'SurveyPartnerData';
  partnerAddressesList?: Maybe<Array<SurveyPartnerAddressData>>;
  partnerVatCodes?: Maybe<Array<SurveyPartnerVatData>>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type SurveyPartnerVatData = {
  __typename?: 'SurveyPartnerVatData';
  country?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  vatCode?: Maybe<Scalars['String']['output']>;
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  failureCode?: Maybe<Scalars['Float']['output']>;
  failureDescription?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SurveyStatusSelectDropdowns = {
  __typename?: 'SurveyStatusSelectDropdowns';
  id: Scalars['ID']['output'];
  phraseId?: Maybe<Scalars['String']['output']>;
  surveyStatus: Scalars['String']['output'];
};

export type SurveySummaryData = {
  __typename?: 'SurveySummaryData';
  agreementTypeId?: Maybe<Scalars['Float']['output']>;
  assignedPartnerUser?: Maybe<Scalars['String']['output']>;
  assignedPartnerUserId?: Maybe<Scalars['Float']['output']>;
  categoryDescription?: Maybe<Scalars['String']['output']>;
  categoryPhraseId?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  includedPartnerIds?: Maybe<Scalars['String']['output']>;
  includedSurveyIds?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  masterDataAcceptedDate?: Maybe<Scalars['String']['output']>;
  masterDataStatusPhraseId?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  partnerVolume?: Maybe<Scalars['Float']['output']>;
  surveyId?: Maybe<Scalars['Float']['output']>;
  surveySentDate?: Maybe<Scalars['String']['output']>;
  surveyStartDate?: Maybe<Scalars['String']['output']>;
  surveyStatus?: Maybe<Scalars['String']['output']>;
  surveyStatusPhraseId?: Maybe<Scalars['String']['output']>;
  surveyVolume?: Maybe<Scalars['Float']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
};

export type SurveyVerifyOutput = {
  __typename?: 'SurveyVerifyOutput';
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  canSubmit?: Maybe<Scalars['Boolean']['output']>;
  channelTypes?: Maybe<Array<ChannelType>>;
  formatTypes?: Maybe<Array<FormatType>>;
  groupId?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  portions?: Maybe<Array<Portion>>;
  submitReason?: Maybe<Scalars['String']['output']>;
  surveyStatus?: Maybe<Scalars['String']['output']>;
  surveyStatusId?: Maybe<Scalars['Float']['output']>;
  surveyVolume?: Maybe<Scalars['Float']['output']>;
  surveys?: Maybe<Array<Scalars['Float']['output']>>;
};

export type SystemMetricsSummary = {
  __typename?: 'SystemMetricsSummary';
  coverage: CoverageMetricsSummary;
  exceptions: ExceptionMetricsSummary;
  intake: IntakeMetricsSummary;
  processing: ProcessingMetricsSummary;
  systemId?: Maybe<Scalars['Int']['output']>;
  systemLabel: Scalars['String']['output'];
};

export type SystemStatus = {
  __typename?: 'SystemStatus';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  filerResultsRule?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  path: Scalars['String']['output'];
  placeHolderConfigured: Scalars['Boolean']['output'];
  reachable: Scalars['Boolean']['output'];
  secret?: Maybe<Scalars['String']['output']>;
  secretPlaceholder: Scalars['String']['output'];
  systemName: Scalars['String']['output'];
  systemNameFreeText: Scalars['String']['output'];
  url: Scalars['String']['output'];
  userName: Scalars['String']['output'];
  vaultProperty: Scalars['String']['output'];
  vaultPropertyFound: Scalars['Boolean']['output'];
};

export type SystemStatusInput = {
  active: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  filerResultsRule?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  path: Scalars['String']['input'];
  placeHolderConfigured: Scalars['Boolean']['input'];
  reachable: Scalars['Boolean']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
  secretPlaceholder: Scalars['String']['input'];
  systemName: Scalars['String']['input'];
  systemNameFreeText: Scalars['String']['input'];
  url: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  vaultProperty: Scalars['String']['input'];
  vaultPropertyFound: Scalars['Boolean']['input'];
};

export type TfBlobResponse = {
  __typename?: 'TFBlobResponse';
  blobId?: Maybe<Scalars['Float']['output']>;
  downloadLink?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  requiresAuthentication?: Maybe<Scalars['Boolean']['output']>;
  rolesAllowed?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type TLogInfoSummaryData = {
  __typename?: 'TLogInfoSummaryData';
  count?: Maybe<Scalars['Float']['output']>;
  firstOccurrence?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lastOccurrence?: Maybe<Scalars['String']['output']>;
  processError?: Maybe<Scalars['String']['output']>;
};

export type TableColumnMetaData = {
  __typename?: 'TableColumnMetaData';
  IS_NULLABLE: Scalars['Boolean']['output'];
  characterMaximumLength?: Maybe<Scalars['Float']['output']>;
  characterOctetLength?: Maybe<Scalars['Float']['output']>;
  columnDefault?: Maybe<Scalars['String']['output']>;
  columnName: Scalars['String']['output'];
  dataType: Scalars['String']['output'];
  datetimePrecision?: Maybe<Scalars['Float']['output']>;
  numericPrecision?: Maybe<Scalars['Float']['output']>;
  numericPrecisionRadix?: Maybe<Scalars['Float']['output']>;
  numericScale?: Maybe<Scalars['Float']['output']>;
  ordinalPosition: Scalars['Float']['output'];
  rowId: Scalars['Float']['output'];
};

export type TableDataResponse = {
  __typename?: 'TableDataResponse';
  rows: Array<TableRow>;
  tableName: Scalars['String']['output'];
};

export type TableMetaData = {
  __typename?: 'TableMetaData';
  columnNames: Array<TableColumnMetaData>;
  tableName: Scalars['String']['output'];
};

export type TableRow = {
  __typename?: 'TableRow';
  row: TableRowColumns;
};

export type TableRowColumn = {
  __typename?: 'TableRowColumn';
  columnName: Scalars['String']['output'];
  columnValue?: Maybe<Scalars['String']['output']>;
};

export type TableRowColumns = {
  __typename?: 'TableRowColumns';
  columns: Array<TableRowColumn>;
};

export type TaxLawReference = {
  __typename?: 'TaxLawReference';
  id?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  taxLawReference?: Maybe<Scalars['String']['output']>;
  taxTypeCode?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type TemplateList = {
  __typename?: 'TemplateList';
  bmwCompany?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  documentDate?: Maybe<Scalars['String']['output']>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  lastUpdate?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNumber?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  taxAmount?: Maybe<Scalars['Float']['output']>;
  templateId?: Maybe<Scalars['Float']['output']>;
  templateInsertTime?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateUpdateTime?: Maybe<Scalars['String']['output']>;
  tpUser?: Maybe<Scalars['String']['output']>;
};

export type TemplateListInput = {
  bmwCompanyId?: InputMaybe<Scalars['Float']['input']>;
  documentTypeId?: InputMaybe<Scalars['Float']['input']>;
  myTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  partnerId?: InputMaybe<Scalars['Float']['input']>;
  partnerNo?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['Float']['input']>;
};

export type TopFailureCompanySummary = {
  __typename?: 'TopFailureCompanySummary';
  companyCode: Scalars['String']['output'];
  country: Scalars['String']['output'];
  failureRate: Scalars['Float']['output'];
  overdueCount: Scalars['Int']['output'];
  riskRanking: Scalars['Int']['output'];
  volume: Scalars['Int']['output'];
};

export type TopFailureProcessSummary = {
  __typename?: 'TopFailureProcessSummary';
  failedCount: Scalars['Int']['output'];
  failureRate: Scalars['Float']['output'];
  overdueCount: Scalars['Int']['output'];
  process: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type TopImpactedGroup = {
  __typename?: 'TopImpactedGroup';
  failureRate: Scalars['Float']['output'];
  groupName: Scalars['String']['output'];
  overdueCount: Scalars['Int']['output'];
  riskRanking: Scalars['Int']['output'];
  volume: Scalars['Int']['output'];
};

export type TranslationContentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
};

export type TranslationDtoInput = {
  phraseID?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Array<TranslationContentInput>>;
};

export type TranslationResponse = {
  __typename?: 'TranslationResponse';
  languageCode?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
};

export type UnavailableVolume = {
  __typename?: 'UnavailableVolume';
  volume: Scalars['Float']['output'];
};

export type UnitOfMeasure = {
  __typename?: 'UnitOfMeasure';
  decimalPlaces?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  unitOfMeasureAllowDecimal?: Maybe<Scalars['Boolean']['output']>;
  unitOfMeasureDescription?: Maybe<Scalars['String']['output']>;
  unitOfMeasureSymbol?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type UserEntitlementResult = {
  __typename?: 'UserEntitlementResult';
  appliedRuleIds?: Maybe<Array<Scalars['Float']['output']>>;
  distinctEntitlements?: Maybe<Array<Scalars['String']['output']>>;
  partners?: Maybe<Array<EntitlementPartner>>;
};

export type UserGuide = {
  __typename?: 'UserGuide';
  insertDate?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  translations?: Maybe<Array<TranslationResponse>>;
  updateDate?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  userGuideBlobs?: Maybe<Array<UserGuideBlob>>;
  userGuideGroup?: Maybe<UserGuideGroup>;
  userGuideId?: Maybe<Scalars['Int']['output']>;
  userGuideNamePhraseId?: Maybe<Scalars['String']['output']>;
};

export type UserGuideBlob = {
  __typename?: 'UserGuideBlob';
  blob?: Maybe<TfBlobResponse>;
  insertDate?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  userGuideBlobId?: Maybe<Scalars['Int']['output']>;
};

export type UserGuideDetails = {
  __typename?: 'UserGuideDetails';
  language?: Maybe<Scalars['String']['output']>;
  userGuideBlob?: Maybe<Scalars['Float']['output']>;
};

export type UserGuideDocUploadInput = {
  blobFileEncoded: BlobFileInput;
  language: Scalars['String']['input'];
  userGuideId: Scalars['Int']['input'];
};

export type UserGuideDocumentResponse = {
  __typename?: 'UserGuideDocumentResponse';
  success?: Maybe<Scalars['String']['output']>;
  value?: Maybe<UserGuideValue>;
};

export type UserGuideGroup = {
  __typename?: 'UserGuideGroup';
  insertDate?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  translations?: Maybe<Array<TranslationResponse>>;
  updateDate?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  userGuideGroupId?: Maybe<Scalars['Int']['output']>;
  userGuideGroupNamePhraseId?: Maybe<Scalars['String']['output']>;
};

export type UserGuideGroupRequest = {
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  translationRequest?: InputMaybe<TranslationDtoInput>;
  userGuideGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserGuideLanguages = {
  __typename?: 'UserGuideLanguages';
  languages: Array<Scalars['String']['output']>;
};

export type UserGuideRequest = {
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  translationRequest?: InputMaybe<TranslationDtoInput>;
  userGuideGroupId?: InputMaybe<Scalars['Int']['input']>;
  userGuideId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserGuideValue = {
  __typename?: 'UserGuideValue';
  encodedFileData?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
};

export type UserGuidesDocList = {
  __typename?: 'UserGuidesDocList';
  details?: Maybe<Array<UserGuideDetails>>;
  groupName?: Maybe<Scalars['String']['output']>;
  groupSortOrder?: Maybe<Scalars['Float']['output']>;
  sortOrder?: Maybe<Scalars['Float']['output']>;
  userGuideGroupId?: Maybe<Scalars['Float']['output']>;
  userGuideId?: Maybe<Scalars['Float']['output']>;
  userGuideName?: Maybe<Scalars['String']['output']>;
};

export type UserRightsInput = {
  assigned?: InputMaybe<Scalars['Float']['input']>;
  companyCode?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Float']['input']>;
  companyLinkExists?: InputMaybe<Scalars['Float']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPartnerId?: InputMaybe<Scalars['Float']['input']>;
  partnerId?: InputMaybe<Scalars['Float']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  partnerNo?: InputMaybe<Scalars['String']['input']>;
  processCode?: InputMaybe<Scalars['String']['input']>;
  processCodeId?: InputMaybe<Scalars['Float']['input']>;
  processCodeName?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['Float']['input']>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  rowno?: InputMaybe<Scalars['Float']['input']>;
  systemCode?: InputMaybe<Scalars['String']['input']>;
  systemCompanyId?: InputMaybe<Scalars['Float']['input']>;
  systemId?: InputMaybe<Scalars['Float']['input']>;
  systemName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type UserRightsOutput = IUserRights & {
  __typename?: 'UserRightsOutput';
  assigned?: Maybe<Scalars['Float']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companyLinkExists?: Maybe<Scalars['Float']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPartnerId?: Maybe<Scalars['Float']['output']>;
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Float']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerNo?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  processCodeId?: Maybe<Scalars['Float']['output']>;
  processCodeName?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['Float']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
  rowno?: Maybe<Scalars['Float']['output']>;
  systemCode?: Maybe<Scalars['String']['output']>;
  systemCompanyId?: Maybe<Scalars['Float']['output']>;
  systemId?: Maybe<Scalars['Float']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type ValidateUserResponse = {
  __typename?: 'ValidateUserResponse';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorDescription?: Maybe<Scalars['String']['output']>;
  portalUser?: Maybe<PortalUser>;
  success?: Maybe<Scalars['Boolean']['output']>;
  userPreferences?: Maybe<Preferences>;
};

export type VatCodes = {
  __typename?: 'VatCodes';
  company?: Maybe<Company>;
  countryCode?: Maybe<CountryCode>;
  id?: Maybe<Scalars['Float']['output']>;
  insertDate?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  vatCode?: Maybe<Scalars['String']['output']>;
};

export type VolumeSectionMetrics = {
  __typename?: 'VolumeSectionMetrics';
  busnTransitCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  failureRate: Scalars['Float']['output'];
  failureRateTarget: Scalars['Float']['output'];
  failureRateThreshold: Scalars['Float']['output'];
  inTransitCount: Scalars['Int']['output'];
  inboundCount: Scalars['Int']['output'];
  outboundCount: Scalars['Int']['output'];
  previousPeriodTotal: Scalars['Int']['output'];
  totalProcessed: Scalars['Int']['output'];
  volumeDelta: Scalars['Float']['output'];
  volumeTrendByMonth: Array<VolumeTrendPoint>;
};

export type VolumeTrendPoint = {
  __typename?: 'VolumeTrendPoint';
  failed: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  stpRate: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
};

export type WebEamUserInfo = {
  __typename?: 'WebEamUserInfo';
  auth_level?: Maybe<Scalars['String']['output']>;
  departmentnumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  family_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  inumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
  suppliername?: Maybe<Scalars['String']['output']>;
  suppliernumber?: Maybe<Scalars['String']['output']>;
};

export type SelectDocType = {
  __typename?: 'selectDocType';
  documentDescription?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  phraseId?: Maybe<Scalars['String']['output']>;
  serviceProviderId?: Maybe<Scalars['Float']['output']>;
  serviceProviderName?: Maybe<Scalars['String']['output']>;
  updateTime?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type SelectFormat = {
  __typename?: 'selectFormat';
  documentFormat?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertTime?: Maybe<Scalars['String']['output']>;
  insertUser?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
};

export type SelectProcessCode = {
  __typename?: 'selectProcessCode';
  id: Scalars['ID']['output'];
  phraseId?: Maybe<Scalars['String']['output']>;
  processCode?: Maybe<Scalars['String']['output']>;
  processCodeName?: Maybe<Scalars['String']['output']>;
};

export type SelectStatus = {
  __typename?: 'selectStatus';
  documentStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertTime: Scalars['String']['output'];
  isFinalStatus: Scalars['Boolean']['output'];
  phraseId: Scalars['String']['output'];
  updateTime: Scalars['String']['output'];
};
